/* eslint-disable no-unused-vars, react-hooks/exhaustive-deps */
import React, { useState, useEffect, useRef } from 'react';
import './InstructorExams.css';
import './InstructorCourses.css';
import { apiFetch, resolveMediaUrl } from './api';
import InstructorExamGrading from './InstructorExamGrading';
import QuestionUploadResultPage from './QuestionUploadResultPage';
import MathText from './MathText';
import { useActiveCourse } from './ActiveCourseContext';

function InstructorExams({ instructorId, isAdmin = false, isProgramBaskan = false }) {
  const BUTTON_COLORS = {
    primaryDark: '#0f172a',
    success: '#10b981',
    warning: '#f59e0b',
    danger: '#ef4444',
    muted: '#94a3b8'
  };
  const DEFAULT_ENTRANCE_CONFIRMATION = `Sevgili Öğrenciler,
Dersimiz kapsamında gerçekleştirilecek olan online sınava ilişkin uygulama esasları ve önemli
bilgiler aşağıda bilgilerinize sunulmuştur:
• Sınavınız “Başla” butonuna tıkladığınız anda başlayacaktır.
• Sınav sürenizi ekrandan takip edebilirsiniz.
• Sınav süresi, sınavın bitiş saatine göre hesaplanmaktadır.
• Süreniz dolduğunda sistem otomatik olarak kapanacak ve işaretlediğiniz sorular
değerlendirmeye alınacaktır.
• Sınavda önceki sorulara geri dönüş yapılabilir.
• Sınava, kesintisiz internet bağlantısı olan ve elektrik kesintisi riski bulunmayan bir
cihazdan girmeniz gerekmektedir. Aksi durumlarda sorumluluk öğrenciye aittir.
• Sınav sayfasının kapanması, elektrik kesintisi vb. durumlarda sınavınız yarım kalırsa,
“Sınavı Teslim Et” butonuna basmadığınız sürece sisteme tekrar giriş yaparak sınav
bağlantısını yeniden seçmeniz gerekmektedir.
• Sisteme yeniden giriş yaptığınızda sınavınıza kaldığınız sorudan devam edebilirsiniz.
• Sınav, kalan süre içerisinde tamamlanabilir.
• Tüm sorular cevaplandıktan sonra “Sınavı Teslim Et” butonuna tıklanması
gerekmektedir.
• “Sınavı Teslim Et” butonuna basıldıktan sonra sınava tekrar giriş yapılamaz.
Önemli Uyarı:
Sınav sırasında tam ekran modundan çıkmanız durumunda:
• İlk ihlalde sistem tarafından uyarı verilecektir.
• İkinci ihlalde sınavınız kopya şüphesi nedeniyle sistem tarafından otomatik olarak
sonlandırılacaktır.
Sınav sırasında akademik dürüstlük kurallarına uyulması gerekmektedir.
Herhangi bir teknik sorun yaşamanız durumunda, en kısa sürede dersin öğretim elemanı ile
iletişime geçmeniz rica olunur.
Hepinize başarılar dilerim. :)`;

  const [exams, setExams] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [showCreateForm, setShowCreateForm] = useState(false);
  const [showArchived, setShowArchived] = useState(false); // Arşiv görünümü (internal)
  const [archivedExams, setArchivedExams] = useState([]);
  const [loadingArchived, setLoadingArchived] = useState(false);
  const [openArchivedCategories, setOpenArchivedCategories] = useState({});
  const [courses, setCourses] = useState([]);
  const [selectedCourseId, setSelectedCourseId] = useState('');
  const [courseSearchQuery, setCourseSearchQuery] = useState('');
  const activeCourseContext = useActiveCourse();
  const [creating, setCreating] = useState(false);
  const [createError, setCreateError] = useState('');
  
  // Page navigation state (modallar yerine sayfalar)
  const [currentPage, setCurrentPage] = useState(null); // null, 'question-management', 'preview', 'extend-time', 'upload-result'
  const [pageData, setPageData] = useState(null); // Sayfa verileri için
  
  // Modal state'leri (uyarı ve onay mesajları için)
  const [showStatusConfirmModal, setShowStatusConfirmModal] = useState(false);
  const [showDeleteConfirmModal, setShowDeleteConfirmModal] = useState(false);
  const [showPublishResultsModal, setShowPublishResultsModal] = useState(false);
  const [publishResultsExam, setPublishResultsExam] = useState(null);
  
  // Soru ekleme state
  const [selectedExam, setSelectedExam] = useState(null);
  const [showExcelUpload, setShowExcelUpload] = useState(false);
  const [questions, setQuestions] = useState([]);
  const [allLOs, setAllLOs] = useState([]);
  const [allPOs, setAllPOs] = useState([]);
  const [uploadingExcel, setUploadingExcel] = useState(false);
  const [questionError, setQuestionError] = useState('');
  const [excelFile, setExcelFile] = useState(null);
  const [questionCount, setQuestionCount] = useState(null);
  const [questionCountInput, setQuestionCountInput] = useState('');
  const [activeQuestionTab, setActiveQuestionTab] = useState('upload'); // 'upload' veya 'manage'
  const [questionPoolFilter, setQuestionPoolFilter] = useState('all'); // legacy — artık akordion kullanılıyor
  const [expandedWeek, setExpandedWeek] = useState(null); // hafta kartı akordionu: '<n>' | 'none' | null
  // null: tüm haftalar; dizi: yalnızca seçilen haftalar sınav havuzundadır.
  const [includedWeekNumbers, setIncludedWeekNumbers] = useState(null);
  const [savingWeekScope, setSavingWeekScope] = useState(false);
  
  // Soru yükleme sonuç bildirimi state
  const [uploadSuccessMessage, setUploadSuccessMessage] = useState('');
  const [uploadErrors, setUploadErrors] = useState([]);
  const [uploadStatistics, setUploadStatistics] = useState(null);
  
  // Önizleme state
  const [previewExam, setPreviewExam] = useState(null);
  const [previewSettings, setPreviewSettings] = useState(null);
  const [previewQuestions, setPreviewQuestions] = useState([]);
  const [loadingPreview, setLoadingPreview] = useState(false);
  // Puan girişi state (önizleme sayfasında)
  const [previewPointInputs, setPreviewPointInputs] = useState({});
  const [pointsSaved, setPointsSaved] = useState(false);
  const [savingPoints, setSavingPoints] = useState(false);
  const [totalPreviewPoints, setTotalPreviewPoints] = useState(0);
  // MC ve Klasik soru bölüm ayarları
  const [mcQuestionCount, setMcQuestionCount] = useState('');
  const [mcQuestionPoints, setMcQuestionPoints] = useState('');
  const [classicQuestionCount, setClassicQuestionCount] = useState('');
  const [classicQuestionPoints, setClassicQuestionPoints] = useState('');
  const [bulkMandatoryPoint, setBulkMandatoryPoint] = useState('');
  const pointBarAnchorRef = useRef(null);
  const pointBarRef = useRef(null);
  const pointBoardRef = useRef(null);
  const [pointBarFixed, setPointBarFixed] = useState(false);
  const [pointBarMetrics, setPointBarMetrics] = useState({ top: 80, left: 0, width: 0, height: 0 });
  // Hangi sınavların tüm soruları puanlandı
  const [examsWithPoints, setExamsWithPoints] = useState(new Set());
  // Doğru cevap düzenleme state'leri
  const [correctAnswerEdits, setCorrectAnswerEdits] = useState({}); // {question_id: "A"}
  const [savingCorrectAnswer, setSavingCorrectAnswer] = useState({}); // {question_id: boolean}

  // Status güncelleme state
  const [pendingStatusAction, setPendingStatusAction] = useState(null); // 'publish' veya 'draft'
  const [pendingExamId, setPendingExamId] = useState(null);
  const [updatingStatus, setUpdatingStatus] = useState(false);
  
  // Silme state
  const [pendingDeleteExamId, setPendingDeleteExamId] = useState(null);
  const [pendingDeleteExamTitle, setPendingDeleteExamTitle] = useState(null);
  const [deleting, setDeleting] = useState(false);
  
  // Değerlendirme state
  const [gradingExamId, setGradingExamId] = useState(null);
  const [selectedExamForScores, setSelectedExamForScores] = useState(null);
  const [selectedCourseForStats, setSelectedCourseForStats] = useState(null);
  const [examScoreStudents, setExamScoreStudents] = useState([]);
  const [loadingExamScores, setLoadingExamScores] = useState(false);
  const [examStatistics, setExamStatistics] = useState(null);
  const [topRankings, setTopRankings] = useState([]);
  const [bottomRankings, setBottomRankings] = useState([]);
  
  // Ek Süre state
  const [selectedExamForExtend, setSelectedExamForExtend] = useState(null);
  const [selectedExamForViolations, setSelectedExamForViolations] = useState(null);
  const [examStudents, setExamStudents] = useState([]);
  const [examAllowedStudentNos, setExamAllowedStudentNos] = useState(null);
  const [loadingStudents, setLoadingStudents] = useState(false);
  const [violationSessionFilter, setViolationSessionFilter] = useState(null);
  const [violationSearch, setViolationSearch] = useState('');
  const [examSessionCount, setExamSessionCount] = useState(1);
  const [bulkExtendMinutes, setBulkExtendMinutes] = useState('');
  const [studentExtendMinutes, setStudentExtendMinutes] = useState({});
  
  // Toast notification state
  const [toastMessage, setToastMessage] = useState('');
  const [toastType, setToastType] = useState('success'); // 'success' veya 'error'
  
  // Sonuç yayınlama state
  const [publishing, setPublishing] = useState(false);
  const [publishingExamId, setPublishingExamId] = useState(null);
  
  // Form state
  const [formData, setFormData] = useState({
    course_id: '',
    title: '',
    mode: 'Online',
    type: 'Mixed', // Sınav formatı artık otomatik belirleniyor (Excel'deki şıklara göre)
    exam_category: '', // Sınav kategorisi (vize, final, quiz - exam_weights'ten) - görüntü için
    exam_weight_id: null, // exam_weights tablosundan id
    exam_effect: null,
    start_at: '',
    end_at: '',
    duration_minutes: '',
    entrance_confirmation: DEFAULT_ENTRANCE_CONFIRMATION,
    finish_confirmation: 'Sınavı tamamladım ve tüm cevaplarımın doğru olduğunu onaylıyorum. Sınavı teslim etmek istiyorum.',
    max_attempts: 1,
    shuffle_type: 'none',
    auto_save: true,
    random_question_count: '',
    session_count: 1,
    students_per_session: '',
    session_1_start_at: '',
    session_1_end_at: '',
    session_2_start_at: '',
    session_2_end_at: ''
  });
  
  // Exam weights state
  const [examWeights, setExamWeights] = useState([]);
  const [loadingWeights, setLoadingWeights] = useState(false);
  // Ders hızlıca değiştirildiğinde eski isteğin geç dönüp yeni dersin
  // kategorilerini ezmesini önler.
  const examWeightsRequestRef = useRef(0);

  const getExamWeightLabel = (weight) => {
    if (!weight) return '';
    
    const isOntest = weight.is_ontest === true || ['ontest', 'öntest'].includes(
      String(weight.exam_type || '').trim().toLocaleLowerCase('tr-TR')
    );
    
    if (isOntest) {
      let label = 'Öntest';
      if (weight.pretest_exists) {
        label += ' ✓';
      }
      return label;
    }
    
    const typeLabels = {
      'final': 'Dönem Sonu Sınavı',
      'Final': 'Dönem Sonu Sınavı',
      'vize': 'Ara Sınav',
      'Vize': 'Ara Sınav',
      'butunleme': 'Bütünleme',
      'bütünleme': 'Bütünleme',
      'Butunleme': 'Bütünleme',
      'Bütünleme': 'Bütünleme',
      'odev': 'Ödev',
      'Odev': 'Ödev',
      'Ödev': 'Ödev',
    };

    let label = typeLabels[weight.exam_type] || weight.exam_type || '';

    if (weight.weight !== undefined && weight.weight !== null) {
      label += ` (${weight.weight}%)`;
    }

    return label.trim();
  };
  
  
  // Sınav düzenleme state
  const [editingExam, setEditingExam] = useState(null);
  
  // Validasyon hataları state
  const [validationErrors, setValidationErrors] = useState({
    start_at: '',
    end_at: '',
    duration_minutes: '',
    session_1: '',
    session_2: ''
  });
  
  // Öğrenci seçimi state
  const [selectedStudents, setSelectedStudents] = useState('all'); // 'all' | number[]
  const [showStudentModal, setShowStudentModal] = useState(false);
  const [modalStudents, setModalStudents] = useState([]);
  const [studentList, setStudentList] = useState([]);
  const [studentSearch, setStudentSearch] = useState('');
  const [studentClassFilter, setStudentClassFilter] = useState('');
  const [loadingStudentList, setLoadingStudentList] = useState(false);

  // Bitiş tarihi otomatik ayarlama state
  const [autoEndDateEnabled, setAutoEndDateEnabled] = useState(true);
  const [selectedDuration, setSelectedDuration] = useState(null); // '30', '45', '60', '90' (dakika)
  
  // Mobil kontrolü için ekran boyutu state
  const [isMobile, setIsMobile] = useState(false);
  
  // Kitapçıklar sayfası - aktif sekme (A veya B)
  const [activeBookletTab, setActiveBookletTab] = useState('A');
  const [bookletsData, setBookletsData] = useState({ A: { questions: [] }, B: { questions: [] } });
  const [loadingBooklets, setLoadingBooklets] = useState(false);
  const [generatingBooklets, setGeneratingBooklets] = useState(false);

  useEffect(() => {
    if (instructorId !== null && instructorId !== undefined) {
      fetchExams();
      fetchCourses();
      if (!isProgramBaskan) fetchArchivedExams();
    }
  }, [instructorId]);

  useEffect(() => {
    if (!activeCourseContext) return;
    const nextCourseId = activeCourseContext.activeCourseId;
    if (String(selectedCourseId) !== String(nextCourseId)) setSelectedCourseId(nextCourseId);
    if (nextCourseId && !editingExam) {
      setFormData((previous) => ({ ...previous, course_id: nextCourseId }));
    }
  }, [activeCourseContext, selectedCourseId, editingExam]);

  // Ekran boyutu kontrolü
  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    
    checkMobile();
    window.addEventListener('resize', checkMobile);
    
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  // Otomatik yenileme - 30 saniyede bir sessiz güncelleme
  useEffect(() => {
    if (instructorId === null || instructorId === undefined) return;
    
    const interval = setInterval(() => {
      // Sessiz güncelleme - loading state'i değiştirme
      fetchExams(showArchived, true).catch(err => console.error('Otomatik yenileme hatası:', err));
      fetchCourses(true).catch(err => console.error('Otomatik yenileme hatası:', err));
    }, 30000); // 30 saniye

    return () => clearInterval(interval);
  }, [instructorId, showArchived]);

  // Kitapçıklar sayfasına girildiğinde veriyi çek
  useEffect(() => {
    if (currentPage === 'booklets' && selectedExam?.exam_id) {
      fetchBooklets(selectedExam.exam_id);
    }
  }, [currentPage, selectedExam?.exam_id]);

  // Ders seçildiğinde öğrenci listesini getir
  useEffect(() => {
    if (!formData.course_id || !showCreateForm) {
      setStudentList([]);
      setSelectedStudents('all');
      return;
    }
    setLoadingStudentList(true);
    apiFetch(`/instructor/students?course_id=${formData.course_id}`)
      .then(r => r.json())
      .then(d => { if (d.success) setStudentList(d.students || []); })
      .catch(() => {})
      .finally(() => setLoadingStudentList(false));
  }, [formData.course_id, showCreateForm]);

  // İhlal ekranı açıkken canlı takip için kısa aralıklı yenileme
  useEffect(() => {
    if (currentPage !== 'violations' || !selectedExamForViolations?.exam_id) return;

    const interval = setInterval(() => {
      fetchExamStudents(selectedExamForViolations.exam_id, true).catch(err =>
        console.error('İhlal ekranı otomatik yenileme hatası:', err)
      );
    }, 10000);

    return () => clearInterval(interval);
  }, [currentPage, selectedExamForViolations?.exam_id]);

  useEffect(() => {
    if (currentPage !== 'preview') {
      setPointBarFixed(false);
      return;
    }

    const updatePointBarPosition = () => {
      const anchor = pointBarAnchorRef.current;
      const board = pointBoardRef.current;
      const bar = pointBarRef.current;
      if (!anchor || !board || !bar) return;

      const headerHeight = document.querySelector('.header')?.getBoundingClientRect().height || 70;
      const top = Math.round(headerHeight + 10);
      const anchorRect = anchor.getBoundingClientRect();
      const boardRect = board.getBoundingClientRect();
      const barHeight = bar.offsetHeight;
      const shouldFix = anchorRect.top <= top && boardRect.bottom > top + barHeight + 24;

      setPointBarFixed(shouldFix);
      setPointBarMetrics(prev => {
        const next = {
          top,
          left: Math.round(boardRect.left),
          width: Math.round(boardRect.width),
          height: barHeight
        };
        return prev.top === next.top && prev.left === next.left && prev.width === next.width && prev.height === next.height
          ? prev
          : next;
      });
    };

    updatePointBarPosition();
    window.addEventListener('scroll', updatePointBarPosition, true);
    window.addEventListener('resize', updatePointBarPosition);

    return () => {
      window.removeEventListener('scroll', updatePointBarPosition, true);
      window.removeEventListener('resize', updatePointBarPosition);
    };
  }, [currentPage, loadingPreview, previewQuestions.length]);
  
  const fetchCourses = async (silent = false) => {
    try {
      const response = await apiFetch(`/instructor/courses`);
      const data = await response.json();
      if (data.success) {
        const nextCourses = data.courses || [];
        setCourses(nextCourses);
        if (isAdmin && nextCourses.length > 0) {
          setSelectedCourseId((prev) => prev || String(nextCourses[0].course_id));
        }
      }
    } catch (err) {
      if (!silent) {
        console.error('Dersler yüklenemedi:', err);
      }
    }
  };

  const fetchExams = async (archived = false, silent = false) => {
    try {
      if (!silent) {
        setLoading(true);
      }
      let examUrl;
      if (isProgramBaskan) {
        examUrl = '/instructor/exams?archived=all';
      } else {
        examUrl = `/instructor/exams${archived ? '?archived=true' : ''}`;
      }
      const response = await apiFetch(examUrl);
      const data = await response.json().catch(() => ({}));

      if (response.ok && data.success) {
        const allExams = data.exams || [];
        if (isProgramBaskan) {
          setExams(allExams.filter(e => e.status !== 'Archived'));
          setArchivedExams(allExams.filter(e => e.status === 'Archived'));
        } else {
          setExams(allExams);
        }
        const withPoints = new Set(
          allExams.filter(e => e.has_all_points).map(e => e.exam_id)
        );
        setExamsWithPoints(withPoints);
      } else {
        if (!silent) {
          if (response.status === 400) {
            setError(data.message || 'Sınav verileri geçersiz. Lütfen form alanlarını kontrol edin.');
          } else if (response.status === 403) {
            setError(data.message || 'Bu ekranı görüntülemek için akademisyen hesabıyla giriş yapmalısınız.');
          } else {
            setError(data.message || 'Sınavlar yüklenemedi');
          }
        }
      }
    } catch (err) {
      if (!silent) {
        setError('Bağlantı hatası');
      }
      console.error('Error:', err);
    } finally {
      if (!silent) {
        setLoading(false);
      }
    }
  };

  const fetchArchivedExams = async () => {
    setLoadingArchived(true);
    try {
      const response = await apiFetch('/instructor/exams?archived=true');
      const data = await response.json();
      if (data.success) setArchivedExams(data.exams || []);
    } catch (err) {
      console.error('Arşiv yüklenemedi:', err);
    } finally {
      setLoadingArchived(false);
    }
  };

  const formatDate = (dateString) => {
    if (!dateString) return '-';
    const date = new Date(dateString);
    return date.toLocaleString('tr-TR');
  };
  
  // UTC tarihini local datetime-local formatına dönüştür (Türkiye UTC+3)
  const utcToLocalDateTime = (utcDateString) => {
    if (!utcDateString) return '';
    // new Date(utcDateString) UTC string'i parse eder ve local timezone'a çevirir
    const date = new Date(utcDateString);
    
    // Local timezone değerlerini al (getFullYear, getMonth vs UTC değil)
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    return `${year}-${month}-${day}T${hours}:${minutes}`;
  };
  
  // Local datetime-local formatını direkt ISO string'e çevir (timezone dönüşümü yok)
  const localDateTimeToISO = (localDateTimeString) => {
    if (!localDateTimeString) return null;
    // datetime-local formatı: "2026-01-19T12:49"
    // Direkt ISO formatına çevir: "2026-01-19T12:49:00" (timezone yok)
    const [datePart, timePart] = localDateTimeString.split('T');
    if (!datePart || !timePart) return null;
    
    // Saniye ekle (eğer yoksa)
    const timeWithSeconds = timePart.includes(':') && timePart.split(':').length === 2 
      ? `${timePart}:00` 
      : timePart;
    
    return `${datePart}T${timeWithSeconds}`;
  };

  // Şu anki tarih/saati datetime-local formatında döndür (form varsayılanı için)
  const getCurrentDateTimeLocal = () => {
    const d = new Date();
    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, '0');
    const day = String(d.getDate()).padStart(2, '0');
    const hours = String(d.getHours()).padStart(2, '0');
    const minutes = String(d.getMinutes()).padStart(2, '0');
    return `${year}-${month}-${day}T${hours}:${minutes}`;
  };

  const getStatusBadge = (status) => {
    const statusMap = {
      'Draft': { label: 'Taslak', class: 'status-draft' },
      'Published': { label: 'Yayınlandı', class: 'status-published' },
      'Paused': { label: 'Duraklatıldı', class: 'status-paused' },
      'Completed': { label: 'Tamamlandı', class: 'status-completed' },
      'Archived': { label: 'Arşivlendi', class: 'status-archived' }
    };
    const statusInfo = statusMap[status] || { label: status, class: 'status-default' };
    return <span className={`status-badge ${statusInfo.class}`}>{statusInfo.label}</span>;
  };
  
  const validateFormData = (data) => {
    const errors = {
      start_at: '',
      end_at: '',
      duration_minutes: '',
      question_count: '',
      session_1: '',
      session_2: ''
    };
    
    const now = new Date();
    now.setSeconds(0, 0); // Saniye ve milisaniyeleri sıfırla
    
    const isMultiSession = parseInt(data.session_count) > 1;

    if (!Number.isInteger(Number(data.random_question_count)) || Number(data.random_question_count) <= 0) {
      errors.question_count = 'Soru sayısı 0’dan büyük bir tam sayı olmalıdır';
    }
    
    if (isMultiSession) {
      // 2 OTURUM - Oturum saatlerini kontrol et
      if (!data.session_1_start_at || !data.session_1_end_at) {
        errors.session_1 = '1. Oturum başlangıç ve bitiş saatleri zorunludur';
      }
      if (!data.session_2_start_at || !data.session_2_end_at) {
        errors.session_2 = '2. Oturum başlangıç ve bitiş saatleri zorunludur';
      }
      
      // 1. Oturum tarih kontrolü
      if (data.session_1_start_at) {
        const startDate = new Date(data.session_1_start_at);
        if (startDate < now) {
          errors.session_1 = '1. Oturum başlangıç tarihi geçmiş bir tarih olamaz';
        }
      }
      if (data.session_1_start_at && data.session_1_end_at) {
        const startDate = new Date(data.session_1_start_at);
        const endDate = new Date(data.session_1_end_at);
        if (startDate >= endDate) {
          errors.session_1 = '1. Oturum başlangıç tarihi bitiş tarihinden önce olmalıdır';
        }
      }
      
      // 2. Oturum tarih kontrolü
      if (data.session_2_start_at) {
        const startDate = new Date(data.session_2_start_at);
        if (startDate < now) {
          errors.session_2 = '2. Oturum başlangıç tarihi geçmiş bir tarih olamaz';
        }
      }
      if (data.session_2_start_at && data.session_2_end_at) {
        const startDate = new Date(data.session_2_start_at);
        const endDate = new Date(data.session_2_end_at);
        if (startDate >= endDate) {
          errors.session_2 = '2. Oturum başlangıç tarihi bitiş tarihinden önce olmalıdır';
        }
      }
    } else {
      // TEK OTURUM - Mevcut kontroller
      // Başlangıç tarihi kontrolü
      if (data.start_at) {
        const startDate = new Date(data.start_at);
        if (startDate < now) {
          errors.start_at = 'Başlangıç tarihi geçmiş bir tarih olamaz';
        }
      }
      
      // Bitiş tarihi kontrolü
      if (data.end_at) {
        const endDate = new Date(data.end_at);
        if (endDate < now) {
          errors.end_at = 'Bitiş tarihi geçmiş bir tarih olamaz';
        }
      }
      
      // Başlangıç ve bitiş tarihi karşılaştırması
      if (data.start_at && data.end_at) {
        const startDate = new Date(data.start_at);
        const endDate = new Date(data.end_at);
        
        if (startDate >= endDate) {
          errors.end_at = 'Başlangıç tarihi bitiş tarihinden önce olmalıdır';
        }
        
        // Süre kontrolü
        if (!data.duration_minutes || parseInt(data.duration_minutes) < 1) {
          errors.duration_minutes = 'Sınav süresi zorunludur';
        } else {
          const durationMinutes = parseInt(data.duration_minutes);
          const diffMinutes = (endDate - startDate) / (1000 * 60);
          if (durationMinutes > diffMinutes) {
            errors.duration_minutes = `Sınav süresi, başlangıç ve bitiş tarihleri arasındaki süreden (${Math.floor(diffMinutes)} dakika) fazla olamaz`;
          }
        }
      }
    }
    
    return errors;
  };
  
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    
    // Ders seçildiğinde exam_weights'leri getir
    const courseChanged = name === 'course_id' && String(value) !== String(formData.course_id || '');

    // Başlangıç tarihi değiştiğinde, otomatik mod aktifse bitiş tarihini güncelle
    if (name === 'start_at' && value && autoEndDateEnabled && selectedDuration) {
      // datetime-local formatından parse et (local timezone)
      const [datePart, timePart] = value.split('T');
      const [year, month, day] = datePart.split('-').map(Number);
      const [hours, mins] = timePart.split(':').map(Number);
      
      // Local timezone'da Date objesi oluştur
      const startDate = new Date(year, month - 1, day, hours, mins);
      // Local timezone'da dakika ekle
      const endDate = new Date(startDate.getTime() + selectedDuration * 60000);
      
      // Local timezone'da datetime-local formatına çevir
      const endYear = endDate.getFullYear();
      const endMonth = String(endDate.getMonth() + 1).padStart(2, '0');
      const endDay = String(endDate.getDate()).padStart(2, '0');
      const endHours = String(endDate.getHours()).padStart(2, '0');
      const endMinutes = String(endDate.getMinutes()).padStart(2, '0');
      const endDateString = `${endYear}-${endMonth}-${endDay}T${endHours}:${endMinutes}`;
      
      const updatedFormData = {
        ...formData,
        [name]: value,
        end_at: endDateString
      };
      
      setFormData(updatedFormData);
      
      // Validasyon yap
      const errors = validateFormData(updatedFormData);
      setValidationErrors(errors);
      return;
    }
    
    // Bitiş tarihi manuel değiştirildiğinde otomatik modu kapat
    if (name === 'end_at') {
      setAutoEndDateEnabled(false);
      setSelectedDuration(null);
    }
    
    const updatedFormData = {
      ...formData,
      [name]: value,
      ...(courseChanged ? {
        exam_category: '',
        exam_weight_id: null,
        exam_effect: null
      } : {})
    };
    
    setFormData(updatedFormData);
    
    // Validasyon yap
    const errors = validateFormData(updatedFormData);
    setValidationErrors(errors);
  };
  
  const fetchExamWeights = async (courseId, existingExamWeightId = null) => {
    if (!courseId) return;

    const requestId = ++examWeightsRequestRef.current;
    setLoadingWeights(true);
    try {
      const response = await apiFetch(`/courses/${courseId}/exam-weights`);
      const data = await response.json();

      // Ders değiştirildiyse bu yanıt artık güncel değildir. Eski yanıtın
      // seçenek listesini ezmesine izin verme.
      if (requestId !== examWeightsRequestRef.current) return;

      if (data.success) {
        setExamWeights(data.exam_weights || []);
        
        // Düzenleme modunda: Mevcut exam_weight_id varsa ve exam weights içinde varsa, onu koru
        if (existingExamWeightId && data.exam_weights && data.exam_weights.length > 0) {
          const existingWeight = data.exam_weights.find(w => w.id === existingExamWeightId);
          if (existingWeight) {
            setFormData(prev => ({
              ...prev,
              exam_weight_id: existingExamWeightId,
              exam_category: existingWeight.exam_type,
              exam_effect: existingWeight.weight
            }));
            return; // Mevcut değeri koruduk, devam etme
          }
        }
        
        // Yeni oluşturma modunda: Eğer sınav kategorisi seçilmemişse ve weights varsa, ilkini seç
        // existingExamWeightId yoksa ve formData'da exam_weight_id yoksa ilkini seç
        if (data.exam_weights && data.exam_weights.length > 0 && !existingExamWeightId) {
          setFormData(prev => {
            // Eğer zaten bir exam_weight_id seçilmişse, değiştirme
            if (prev.exam_weight_id) {
              return prev;
            }
            // Yoksa ilkini seç
            // API, ağırlıksız Öntest'i ilk sırada döndürür. Böylece tüm
            // derslerde izlenç ağırlığı aranmadan Öntest seçilebilir.
            const firstWeight = data.exam_weights[0];
            return {
              ...prev,
              exam_category: firstWeight.exam_type,
              exam_weight_id: firstWeight.id,
              exam_effect: firstWeight.weight
            };
          });
        }
      } else {
        setExamWeights([]);
        // Hata durumunda eski değerleri temizle (sadece yeni oluşturma modunda)
        if (!existingExamWeightId) {
          setFormData(prev => ({
            ...prev,
            exam_category: '',
            exam_weight_id: null,
            exam_effect: null
          }));
        }
      }
    } catch (err) {
      if (requestId !== examWeightsRequestRef.current) return;
      console.error('Sınav ağırlıkları yüklenemedi:', err);
      setExamWeights([]);
    } finally {
      if (requestId === examWeightsRequestRef.current) {
        setLoadingWeights(false);
      }
    }
  };

  // Üstteki aktif ders bağlamı formu doğrudan doldurduğunda select onChange
  // çalışmaz. Yeni sınav formu açıldığında ve ders her değiştiğinde ağırlıkları
  // tek bir kaynaktan yükle; böylece otomatik seçilen derslerde kategori boş kalmaz.
  useEffect(() => {
    if (!showCreateForm || !formData.course_id || editingExam) return;
    fetchExamWeights(parseInt(formData.course_id, 10));
    // fetchExamWeights render sırasında yeniden oluşur; tetikleyiciler yalnızca
    // form görünürlüğü ve seçili ders olmalıdır.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [showCreateForm, formData.course_id, editingExam]);
  
  // Tarih/saat ayrı alanlardan start_at veya end_at güncelle
  const handleDateTimePartChange = (field, value) => {
    const defaultDate = () => new Date().toISOString().slice(0, 10);
    const defaultStartTime = '09:00';
    const defaultEndTime = '17:00';

    if (field === 'start_date') {
      const time = formData.start_at ? formData.start_at.split('T')[1].substring(0, 5) : defaultStartTime;
      const newStartAt = `${value}T${time}`;
      let updated = { ...formData, start_at: newStartAt };
      if (autoEndDateEnabled && selectedDuration) {
        const [y, mo, d] = value.split('-').map(Number);
        const [h, m] = time.split(':').map(Number);
        const startDate = new Date(y, mo - 1, d, h, m);
        const endDate = new Date(startDate.getTime() + selectedDuration * 60000);
        const endStr = `${endDate.getFullYear()}-${String(endDate.getMonth() + 1).padStart(2, '0')}-${String(endDate.getDate()).padStart(2, '0')}T${String(endDate.getHours()).padStart(2, '0')}:${String(endDate.getMinutes()).padStart(2, '0')}`;
        updated = { ...updated, end_at: endStr };
      }
      setFormData(updated);
      setValidationErrors(validateFormData(updated));
      return;
    }
    if (field === 'start_time') {
      const date = formData.start_at ? formData.start_at.split('T')[0] : defaultDate();
      const newStartAt = `${date}T${value}`;
      let updated = { ...formData, start_at: newStartAt };
      if (autoEndDateEnabled && selectedDuration) {
        const [y, mo, d] = date.split('-').map(Number);
        const [h, m] = value.split(':').map(Number);
        const startDate = new Date(y, mo - 1, d, h, m);
        const endDate = new Date(startDate.getTime() + selectedDuration * 60000);
        const endStr = `${endDate.getFullYear()}-${String(endDate.getMonth() + 1).padStart(2, '0')}-${String(endDate.getDate()).padStart(2, '0')}T${String(endDate.getHours()).padStart(2, '0')}:${String(endDate.getMinutes()).padStart(2, '0')}`;
        updated = { ...updated, end_at: endStr };
      }
      setFormData(updated);
      setValidationErrors(validateFormData(updated));
      return;
    }
    if (field === 'end_date') {
      const time = formData.end_at ? formData.end_at.split('T')[1].substring(0, 5) : defaultEndTime;
      const updated = { ...formData, end_at: `${value}T${time}` };
      setAutoEndDateEnabled(false);
      setSelectedDuration(null);
      setFormData(updated);
      setValidationErrors(validateFormData(updated));
      return;
    }
    if (field === 'end_time') {
      const date = formData.end_at ? formData.end_at.split('T')[0] : defaultDate();
      const updated = { ...formData, end_at: `${date}T${value}` };
      setAutoEndDateEnabled(false);
      setSelectedDuration(null);
      setFormData(updated);
      setValidationErrors(validateFormData(updated));
    }
  };

  const setStartTime5MinutesLater = () => {
    // Şu anki tarih ve saatten 5 dakika sonrasını al
    const now = new Date();
    const fiveMinutesLater = new Date(now.getTime() + 5 * 60000);
    
    // datetime-local formatına çevir (YYYY-MM-DDTHH:mm)
    const year = fiveMinutesLater.getFullYear();
    const month = String(fiveMinutesLater.getMonth() + 1).padStart(2, '0');
    const day = String(fiveMinutesLater.getDate()).padStart(2, '0');
    const hours = String(fiveMinutesLater.getHours()).padStart(2, '0');
    const minutes = String(fiveMinutesLater.getMinutes()).padStart(2, '0');
    const dateTimeString = `${year}-${month}-${day}T${hours}:${minutes}`;
    
    // FormData'yı güncelle
    const updatedFormData = {
      ...formData,
      start_at: dateTimeString
    };
    
    setFormData(updatedFormData);
    
    // Validasyon yap
    const errors = validateFormData(updatedFormData);
    setValidationErrors(errors);
  };
  
  const handleQuickDurationSelect = (minutes) => {
    if (!formData.start_at) {
      alert('Lütfen önce başlangıç tarihini seçin');
      return;
    }
    
    // datetime-local formatından parse et (local timezone - Türkiye)
    const [datePart, timePart] = formData.start_at.split('T');
    const [year, month, day] = datePart.split('-').map(Number);
    const [hours, mins] = timePart.split(':').map(Number);
    
    // Local timezone'da Date objesi oluştur
    const startDate = new Date(year, month - 1, day, hours, mins);
    // Local timezone'da dakika ekle
    const endDate = new Date(startDate.getTime() + minutes * 60000);
    
    // Local timezone'da datetime-local formatına çevir
    const endYear = endDate.getFullYear();
    const endMonth = String(endDate.getMonth() + 1).padStart(2, '0');
    const endDay = String(endDate.getDate()).padStart(2, '0');
    const endHours = String(endDate.getHours()).padStart(2, '0');
    const endMinutes = String(endDate.getMinutes()).padStart(2, '0');
    const endDateString = `${endYear}-${endMonth}-${endDay}T${endHours}:${endMinutes}`;
    
    setSelectedDuration(minutes);
    setAutoEndDateEnabled(true);
    
    const updatedFormData = {
      ...formData,
      end_at: endDateString
    };
    
    setFormData(updatedFormData);
    
    // Validasyon yap
    const errors = validateFormData(updatedFormData);
    setValidationErrors(errors);
  };
  
  const handleOpenStudentModal = () => {
    setModalStudents(selectedStudents === 'all' ? [] : [...selectedStudents]);
    setStudentSearch('');
    setStudentClassFilter('');
    setShowStudentModal(true);
  };

  const toggleModalStudent = (id) =>
    setModalStudents(prev => prev.includes(id) ? prev.filter(x => x !== id) : [...prev, id]);

  const handleMasterCheck = (filteredStudents, keyFn = (s => s.student_number)) => {
    const allKeys = filteredStudents.map(keyFn);
    const allSelected = allKeys.length > 0 && allKeys.every(k => modalStudents.includes(k));
    setModalStudents(allSelected
      ? modalStudents.filter(k => !allKeys.includes(k))
      : [...new Set([...modalStudents, ...allKeys])]);
  };

  const handleExamCategoryChange = (e) => {
    const selectedId = parseInt(e.target.value);
    const selectedWeight = examWeights.find(w => w.id === selectedId);
    
    setFormData(prev => ({
      ...prev,
      exam_weight_id: selectedId || null,
      exam_category: selectedWeight ? selectedWeight.exam_type : '',
      exam_effect: selectedWeight ? selectedWeight.weight : null
    }));
  };
  
  const handleCreateExam = async (e) => {
    e.preventDefault();
    setCreating(true);
    setCreateError('');

    // Yeni sınavın dersi yalnızca üstteki aktif ders bağlamından gelir.
    // Düzenlenen mevcut sınav ise kendi kayıtlı dersini korur.
    const effectiveCourseId = editingExam
      ? formData.course_id
      : activeCourseContext?.activeCourseId;
    if (!effectiveCourseId) {
      setCreating(false);
      setCreateError('Sınav oluşturmak için önce üst bölümden aktif ders seçin.');
      return;
    }
    
    // Form validasyonu
    const errors = validateFormData(formData);
    setValidationErrors(errors);
    
    // Hata varsa submit etme
    const hasErrors = errors.start_at || errors.end_at || errors.duration_minutes || errors.question_count || errors.session_1 || errors.session_2;
    if (hasErrors) {
      setCreating(false);
      const errorMessages = [errors.start_at, errors.end_at, errors.duration_minutes, errors.question_count, errors.session_1, errors.session_2].filter(Boolean);
      setCreateError(errorMessages[0] || 'Lütfen form hatalarını düzeltin');
      return;
    }
    
    try {
      // Local datetime-local formatını direkt ISO string'e çevir (timezone dönüşümü yok)
      // 2 oturum seçilmişse, genel start_at/end_at oturum saatlerinden alınır
      const isMultiSession = parseInt(formData.session_count) > 1;
      const startAtISO = isMultiSession 
        ? localDateTimeToISO(formData.session_1_start_at)
        : localDateTimeToISO(formData.start_at);
      const endAtISO = isMultiSession 
        ? localDateTimeToISO(formData.session_2_end_at)
        : localDateTimeToISO(formData.end_at);
      
      const examData = {
        instructor_id: instructorId,
        course_id: parseInt(effectiveCourseId, 10),
        title: formData.title,
        mode: formData.mode,
        type: 'Mixed', // Sınav türü artık otomatik belirleniyor (Excel'deki şıklara göre)
        exam_category: formData.exam_category || '', // görüntü için
        exam_weight_id: formData.exam_weight_id || null, // FK
        exam_effect: formData.exam_effect !== null ? parseFloat(formData.exam_effect) : null,
        status: 'Draft', // Sınav her zaman taslak olarak oluşturulur
        start_at: startAtISO,  // Direkt local time (timezone dönüşümü yok)
        end_at: endAtISO,      // Direkt local time (timezone dönüşümü yok)
        duration_minutes: formData.duration_minutes ? parseInt(formData.duration_minutes) : null,
        entrance_confirmation: formData.entrance_confirmation || '',
        finish_confirmation: formData.finish_confirmation || '',
        max_attempts: parseInt(formData.max_attempts) || 1,
        shuffle_type: formData.shuffle_type || 'none',
        auto_save: true,
        question_count: parseInt(formData.random_question_count, 10),
        session_count: parseInt(formData.session_count) || 1,
        students_per_session: parseInt(formData.session_count) > 1
          ? (parseInt(formData.students_per_session) || null)
          : null,
        session_1_start_at: parseInt(formData.session_count) > 1 ? formData.session_1_start_at : null,
        session_1_end_at: parseInt(formData.session_count) > 1 ? formData.session_1_end_at : null,
        session_2_start_at: parseInt(formData.session_count) > 1 ? formData.session_2_start_at : null,
        session_2_end_at: parseInt(formData.session_count) > 1 ? formData.session_2_end_at : null,
        students: selectedStudents
      };
      
      const url = editingExam 
        ? `/instructor/exams/${editingExam.exam_id}`
        : '/instructor/exams';
      
      const response = await apiFetch(url, {
        method: editingExam ? 'PUT' : 'POST',
        body: JSON.stringify(examData)
      });
      
      const data = await response.json();
      
      if (data.success) {
        setShowCreateForm(false);
        setEditingExam(null);
        setAutoEndDateEnabled(true);
        setSelectedDuration(null);
        setFormData({
          course_id: '',
          title: '',
          mode: 'Online',
          type: 'Mixed',
          exam_category: '',
          exam_weight_id: null,
          exam_effect: null,
          status: 'Draft',
          start_at: '',
          end_at: '',
          duration_minutes: '',
          entrance_confirmation: DEFAULT_ENTRANCE_CONFIRMATION,
          finish_confirmation: 'Sınavı tamamladım ve tüm cevaplarımın doğru olduğunu onaylıyorum. Sınavı teslim etmek istiyorum.',
          max_attempts: 1,
          shuffle_type: 'none',
          auto_save: true,
          random_question_count: '',
          session_count: 1,
          students_per_session: '',
          session_1_start_at: '',
          session_1_end_at: '',
          session_2_start_at: '',
          session_2_end_at: ''
        });
        setValidationErrors({
          start_at: '',
          end_at: '',
          duration_minutes: '',
          session_1: '',
          session_2: ''
        });
        setExamWeights([]);
        setSelectedStudents('all');
        setStudentList([]);
        setModalStudents([]);
        fetchExams(); // Listeyi yenile
      } else {
        setCreateError(data.message || (editingExam ? 'Sınav güncellenemedi' : 'Sınav oluşturulamadı'));
      }
    } catch (err) {
      setCreateError('Bağlantı hatası');
      console.error('Error:', err);
    } finally {
      setCreating(false);
    }
  };
  
  const openQuestionModal = async (exam, initialTab = 'upload') => {
    setSelectedExam(exam);
    setShowExcelUpload(true); // Direkt Excel yükleme göster
    setQuestionError('');
    setUploadErrors([]);
    setUploadStatistics(null);
    setUploadSuccessMessage('');
    setExcelFile(null);
    setActiveQuestionTab(initialTab);
    const count = exam.question_count || null;
    setQuestionCount(count);
    setQuestionCountInput(count ? count.toString() : '');
    setQuestionPoolFilter('all');
    await fetchQuestions(exam.exam_id);
    setCurrentPage('question-management');
    setPageData({ exam });
  };
  
  const openBookletsPage = (exam) => {
    setSelectedExam(exam);
    setCurrentPage('booklets');
    setBookletsData({ A: { questions: [] }, B: { questions: [] } });
  };

  const fetchBooklets = async (examId) => {
    setLoadingBooklets(true);
    try {
      const response = await apiFetch(`/instructor/exams/${examId}/booklets`);
      const data = await response.json();
      if (data.success && data.booklets) {
        const byVariant = { A: { questions: [] }, B: { questions: [] } };
        data.booklets.forEach(b => {
          if (b.variant === 'A' || b.variant === 'B') {
            byVariant[b.variant] = { questions: b.questions || [] };
          }
        });
        setBookletsData(byVariant);
      } else {
        setBookletsData({ A: { questions: [] }, B: { questions: [] } });
      }
    } catch (e) {
      console.error('Kitapçıklar yüklenemedi:', e);
      setBookletsData({ A: { questions: [] }, B: { questions: [] } });
    } finally {
      setLoadingBooklets(false);
    }
  };

  const generateBooklets = async () => {
    if (!selectedExam) return;
    setGeneratingBooklets(true);
    try {
      const response = await apiFetch(`/instructor/exams/${selectedExam.exam_id}/booklets/generate`, { method: 'POST' });
      const data = await response.json();
      if (data.success) {
        setToastMessage('Kitapçıklar oluşturuldu');
        setToastType('success');
        setTimeout(() => setToastMessage(''), 3000);
        await fetchBooklets(selectedExam.exam_id);
      } else {
        setToastMessage(data.message || 'Kitapçık oluşturulamadı');
        setToastType('error');
        setTimeout(() => setToastMessage(''), 3000);
      }
    } catch (e) {
      setToastMessage('Kitapçık oluşturulamadı');
      setToastType('error');
      setTimeout(() => setToastMessage(''), 3000);
    } finally {
      setGeneratingBooklets(false);
    }
  };

  const downloadBooklet = async (variant) => {
    if (!selectedExam) return;
    const questions = bookletsData[variant]?.questions;
    if (!questions || questions.length === 0) {
      setToastMessage('Önce kitapçık oluşturun');
      setToastType('error');
      setTimeout(() => setToastMessage(''), 3000);
      return;
    }
    try {
      const response = await apiFetch(`/instructor/exams/${selectedExam.exam_id}/booklets/${variant}/download?format=docx`);
      const contentType = response.headers.get('Content-Type') || '';
      if (!response.ok) {
        const data = await response.json().catch(() => ({}));
        setToastMessage(data.message || 'İndirme başarısız');
        setToastType('error');
        setTimeout(() => setToastMessage(''), 3000);
        return;
      }
      if (contentType.includes('application/json')) {
        const data = await response.json().catch(() => ({}));
        setToastMessage(data.message || 'Sunucu Word dosyası yerine hata döndü');
        setToastType('error');
        setTimeout(() => setToastMessage(''), 3000);
        return;
      }
      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = `kitapcik_${variant}.docx`;
      a.style.display = 'none';
      document.body.appendChild(a);
      a.click();
      setTimeout(() => {
        window.URL.revokeObjectURL(url);
        a.remove();
      }, 300);
      setToastMessage(`${variant} kitapçığı Word dosyası olarak indirildi. Word ile açıp kontrol edebilirsiniz.`);
      setToastType('success');
      setTimeout(() => setToastMessage(''), 4000);
    } catch (e) {
      setToastMessage('İndirme başarısız: ' + (e.message || 'Bağlantı hatası'));
      setToastType('error');
      setTimeout(() => setToastMessage(''), 3000);
    }
  };
  
  const fetchQuestions = async (examId) => {
    try {
      const response = await apiFetch(`/instructor/exams/${examId}/questions`);
      const data = await response.json();
      console.log('Raw response data:', data);
      console.log('Response success:', data.success);
      console.log('Questions array length:', data.questions?.length);
      if (data.success && data.questions) {
        // Her soruya is_mandatory ekle (eğer yoksa)
        const questionsWithMandatory = data.questions.map(q => {
          // Backend'den gelen is_mandatory değerini kullan
          const isMandatory = q.is_mandatory !== undefined ? Boolean(q.is_mandatory) : false;
          console.log(`Question ${q.id} - is_mandatory from backend: ${q.is_mandatory}, processed: ${isMandatory}`);
          return {
            ...q,
            is_mandatory: isMandatory
          };
        });
        console.log('Processed questions with is_mandatory:', questionsWithMandatory.map(q => ({ id: q.id, is_mandatory: q.is_mandatory, type: typeof q.is_mandatory })));
        setQuestions(questionsWithMandatory);
        setIncludedWeekNumbers(Array.isArray(data.included_week_numbers)
          ? data.included_week_numbers.map(Number).filter(Number.isFinite)
          : null);
        setAllLOs(data.all_learning_outcomes || []);
        setAllPOs(data.all_program_outcomes || []);
      }
    } catch (err) {
      console.error('Sorular yüklenemedi:', err);
    }
  };
  
  const handleExcelUpload = async (e) => {
    e.preventDefault();
    if (!excelFile) {
      setQuestionError('Lütfen bir Excel dosyası seçin');
      return;
    }
    
    setUploadingExcel(true);
    setQuestionError('');
    
    try {
      const formData = new FormData();
      formData.append('file', excelFile);
      
      const response = await apiFetch(`/instructor/exams/${selectedExam.exam_id}/questions/upload-excel`, {
        method: 'POST',
        body: formData
      });
      
      const data = await response.json();
      
      if (data.success) {
        setExcelFile(null);
        await fetchQuestions(selectedExam.exam_id);
        await fetchExams(showArchived); // Exam listesini yenile
        
        // Detaylı istatistik ve hata mesajları
        const added = data.statistics?.added || 0;
        const skipped = data.statistics?.skipped || 0;
        const total = data.statistics?.total || 0;
        const errors = data.errors || [];
        
        setUploadStatistics(data.statistics);
        setUploadErrors(errors);
        
        if (added > 0) {
          let message = `${added} soru başarıyla eklendi!`;
          if (skipped > 0) {
            message += ` ${skipped} soru atlandı.`;
          }
          setUploadSuccessMessage(message);
          
          // 5 saniye sonra mesajı kaldır
          setTimeout(() => {
            setUploadSuccessMessage('');
          }, 5000);
        } else {
          // Hiç soru eklenmediyse hata mesajı göster
          if (errors.length > 0) {
            setQuestionError(`Hiç soru eklenemedi. ${errors.length} hata bulundu.`);
          } else {
            setQuestionError('Hiç soru eklenemedi. Lütfen Excel dosyasını kontrol edin.');
          }
        }
        
        // Hata varsa mesajı temizleme (kullanıcı görebilsin)
        if (errors.length === 0) {
          setQuestionError('');
        }
      } else {
        setQuestionError(data.message || 'Excel yüklenemedi');
        setUploadErrors(data.errors || []);
        setUploadStatistics(null);
      }
    } catch (err) {
      setQuestionError('Bağlantı hatası: ' + (err.message || 'Sunucuya bağlanılamadı'));
      setUploadErrors([]);
      setUploadStatistics(null);
      console.error('Error:', err);
    } finally {
      setUploadingExcel(false);
    }
  };
  
  const saveQuestionCount = async (examId, count) => {
    try {
      const finalCount = (count === null || count === undefined || count === '') ? null : count;
      const payload = { question_count: finalCount };
      const response = await apiFetch(`/instructor/exams/${examId}/settings`, {
        method: 'PUT',
        body: JSON.stringify(payload)
      });
      const data = await response.json();
      if (data.success) {
        setUploadSuccessMessage('Ayarlar başarıyla kaydedildi!');
        // Exam listesini güncelle
        await fetchExams(showArchived, true);
        // selectedExam'i güncelle
        if (selectedExam) {
          setSelectedExam({ ...selectedExam, question_count: finalCount });
        }
        // Input'u güncelle
        setQuestionCount(finalCount);
        setQuestionCountInput(finalCount ? finalCount.toString() : '');
        return true;
      } else {
        setQuestionError(data.message || 'Ayarlar kaydedilemedi');
        return false;
      }
    } catch (err) {
      console.error('Ayarlar kaydedilemedi:', err);
      setQuestionError('Ayarlar kaydedilirken bir hata oluştu');
      return false;
    }
  };

  const saveIncludedWeekNumbers = async (weeks) => {
    if (!selectedExam) return false;
    setSavingWeekScope(true);
    try {
      const response = await apiFetch(`/instructor/exams/${selectedExam.exam_id}/settings`, {
        method: 'PUT',
        body: JSON.stringify({ included_week_numbers: weeks })
      });
      const data = await response.json();
      if (!data.success) {
        setQuestionError(data.message || 'Hafta kapsamı kaydedilemedi');
        return false;
      }
      setIncludedWeekNumbers(weeks);
      setSelectedExam((prev) => prev ? { ...prev, included_week_numbers: weeks } : prev);
      setUploadSuccessMessage(weeks === null ? 'Sınava tüm haftalar dahil edildi.' : `Sınava ${weeks.join(', ')}. hafta dahil edildi.`);
      return true;
    } catch (err) {
      setQuestionError('Hafta kapsamı kaydedilirken bağlantı hatası oluştu');
      return false;
    } finally {
      setSavingWeekScope(false);
    }
  };

  const setMandatoryByWeek = async (weekNumber, action) => {
    if (!selectedExam) return;
    const label = action === 'set' ? 'zorunlu yapmak' : 'zorunluluktan çıkarmak';
    if (!window.confirm(`${weekNumber}. haftadaki uygun soruların tümünü ${label} istediğinize emin misiniz?`)) return;
    try {
      const response = await apiFetch(`/instructor/exams/${selectedExam.exam_id}/questions/mandatory-by-week`, {
        method: 'PATCH',
        body: JSON.stringify({ week_number: weekNumber, action })
      });
      const data = await response.json();
      if (!data.success) {
        setQuestionError(data.message || 'Hafta bazlı zorunlu işlem yapılamadı');
        return;
      }
      const mandatoryIds = new Set(data.mandatory_question_ids || []);
      setQuestions((prev) => prev.map((q) => ({ ...q, is_mandatory: mandatoryIds.has(q.id) })));
      setUploadSuccessMessage(`${weekNumber}. hafta için zorunlu soru ayarı güncellendi.`);
    } catch (err) {
      setQuestionError('Hafta bazlı zorunlu işlem sırasında bağlantı hatası oluştu');
    }
  };

  const downloadExcelTemplate = async () => {
    try {
      const response = await apiFetch(`/instructor/exams/${selectedExam.exam_id}/questions/excel-template`);
      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = `soru_sablonu_${selectedExam.exam_id}.xlsx`;
      document.body.appendChild(a);
      a.click();
      window.URL.revokeObjectURL(url);
      document.body.removeChild(a);
    } catch (err) {
      console.error('Şablon indirilemedi:', err);
      alert('Şablon indirilemedi');
    }
  };
  
  const toggleMandatoryQuestion = async (questionId, exam = selectedExam) => {
    if (!exam?.exam_id) {
      alert('Sınav bilgisi bulunamadı');
      return;
    }

    try {
      console.log('Toggle mandatory for question:', questionId);
      const response = await apiFetch(`/instructor/exams/${exam.exam_id}/questions/${questionId}/toggle-mandatory`, {
        method: 'PATCH'
      });
      const data = await response.json();
      console.log('Toggle response:', data);
      if (data.success) {
        // Backend'den gelen yeni is_mandatory değerini kullan
        const newMandatoryStatus = data.is_mandatory !== undefined ? Boolean(data.is_mandatory) : false;
        console.log('Toggle response data:', data);
        console.log('New mandatory status from backend:', newMandatoryStatus);
        
        // State'i direkt güncelle (optimistic update) - ID'leri string/number karşılaştırması için
        setQuestions(prevQuestions => {
          const updated = prevQuestions.map(q => {
            const qId = String(q.id);
            const targetId = String(questionId);
            if (qId === targetId) {
              console.log(`Updating question ${q.id} with new mandatory status: ${newMandatoryStatus}`);
              return { ...q, is_mandatory: newMandatoryStatus };
            }
            return q;
          });
          return updated;
        });

        // Puanlama önizlemesi açıksa zorunlu listesini de anında güncelle.
        setPreviewQuestions(prevQuestions => prevQuestions.map(q =>
          String(q.id) === String(questionId)
            ? { ...q, is_mandatory: newMandatoryStatus, score: newMandatoryStatus ? q.score : null }
            : q
        ));
        if (!newMandatoryStatus) {
          setPreviewPointInputs(prev => {
            const next = { ...prev };
            delete next[questionId];
            return next;
          });
        }
        setPointsSaved(false);
        
        // fetchQuestions çağırma - optimistic update yeterli, backend zaten güncellendi
        // Eğer sayfa yenilenirse veya modal tekrar açılırsa backend'den doğru değer gelecek
      } else {
        alert(data.message || 'Zorunlu soru durumu güncellenemedi');
      }
    } catch (err) {
      console.error('Error:', err);
      alert('Bağlantı hatası');
    }
  };

  const removeMandatoryQuestionFromPreview = (question) => {
    if (!previewExam || !question?.id) return;
    const confirmed = window.confirm('Bu soruyu zorunlu soru listesinden çıkarmak istiyor musunuz? Soru havuzda kalacaktır.');
    if (confirmed) {
      toggleMandatoryQuestion(question.id, previewExam);
    }
  };
  
  const deleteQuestion = async (questionId) => {
    if (!window.confirm('Bu soruyu silmek istediğinize emin misiniz?')) {
      return;
    }
    
    try {
      const response = await apiFetch(`/instructor/exams/${selectedExam.exam_id}/questions/${questionId}`, {
        method: 'DELETE'
      });
      const data = await response.json();
      if (data.success) {
        await fetchQuestions(selectedExam.exam_id);
        await fetchExams(showArchived); // Exam listesini yenile
      } else {
        alert(data.message || 'Soru silinemedi');
      }
    } catch (err) {
      console.error('Error:', err);
      alert('Bağlantı hatası');
    }
  };

  const openPreviewModal = async (exam) => {
    console.log('Önizleme açılıyor:', exam);
    setPreviewExam(exam);
    setLoadingPreview(true);
    setCurrentPage('preview');
    setPageData({ exam });
    
    try {
      // Ayarları getir
      const settingsResponse = await apiFetch(`/instructor/exams/${exam.exam_id}/settings`);
      const settingsData = await settingsResponse.json();
      if (settingsData.success) {
        setPreviewSettings(settingsData.settings);
      } else {
        setPreviewSettings({ max_attempts: 1, shuffle_type: 'none', auto_save: true });
      }
      
      // Soruları getir
      const questionsResponse = await apiFetch(`/instructor/exams/${exam.exam_id}/questions`);
      const questionsData = await questionsResponse.json();
      if (questionsData.success) {
        setPreviewQuestions(questionsData.questions || []);
      } else {
        setPreviewQuestions([]);
      }

      // Mevcut soru puanlarını getir
      try {
        const pointsResponse = await apiFetch(`/instructor/exams/${exam.exam_id}/question-points`);
        const pointsData = await pointsResponse.json();
        if (pointsData.success) {
          const init = {};
          pointsData.points.forEach(p => { init[p.question_id] = String(p.points); });
          setPreviewPointInputs(init);
          setPointsSaved(pointsData.all_questions_have_points);
          setTotalPreviewPoints(pointsData.total_points);
          setMcQuestionCount(pointsData.mc_question_count != null ? String(pointsData.mc_question_count) : '');
          setMcQuestionPoints(pointsData.mc_question_points != null ? String(pointsData.mc_question_points) : '');
          setClassicQuestionCount(pointsData.classic_question_count != null ? String(pointsData.classic_question_count) : '');
          setClassicQuestionPoints(pointsData.classic_question_points != null ? String(pointsData.classic_question_points) : '');
          if (pointsData.all_questions_have_points) {
            setExamsWithPoints(prev => new Set([...prev, exam.exam_id]));
          }
        } else {
          setPreviewPointInputs({});
          setPointsSaved(false);
          setTotalPreviewPoints(0);
          setMcQuestionCount('');
          setMcQuestionPoints('');
          setClassicQuestionCount('');
          setClassicQuestionPoints('');
        }
      } catch (err) {
        console.error('Soru puanları yüklenemedi:', err);
        setPreviewPointInputs({});
        setPointsSaved(false);
        setTotalPreviewPoints(0);
      }
    } catch (err) {
      console.error('Önizleme verileri yüklenemedi:', err);
      setPreviewSettings({ max_attempts: 1, shuffle_type: 'none', auto_save: true });
      setPreviewQuestions([]);
    } finally {
      setLoadingPreview(false);
    }
  };

  const saveCorrectAnswerInExams = async (questionId, examId) => {
    const selectedAnswer = correctAnswerEdits[questionId];
    if (!selectedAnswer) {
      alert('Lütfen doğru cevabı seçin');
      return;
    }
    try {
      setSavingCorrectAnswer(prev => ({ ...prev, [questionId]: true }));
      const response = await apiFetch(
        `/instructor/exams/${examId}/questions/${questionId}/set-correct-answer`,
        { method: 'POST', body: JSON.stringify({ correct_answer: selectedAnswer }) }
      );
      const data = await response.json();
      if (data.success) {
        alert(data.message || 'Doğru cevap kaydedildi');
        setCorrectAnswerEdits(prev => { const next = { ...prev }; delete next[questionId]; return next; });
        // previewQuestions içindeki sorunun correct_answer'ını güncelle
        setPreviewQuestions(prev => prev.map(q =>
          q.id === questionId ? { ...q, correct_answer: selectedAnswer } : q
        ));
      } else {
        alert(data.message || 'Doğru cevap kaydedilemedi');
      }
    } catch (err) {
      alert(err.message || 'Bağlantı hatası');
    } finally {
      setSavingCorrectAnswer(prev => ({ ...prev, [questionId]: false }));
    }
  };

  const handleSavePoints = async () => {
    setSavingPoints(true);
    try {
      const mandatoryQs = previewQuestions.filter(q => q.is_mandatory);
      const getMandatoryPts = (q) => {
        if (previewPointInputs[q.id] !== undefined) return parseFloat(previewPointInputs[q.id] || 0);
        if (q.score !== null && q.score !== undefined) return parseFloat(q.score);
        return 0;
      };
      const payload = {
        points: mandatoryQs.map(q => ({
          question_id: q.id,
          points: getMandatoryPts(q)
        })),
        mc_question_count: mcQuestionCount !== '' ? parseInt(mcQuestionCount) : null,
        mc_question_points: mcQuestionPoints !== '' ? parseFloat(mcQuestionPoints) : null,
        classic_question_count: classicQuestionCount !== '' ? parseInt(classicQuestionCount) : null,
        classic_question_points: classicQuestionPoints !== '' ? parseFloat(classicQuestionPoints) : null,
      };
      const res = await apiFetch(`/instructor/exams/${previewExam.exam_id}/question-points`, {
        method: 'PUT',
        body: JSON.stringify(payload)
      });
      const data = await res.json();
      if (data.success) {
        setPointsSaved(true);
        setTotalPreviewPoints(data.total_points);
        setExamsWithPoints(prev => new Set([...prev, previewExam.exam_id]));
        setToastMessage('Puanlar başarıyla kaydedildi');
        setToastType('success');
      } else {
        setToastMessage(data.message || 'Puanlar kaydedilemedi');
        setToastType('error');
      }
      setTimeout(() => setToastMessage(''), 3000);
    } catch (err) {
      console.error('Puan kaydetme hatası:', err);
      setToastMessage('Bağlantı hatası');
      setToastType('error');
      setTimeout(() => setToastMessage(''), 3000);
    } finally {
      setSavingPoints(false);
    }
  };

  const openEditExamModal = async (exam) => {
    setEditingExam(exam);
    const courseId = exam.course_id || '';
    
    // Ayarları da getir
    let examSettings = {
      max_attempts: 1,
      shuffle_type: 'none',
      auto_save: true
    };
    
    try {
      const response = await apiFetch(`/instructor/exams/${exam.exam_id}/settings`);
      const data = await response.json();
      if (data.success) {
        examSettings = data.settings;
      }
    } catch (err) {
      console.error('Ayarlar yüklenemedi:', err);
    }
    
    setFormData({
      course_id: courseId,
      title: exam.title || '',
      mode: exam.mode || 'Online',
      type: exam.type || 'Mixed', // Sınav türü artık otomatik belirleniyor
      exam_category: exam.exam_category || '',
      exam_weight_id: exam.exam_weight_id || null,
      exam_effect: exam.exam_effect || null,
      status: exam.status || 'Draft',
      start_at: exam.start_at ? utcToLocalDateTime(exam.start_at) : '',
      end_at: exam.end_at ? utcToLocalDateTime(exam.end_at) : '',
      duration_minutes: exam.duration_minutes || '',
      entrance_confirmation: exam.entrance_confirmation || DEFAULT_ENTRANCE_CONFIRMATION,
      finish_confirmation: exam.finish_confirmation || 'Sınavı tamamladım ve tüm cevaplarımın doğru olduğunu onaylıyorum. Sınavı teslim etmek istiyorum.',
      max_attempts: examSettings.max_attempts || 1,
      shuffle_type: examSettings.shuffle_type || 'none',
      auto_save: true,
      session_count: exam.session_count || 1,
      students_per_session: exam.students_per_session || '',
      session_1_start_at: exam.session_1_start_at ? utcToLocalDateTime(exam.session_1_start_at) : '',
      session_1_end_at: exam.session_1_end_at ? utcToLocalDateTime(exam.session_1_end_at) : '',
      session_2_start_at: exam.session_2_start_at ? utcToLocalDateTime(exam.session_2_start_at) : '',
      session_2_end_at: exam.session_2_end_at ? utcToLocalDateTime(exam.session_2_end_at) : ''
    });
    
    // Düzenleme modunda otomatik modu kapat (manuel düzenleme için)
    setAutoEndDateEnabled(false);
    setSelectedDuration(null);
    
    // Exam weights'leri yükle (düzenleme modunda mevcut exam_weight_id'yi koru)
    if (courseId) {
      await fetchExamWeights(parseInt(courseId), exam.exam_weight_id);
    }
    
    setShowCreateForm(true);
  };
  
  // Ek Süre modal fonksiyonları
  const openExtendTimeModal = async (exam) => {
    setSelectedExamForExtend(exam);
    setCurrentPage('extend-time');
    setPageData({ exam });
    await fetchExamStudents(exam.exam_id);
  };

  const openViolationsPage = async (exam) => {
    setViolationSessionFilter(null);
    setViolationSearch('');
    setSelectedExamForViolations(exam);
    setCurrentPage('violations');
    setPageData({ exam });
    await fetchExamStudents(exam.exam_id);
  };

  const handleGrantReEntry = async (attemptId) => {
    if (!window.confirm('Bu öğrenciye tekrar sınav girişi hakkı verilecek. Önceki cevapları korunacak ve sınavına devam edebilecek. Emin misiniz?')) return;
    try {
      const res = await apiFetch(`/instructor/exams/${selectedExamForViolations.exam_id}/attempts/${attemptId}/grant-reentry`, { method: 'POST' });
      const data = await res.json();
      if (data.success) {
        await fetchExamStudents(selectedExamForViolations.exam_id);
      } else {
        alert(data.message || 'İşlem başarısız oldu');
      }
    } catch (err) {
      alert('Bağlantı hatası oluştu');
    }
  };

  const fetchExamStudents = async (examId, silent = false) => {
    try {
      if (!silent) {
        setLoadingStudents(true);
      }
      const response = await apiFetch(`/instructor/exams/${examId}/students`);
      const data = await response.json();

      if (data.success) {
        setExamStudents(data.students || []);
        setExamSessionCount(data.session_count || 1);
        setExamAllowedStudentNos(data.allowed_student_nos || null);
      } else {
        if (!silent) {
          alert(data.message || 'Öğrenciler yüklenemedi');
        }
        setExamStudents([]);
        setExamSessionCount(1);
        setExamAllowedStudentNos(null);
      }
    } catch (err) {
      console.error('Öğrenciler yüklenemedi:', err);
      if (!silent) {
        alert('Bağlantı hatası');
      }
      setExamStudents([]);
      setExamSessionCount(1);
      setExamAllowedStudentNos(null);
    } finally {
      if (!silent) {
        setLoadingStudents(false);
      }
    }
  };

  const fetchExamScoreSummary = async (examId, silent = false) => {
    try {
      if (!silent) {
        setLoadingExamScores(true);
      }
      const response = await apiFetch(`/instructor/exams/${examId}/students`);
      const data = await response.json();
      if (data.success) {
        setExamScoreStudents(data.students || []);
      } else {
        if (!silent) {
          alert(data.message || 'Öğrenci not listesi yüklenemedi');
        }
        setExamScoreStudents([]);
      }
    } catch (err) {
      console.error('Öğrenci not listesi yüklenemedi:', err);
      if (!silent) {
        alert('Bağlantı hatası');
      }
      setExamScoreStudents([]);
    } finally {
      if (!silent) {
        setLoadingExamScores(false);
      }
    }
  };

  const fetchExamStatistics = async (examId, silent = false) => {
    try {
      const [statsResponse, topResponse, bottomResponse] = await Promise.all([
        apiFetch(`/instructor/exams/${examId}/statistics`),
        apiFetch(`/instructor/exams/${examId}/statistics/rankings?type=top&limit=5`),
        apiFetch(`/instructor/exams/${examId}/statistics/rankings?type=bottom&limit=5`)
      ]);
      const statsData = await statsResponse.json();
      const topData = await topResponse.json();
      const bottomData = await bottomResponse.json();

      if (statsData.success) {
        setExamStatistics(statsData.statistics || null);
      } else {
        if (!silent) alert(statsData.message || 'Sınav istatistikleri yüklenemedi');
        setExamStatistics(null);
      }

      setTopRankings(topData.success ? (topData.students || []) : []);
      setBottomRankings(bottomData.success ? (bottomData.students || []) : []);
    } catch (err) {
      console.error('Sınav istatistikleri yüklenemedi:', err);
      if (!silent) alert('Sınav istatistikleri yüklenirken bağlantı hatası oluştu');
      setExamStatistics(null);
      setTopRankings([]);
      setBottomRankings([]);
    }
  };

  const openExamScoreSummary = async (exam) => {
    setSelectedExamForScores(exam);
    setCurrentPage('exam-statistics');
    await Promise.all([
      fetchExamScoreSummary(exam.exam_id),
      fetchExamStatistics(exam.exam_id)
    ]);
  };

  const openCourseStatisticsPage = async (course) => {
    const cid = String(course.course_id);
    setSelectedCourseId(cid);
    if (activeCourseContext) activeCourseContext.setActiveCourseId(cid);
    setSelectedCourseForStats(course);
    setCurrentPage('exam-statistics');

    const courseExams = [...exams, ...archivedExams].filter(
      (exam) => String(exam.course_id) === cid
    );

    if (courseExams.length === 0) {
      setSelectedExamForScores(null);
      setExamScoreStudents([]);
      setExamStatistics(null);
      setTopRankings([]);
      setBottomRankings([]);
      return;
    }

    await openExamScoreSummary(courseExams[0]);
  };
  
  const extendTime = async (attemptId, minutes) => {
    if (!selectedExamForExtend) return;
    
    try {
      const response = await apiFetch(
        `/instructor/exams/${selectedExamForExtend.exam_id}/attempts/${attemptId}/extend-time`,
        {
          method: 'PATCH',
          body: JSON.stringify({ minutes })
        }
      );
      
      const data = await response.json();
      
      if (data.success) {
        setToastMessage(data.message || `Öğrenciye ${minutes} dakika ekstra süre verildi`);
        setToastType('success');
        setTimeout(() => setToastMessage(''), 3000);
        // Listeyi yenile
        await fetchExamStudents(selectedExamForExtend.exam_id);
      } else {
        setToastMessage(data.message || 'Ekstra süre verilemedi');
        setToastType('error');
        setTimeout(() => setToastMessage(''), 3000);
      }
    } catch (err) {
      console.error('Error:', err);
      setToastMessage('Bağlantı hatası');
      setToastType('error');
      setTimeout(() => setToastMessage(''), 3000);
    }
  };
  
  const downloadGradesExcel = async (exam) => {
    try {
      const response = await apiFetch(`/instructor/exams/${exam.exam_id}/grades/excel`);
      if (!response.ok) {
        const data = await response.json();
        alert(data.message || 'Not listesi indirilemedi');
        return;
      }
      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = 'NotYuklemeExceli.xlsx';
      document.body.appendChild(a);
      a.click();
      window.URL.revokeObjectURL(url);
      document.body.removeChild(a);
    } catch (err) {
      alert('Not listesi indirilemedi');
    }
  };

  // Sonuçları yayınlama fonksiyonu
  const handlePublishResultsClick = (exam) => {
    setPublishResultsExam(exam);
    setShowPublishResultsModal(true);
  };
  
  const publishResults = async () => {
    if (!publishResultsExam) return;
    
    try {
      setPublishing(true);
      setPublishingExamId(publishResultsExam.exam_id);
      const response = await apiFetch(
        `/instructor/exams/${publishResultsExam.exam_id}/publish-results`,
        {
          method: 'POST'
        }
      );

      const data = await response.json();
      if (data.success) {
        setShowPublishResultsModal(false);
        setPublishResultsExam(null);
        setToastMessage('Sonuçlar başarıyla yayınlandı');
        setToastType('success');
        setTimeout(() => setToastMessage(''), 3000);
        // Sınav listelerini yenile (arşivlenmiş liste de dahil)
        await Promise.all([fetchExams(showArchived), fetchArchivedExams()]);
      } else {
        setToastMessage(data.message || 'Sonuçlar yayınlanamadı');
        setToastType('error');
        setTimeout(() => setToastMessage(''), 3000);
      }
    } catch (err) {
      console.error('Error:', err);
      setToastMessage('Bağlantı hatası');
      setToastType('error');
      setTimeout(() => setToastMessage(''), 3000);
    } finally {
      setPublishing(false);
      setPublishingExamId(null);
    }
  };
  
  const cancelPublishResults = () => {
    setShowPublishResultsModal(false);
    setPublishResultsExam(null);
  };
  
  // Status güncelleme fonksiyonları
  const handlePublishClick = (exam) => {
    setPendingStatusAction('publish');
    setPendingExamId(exam.exam_id);
    setShowStatusConfirmModal(true);
  };
  
  const handleDraftClick = (exam) => {
    setPendingStatusAction('draft');
    setPendingExamId(exam.exam_id);
    setShowStatusConfirmModal(true);
  };
  
  const confirmStatusChange = async () => {
    if (!pendingExamId || !pendingStatusAction) return;
    
    setUpdatingStatus(true);
    try {
      const newStatus = pendingStatusAction === 'publish' ? 'Published' : 'Draft';
      
      const response = await apiFetch(`/instructor/exams/${pendingExamId}`, {
        method: 'PUT',
        body: JSON.stringify({ status: newStatus })
      });
      
      const data = await response.json();
      
      if (data.success) {
        setShowStatusConfirmModal(false);
        setPendingStatusAction(null);
        setPendingExamId(null);
        await fetchExams(showArchived);
        setToastMessage(newStatus === 'Published' ? 'Sınav başarıyla yayınlandı' : 'Sınav taslağa çevrildi');
        setToastType('success');
        setTimeout(() => setToastMessage(''), 3000);
      } else {
        setToastMessage(data.message || 'Durum güncellenemedi');
        setToastType('error');
        setTimeout(() => setToastMessage(''), 3000);
      }
    } catch (err) {
      console.error('Status güncelleme hatası:', err);
      setToastMessage('Durum güncellenirken bir hata oluştu');
      setToastType('error');
      setTimeout(() => setToastMessage(''), 3000);
    } finally {
      setUpdatingStatus(false);
    }
  };
  
  const cancelStatusChange = () => {
    setShowStatusConfirmModal(false);
    setPendingStatusAction(null);
    setPendingExamId(null);
  };
  
  // Silme fonksiyonları
  const handleDeleteClick = (exam) => {
    setPendingDeleteExamId(exam.exam_id);
    setPendingDeleteExamTitle(exam.title);
    setShowDeleteConfirmModal(true);
  };
  
  const confirmDelete = async () => {
    if (!pendingDeleteExamId) return;
    
    setDeleting(true);
    try {
      const response = await apiFetch(`/instructor/exams/${pendingDeleteExamId}`, {
        method: 'DELETE'
      });
      
      const data = await response.json();
      
      if (data.success) {
        setShowDeleteConfirmModal(false);
        setPendingDeleteExamId(null);
        setPendingDeleteExamTitle(null);
        await fetchExams(showArchived);
        await fetchArchivedExams();
        setToastMessage('Sınav başarıyla silindi');
        setToastType('success');
        setTimeout(() => setToastMessage(''), 3000);
      } else {
        setToastMessage(data.message || 'Sınav silinemedi');
        setToastType('error');
        setTimeout(() => setToastMessage(''), 3000);
      }
    } catch (err) {
      console.error('Silme hatası:', err);
      setToastMessage('Sınav silinirken bir hata oluştu');
      setToastType('error');
      setTimeout(() => setToastMessage(''), 3000);
    } finally {
      setDeleting(false);
    }
  };
  
  const cancelDelete = () => {
    setShowDeleteConfirmModal(false);
    setPendingDeleteExamId(null);
    setPendingDeleteExamTitle(null);
  };

  const handleToggleArchive = () => {
    const newShowArchived = !showArchived;
    setShowArchived(newShowArchived);
    fetchExams(newShowArchived);
  };

  const formatQuestionDate = (dateStr) => {
    if (!dateStr) return '';
    return new Date(dateStr).toLocaleDateString('tr-TR', { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' });
  };

  // Hafta bazlı filtreleme: 'all' | 'none' | '<weekNumber>'
  const getFilteredQuestions = (allQuestions, filter) => {
    const list = allQuestions || [];
    if (filter === 'all' || !filter) return list;
    if (filter === 'none') return list.filter(q => q.week_number == null);
    return list.filter(q => q.week_number != null && String(q.week_number) === String(filter));
  };

  const getAvailableWeeks = (allQuestions) => {
    const weeks = Array.from(new Set(
      (allQuestions || []).map(q => q.week_number).filter(w => w != null)
    )).sort((a, b) => a - b);
    const hasUnassigned = (allQuestions || []).some(q => q.week_number == null);
    return { weeks, hasUnassigned };
  };

  // Sayfa render fonksiyonları
  const renderQuestionManagementPage = () => {
    return (
      <div className="dashboard-section">
        <div className="page-header">
          <button className="back-button" onClick={() => {
            setCurrentPage(null);
            setPageData(null);
            setSelectedExam(null);
            setQuestionError('');
            setUploadErrors([]);
            setUploadStatistics(null);
            setUploadSuccessMessage('');
            setExcelFile(null);
            fetchExams(showArchived);
          }}>
            ← Geri Dön
          </button>
          <h2>{selectedExam?.title} - Sorular</h2>
        </div>
        <div className="page-content" style={{ padding: '2rem', maxWidth: '100%', width: '100%' }}>
          {questionError && (
            <div className="alert alert-error" style={{
              marginBottom: '1rem',
              padding: '0.85rem 1rem',
              backgroundColor: '#fdecee',
              color: '#721c24',
              borderRadius: '10px',
              border: '1px solid #f5c2c7',
              fontSize: '0.92rem',
              fontWeight: '500'
            }}>
              <strong>⚠️ Hata:</strong> {questionError}
            </div>
          )}

          {/* Özet kart: havuz / sınavda / zorunlu + soru sayısı kaydı */}
          {(() => {
            const mandatoryCount = questions.filter(q => q.is_mandatory).length;
            const availableWeekNumbers = Array.from(new Set(
              questions.map((q) => q.week_number).filter((week) => week != null)
            )).sort((a, b) => a - b);
            const scopedQuestions = includedWeekNumbers === null
              ? questions
              : questions.filter((q) => includedWeekNumbers.includes(Number(q.week_number)));
            const scopedQuestionCount = scopedQuestions.length;
            const isDisabled = scopedQuestionCount === 0;
            return (
              <div className="qm-summary">
                <div className="qm-summary-stats">
                  <div className="qm-stat">
                    <span className="qm-stat-label">Sınav Havuzu</span>
                    <span className="qm-stat-value">{scopedQuestionCount} <span style={{ fontSize: '0.85rem', fontWeight: 500, color: '#6c757d' }}>soru</span></span>
                  </div>
                  <div className="qm-stat-divider" />
                  <div className="qm-stat">
                    <span className="qm-stat-label">Sınavda Sorulacak</span>
                    <span className={`qm-stat-value ${questionCount ? 'success' : 'muted'}`}>
                      {questionCount ? questionCount : '—'}
                      {questionCount && <span style={{ fontSize: '0.85rem', fontWeight: 500, color: '#6c757d' }}>soru</span>}
                    </span>
                  </div>
                  <div className="qm-stat-divider" />
                  <div className="qm-stat">
                    <span className="qm-stat-label">Zorunlu</span>
                    <span className={`qm-stat-value ${mandatoryCount > 0 ? 'success' : 'warn'}`}>
                      {mandatoryCount}
                    </span>
                  </div>
                </div>
                <div className="qm-summary-action">
                  <label htmlFor="qm-count-input">Sınavda</label>
                  <input
                    id="qm-count-input"
                    type="text"
                    inputMode="numeric"
                    className="qm-count-input"
                    value={questionCountInput}
                    disabled={isDisabled}
                    onChange={(e) => {
                      const value = e.target.value;
                      if (value === '' || /^\d+$/.test(value)) {
                        setQuestionCountInput(value);
                      }
                    }}
                    onBlur={(e) => {
                      const value = e.target.value;
                      if (value !== '') {
                        const num = parseInt(value, 10);
                        if (isNaN(num) || num < 1 || num > scopedQuestionCount) {
                          setQuestionCountInput(questionCount ? questionCount.toString() : '');
                        } else {
                          setQuestionCount(num);
                        }
                      } else {
                        setQuestionCount(null);
                      }
                    }}
                    placeholder={isDisabled ? '—' : `1–${scopedQuestionCount}`}
                  />
                  <span className="qm-count-suffix">/ {scopedQuestionCount}</span>
                  <button
                    type="button"
                    className="qm-btn qm-btn-primary"
                    disabled={isDisabled}
                    onClick={async () => {
                      if (selectedExam && scopedQuestionCount > 0) {
                        const num = parseInt(questionCountInput, 10);
                        const finalCount = !isNaN(num) && num > 0 && num <= scopedQuestionCount ? num : null;
                        const success = await saveQuestionCount(selectedExam.exam_id, finalCount);
                        if (success) {
                          setQuestionCount(finalCount);
                          setQuestionCountInput(finalCount ? finalCount.toString() : '');
                        }
                      }
                    }}
                  >
                    Kaydet
                  </button>
                </div>
                {availableWeekNumbers.length > 0 && (
                  <div style={{ width: '100%', marginTop: '1rem', borderTop: '1px solid #e2e8f0', paddingTop: '0.85rem' }}>
                    <div style={{ fontSize: '0.85rem', fontWeight: 700, color: '#475569', marginBottom: '0.5rem' }}>Sınava dahil edilecek haftalar</div>
                    <div style={{ display: 'flex', flexWrap: 'wrap', gap: '0.5rem', alignItems: 'center' }}>
                      <button type="button" className={`qm-btn ${includedWeekNumbers === null ? 'qm-btn-primary' : 'qm-btn-ghost'}`} disabled={savingWeekScope} onClick={() => saveIncludedWeekNumbers(null)}>Tüm haftalar</button>
                      {availableWeekNumbers.map((week) => {
                        const selected = Array.isArray(includedWeekNumbers) && includedWeekNumbers.includes(Number(week));
                        return <button key={week} type="button" className={`qm-btn ${selected ? 'qm-btn-primary' : 'qm-btn-ghost'}`} disabled={savingWeekScope} onClick={() => {
                          const next = selected
                            ? includedWeekNumbers.filter((item) => Number(item) !== Number(week))
                            : [...(includedWeekNumbers || []), Number(week)].sort((a, b) => a - b);
                          if (!next.length) return;
                          saveIncludedWeekNumbers(next);
                        }}>{week}. Hafta</button>;
                      })}
                    </div>
                    <div style={{ marginTop: '0.45rem', fontSize: '0.8rem', color: '#64748b' }}>Seçilen haftaların dışındaki sorular öğrenciye gönderilmez.</div>
                  </div>
                )}
              </div>
            );
          })()}

          {/* Toolbar: başlık, filtre, tümünü sil */}
          <div className="qm-toolbar">
            <h4 className="qm-toolbar-title">
              Mevcut Sorular
              <span className="count-pill">{questions.length}</span>
            </h4>
          </div>

          {(() => {
            const incompleteQuestions = (questions || []).filter(q =>
              (!q.is_pretest && q.week_number == null) ||
              !(Array.isArray(q.learning_outcomes) && q.learning_outcomes.length > 0) ||
              !(Array.isArray(q.program_outcomes) && q.program_outcomes.length > 0)
            );
            const missingWeekCount = incompleteQuestions.filter(q => !q.is_pretest && q.week_number == null).length;
            const missingLoCount = incompleteQuestions.filter(q => !(Array.isArray(q.learning_outcomes) && q.learning_outcomes.length > 0)).length;
            const missingPoCount = incompleteQuestions.filter(q => !(Array.isArray(q.program_outcomes) && q.program_outcomes.length > 0)).length;
            if (incompleteQuestions.length === 0) return null;
            const reasonParts = [
              missingWeekCount > 0 ? `${missingWeekCount} hafta` : null,
              missingLoCount > 0 ? `${missingLoCount} ÖÇ` : null,
              missingPoCount > 0 ? `${missingPoCount} PÇ` : null,
            ].filter(Boolean);
            return (
              <div className="qm-unmapped-banner">
                <span>⚠</span>
                <span>
                  <strong>{incompleteQuestions.length}</strong> soruda eksik bilgi var ({reasonParts.join(', ')} eksik).
                  Bu sorular sınavda sorulamaz ve zorunlu yapılamaz. Tamamlamak için <strong>Sorular</strong> ekranını kullanın.
                </span>
              </div>
            );
          })()}

          {(() => {
            const renderQuestionCard = (q, index) => {
              const isMandatory = Boolean(q.is_mandatory);
              const unmapped =
                (!q.is_pretest && q.week_number == null) ||
                !(Array.isArray(q.learning_outcomes) && q.learning_outcomes.length > 0) ||
                !(Array.isArray(q.program_outcomes) && q.program_outcomes.length > 0);
              const missingParts = [
                !q.is_pretest && q.week_number == null ? 'Hafta' : null,
                !(Array.isArray(q.learning_outcomes) && q.learning_outcomes.length > 0) ? 'ÖÇ' : null,
                !(Array.isArray(q.program_outcomes) && q.program_outcomes.length > 0) ? 'PÇ' : null,
              ].filter(Boolean);
              const incompleteLabel = `${missingParts.join(' / ')} eksik`;
              return (
                <div key={q.id} className={`qm-card ${isMandatory ? 'is-mandatory' : ''} ${unmapped ? 'is-unmapped' : ''}`}>
                  <div className="qm-card-header">
                    <div className="qm-card-title">
                      <span className="qm-card-no">{index + 1}</span>
                      <span>Soru</span>
                      {q.created_at && (
                        <span className="qm-card-meta">{formatQuestionDate(q.created_at)}</span>
                      )}
                      {isMandatory && <span className="qm-mandatory-pill">★ Zorunlu</span>}
                      {unmapped && (
                        <span
                          className="qm-unmapped-pill"
                          title={`${incompleteLabel}. Bu soru sınavda sorulamaz; önce Sorular ekranından tamamlayın.`}
                        >
                          ⚠ {incompleteLabel}
                        </span>
                      )}
                    </div>
                    <div className="qm-card-actions">
                      <button
                        type="button"
                        className={`qm-btn ${isMandatory ? 'qm-btn-ghost active' : 'qm-btn-ghost'}`}
                        onClick={() => toggleMandatoryQuestion(q.id)}
                        disabled={unmapped && !isMandatory}
                        title={
                          unmapped && !isMandatory
                            ? `Soru zorunlu yapılamaz (${incompleteLabel})`
                            : (isMandatory ? 'Zorunlu sorudan çıkar' : 'Zorunlu yap')
                        }
                      >
                        {isMandatory ? '★ Kaldır' : '☆ Zorunlu Yap'}
                      </button>
                      <button
                        type="button"
                        className="qm-btn qm-btn-danger-soft"
                        onClick={() => deleteQuestion(q.id)}
                        title="Soruyu sil"
                      >
                        Sil
                      </button>
                    </div>
                  </div>

                  <p className="qm-card-text">
                    {q.question_text
                      ? <MathText text={q.question_text} />
                      : <span style={{ color: '#6c757d', fontStyle: 'italic' }}>Soru metni girilmemiş</span>}
                  </p>

                  {q.image_url && (() => {
                    const imageSrc = resolveMediaUrl(q.image_url);
                    return (
                      <div style={{ margin: '8px 0 14px', textAlign: 'center' }}>
                        <img
                          src={imageSrc}
                          alt="Soru görseli"
                          style={{
                            display: 'inline-block',
                            maxWidth: '100%',
                            maxHeight: 360,
                            objectFit: 'contain',
                            borderRadius: 8,
                            border: '1px solid #e2e8f0',
                            cursor: 'zoom-in'
                          }}
                          onClick={() => window.open(imageSrc, '_blank')}
                        />
                      </div>
                    );
                  })()}

                  {q.question_type === 'Classic' && q.correct_answer && (
                    <div className="qm-correct-banner">
                      <strong>Doğru Cevap:</strong>
                      <span><MathText text={String(q.correct_answer)} /></span>
                    </div>
                  )}

                  {(q.question_type === 'MultipleChoice' || !q.question_type || q.question_type === '') && (
                    <div className="qm-options">
                      {['A', 'B', 'C', 'D', 'E'].map(opt => {
                        const optionValue = q[`option_${opt.toLowerCase()}`];
                        if (!optionValue) return null;

                        let isCorrect = false;
                        if (q.correct_answer) {
                          const correctAnswerStr = String(q.correct_answer).trim().toUpperCase();
                          if (correctAnswerStr.length === 1 && ['A','B','C','D','E'].includes(correctAnswerStr)) {
                            isCorrect = correctAnswerStr === opt;
                          } else if (correctAnswerStr.startsWith('OPTION_')) {
                            const optionLetter = correctAnswerStr.replace('OPTION_', '').charAt(0);
                            isCorrect = optionLetter === opt;
                          } else {
                            isCorrect = (optionValue || '').trim().toLowerCase() === String(q.correct_answer).trim().toLowerCase();
                          }
                        }
                        return (
                          <div key={opt} className={`qm-option ${isCorrect ? 'correct' : ''}`}>
                            <span className="qm-option-letter">{opt}</span>
                            <span className="qm-option-text">
                              <MathText text={optionValue} />
                              {isCorrect && <span className="qm-option-correct-mark">✓ Doğru</span>}
                            </span>
                          </div>
                        );
                      })}
                    </div>
                  )}
                </div>
              );
            };

            if (!questions || questions.length === 0) {
              return <div className="qm-empty">Henüz soru eklenmemiş</div>;
            }

            const { weeks, hasUnassigned } = getAvailableWeeks(questions);
            const groups = [
              ...weeks.map(w => ({
                key: String(w),
                label: `${w}. Hafta`,
                items: questions.filter(q => q.week_number === w),
              })),
              ...(hasUnassigned ? [{
                key: 'none',
                label: 'Hafta atanmamış',
                items: questions.filter(q => q.week_number == null),
              }] : []),
            ];

            // Hiç hafta yoksa düz liste
            if (weeks.length === 0) {
              return (
                <div className="qm-questions-list">
                  {questions.map((q, i) => renderQuestionCard(q, i))}
                </div>
              );
            }

            return (
              <div style={{ display: 'flex', flexDirection: 'column', gap: '0.75rem' }}>
                {groups.map(g => {
                  const open = expandedWeek === g.key;
                  const mandatoryInGroup = g.items.filter(q => q.is_mandatory).length;
                  return (
                    <div
                      key={g.key}
                      style={{
                        border: '1px solid #dee2e6',
                        borderRadius: '12px',
                        background: '#fff',
                        overflow: 'hidden',
                        boxShadow: open ? '0 2px 8px rgba(40,167,69,0.08)' : 'none',
                        transition: 'box-shadow 0.15s ease',
                      }}
                    >
                      <button
                        type="button"
                        onClick={() => setExpandedWeek(open ? null : g.key)}
                        style={{
                          width: '100%',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'space-between',
                          gap: '1rem',
                          padding: '1rem 1.25rem',
                          background: open ? '#f1f8f4' : '#f8f9fa',
                          border: 'none',
                          borderBottom: open ? '1px solid #dee2e6' : 'none',
                          cursor: 'pointer',
                          fontSize: '1rem',
                          fontWeight: 600,
                          color: '#212529',
                          textAlign: 'left',
                        }}
                      >
                        <span style={{ display: 'flex', alignItems: 'center', gap: '0.75rem' }}>
                          <span style={{
                            display: 'inline-flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            width: '28px',
                            height: '28px',
                            borderRadius: '50%',
                            background: open ? '#28a745' : '#e9ecef',
                            color: open ? '#fff' : '#495057',
                            fontSize: '0.85rem',
                            fontWeight: 700,
                            transition: 'all 0.15s ease',
                          }}>{open ? '−' : '+'}</span>
                          {g.label}
                        </span>
                        <span style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', fontSize: '0.875rem', fontWeight: 500, color: '#6c757d' }}>
                          {mandatoryInGroup > 0 && (
                            <span style={{
                              background: '#fff3cd',
                              color: '#856404',
                              padding: '0.15rem 0.5rem',
                              borderRadius: '999px',
                              fontSize: '0.75rem',
                              fontWeight: 600,
                            }}>★ {mandatoryInGroup}</span>
                          )}
                          <span style={{
                            background: '#e9ecef',
                            color: '#495057',
                            padding: '0.15rem 0.6rem',
                            borderRadius: '999px',
                            fontSize: '0.8rem',
                            fontWeight: 600,
                          }}>{g.items.length} soru</span>
                        </span>
                      </button>
                      {g.key !== 'none' && (
                        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '0.5rem', padding: '0.65rem 1.25rem', borderBottom: open ? '1px solid #e9ecef' : 'none', background: '#fff' }}>
                          <button type="button" className="qm-btn qm-btn-ghost" onClick={() => setMandatoryByWeek(Number(g.key), 'clear')} disabled={mandatoryInGroup === 0}>Haftanın zorunlularını kaldır</button>
                          <button type="button" className="qm-btn qm-btn-primary" onClick={() => setMandatoryByWeek(Number(g.key), 'set')}>Haftanın tümünü zorunlu yap</button>
                        </div>
                      )}
                      {open && (
                        <div className="qm-questions-list" style={{ padding: '1rem 1.25rem' }}>
                          {g.items.map((q, i) => renderQuestionCard(q, i))}
                        </div>
                      )}
                    </div>
                  );
                })}
              </div>
            );
          })()}
        </div>
      </div>
    );
  };

  const renderBookletsPage = () => {
    return (
      <div className="dashboard-section">
        <div className="page-header">
          <button className="back-button" onClick={() => {
            setCurrentPage(null);
            setSelectedExam(null);
            fetchExams(showArchived);
          }}>
            ← Geri Dön
          </button>
          <h2>{selectedExam?.title} - Kitapçıklar</h2>
        </div>
        <div className="page-content" style={{ padding: '2rem', maxWidth: '100%', width: '100%' }}>
          {/* Sekmeler: A Kitapçığı | B Kitapçığı */}
          <div className="question-tabs" style={{
            display: 'flex',
            gap: '0.5rem',
            marginBottom: '1.5rem',
            borderBottom: '2px solid #e9ecef',
            paddingBottom: '0'
          }}>
            <button
              type="button"
              onClick={() => setActiveBookletTab('A')}
              className={`question-tab-button ${activeBookletTab === 'A' ? 'active' : ''}`}
              style={{
                padding: '0.875rem 1.5rem',
                backgroundColor: activeBookletTab === 'A' ? '#28a745' : '#f8f9fa',
                color: activeBookletTab === 'A' ? '#ffffff' : '#495057',
                border: activeBookletTab === 'A' ? 'none' : '1px solid #dee2e6',
                borderBottom: activeBookletTab === 'A' ? '3px solid #28a745' : '3px solid transparent',
                borderRadius: '8px 8px 0 0',
                fontSize: '1rem',
                fontWeight: activeBookletTab === 'A' ? '600' : '500',
                cursor: 'pointer',
                transition: 'all 0.2s ease',
                marginBottom: '-2px',
                boxShadow: activeBookletTab === 'A' ? 'none' : '0 1px 3px rgba(0, 0, 0, 0.1)'
              }}
            >
              A Kitapçığı
            </button>
            <button
              type="button"
              onClick={() => setActiveBookletTab('B')}
              className={`question-tab-button ${activeBookletTab === 'B' ? 'active' : ''}`}
              style={{
                padding: '0.875rem 1.5rem',
                backgroundColor: activeBookletTab === 'B' ? '#28a745' : '#f8f9fa',
                color: activeBookletTab === 'B' ? '#ffffff' : '#495057',
                border: activeBookletTab === 'B' ? 'none' : '1px solid #dee2e6',
                borderBottom: activeBookletTab === 'B' ? '3px solid #28a745' : '3px solid transparent',
                borderRadius: '8px 8px 0 0',
                fontSize: '1rem',
                fontWeight: activeBookletTab === 'B' ? '600' : '500',
                cursor: 'pointer',
                transition: 'all 0.2s ease',
                marginBottom: '-2px',
                boxShadow: activeBookletTab === 'B' ? 'none' : '0 1px 3px rgba(0, 0, 0, 0.1)'
              }}
            >
              B Kitapçığı
            </button>
          </div>
          {/* Kitapçık oluştur / Yeniden oluştur */}
          <div style={{ marginBottom: '1.5rem' }}>
            <button
              type="button"
              className="btn btn-primary"
              onClick={generateBooklets}
              disabled={generatingBooklets}
              style={{ background: BUTTON_COLORS.success, color: 'white' }}
            >
              {generatingBooklets ? 'Oluşturuluyor...' : (bookletsData.A?.questions?.length > 0 || bookletsData.B?.questions?.length > 0 ? 'Yeniden oluştur' : 'Kitapçık oluştur')}
            </button>
          </div>
          {/* Önizleme alanı */}
          <div style={{
            padding: '1.5rem',
            marginBottom: '1.5rem',
            backgroundColor: '#f8f9fa',
            borderRadius: '8px',
            border: '1px solid #e9ecef',
            minHeight: '200px'
          }}>
            {loadingBooklets ? (
              <p>Yükleniyor...</p>
            ) : (() => {
              const questions = bookletsData[activeBookletTab]?.questions || [];
              if (questions.length === 0) {
                return <p style={{ color: '#6c757d' }}>Kitapçık oluşturun veya henüz veri yok.</p>;
              }
              const optionKeys = ['option_a', 'option_b', 'option_c', 'option_d', 'option_e'];
              const optionLabels = { option_a: 'A', option_b: 'B', option_c: 'C', option_d: 'D', option_e: 'E' };
              const getCorrectOption = (q) => {
                const ca = (q.correct_answer && String(q.correct_answer).trim()) || '';
                const upper = ca.toUpperCase();
                if (['A', 'B', 'C', 'D', 'E'].includes(upper)) return `option_${upper.toLowerCase()}`;
                const byText = optionKeys.find(k => (q[k] || '').trim() === ca || (q[k] || '').trim().toLowerCase() === ca.toLowerCase());
                return byText || null;
              };
              return (
                <ol style={{ margin: 0, paddingLeft: '1.25rem', listStyle: 'decimal', counterReset: 'item' }}>
                  {questions.map((q, idx) => {
                    const correctKey = getCorrectOption(q);
                    return (
                      <li key={q.id || idx} style={{
                        marginBottom: '1.25rem',
                        padding: '1rem',
                        backgroundColor: '#fafafa',
                        borderRadius: '8px',
                        border: '1px solid #e9ecef',
                        borderLeft: '4px solid #28a745'
                      }}>
                        <div style={{ fontWeight: '600', fontSize: '1rem', color: '#212529', marginBottom: '0.5rem', lineHeight: 1.5 }}>
                          {q.question_text ? <MathText text={q.question_text} /> : <span style={{ color: '#6c757d', fontStyle: 'italic' }}>Soru metni girilmemiş</span>}
                        </div>
                        {(q.option_a || q.option_b) && (
                          <ul style={{ margin: 0, paddingLeft: '1.25rem', listStyle: 'none' }}>
                            {optionKeys.filter(k => q[k]).map(k => {
                              const isCorrect = correctKey === k;
                              return (
                                <li key={k} style={{
                                  marginBottom: '0.35rem',
                                  padding: '0.5rem 0.65rem',
                                  fontSize: '0.95rem',
                                  color: isCorrect ? '#155724' : '#495057',
                                  backgroundColor: isCorrect ? 'rgba(40, 167, 69, 0.12)' : 'transparent',
                                  borderRadius: '6px',
                                  borderLeft: isCorrect ? '3px solid #28a745' : '3px solid transparent',
                                  fontWeight: isCorrect ? '600' : '400'
                                }}>
                                  <span style={{ marginRight: '0.5rem', fontWeight: '600', color: isCorrect ? '#28a745' : '#6c757d' }}>{optionLabels[k]})</span>
                                  <MathText text={q[k]} />
                                  {isCorrect && <span style={{ marginLeft: '0.5rem', fontSize: '0.8rem', color: '#28a745' }}>✓ Doğru cevap</span>}
                                </li>
                              );
                            })}
                          </ul>
                        )}
                      </li>
                    );
                  })}
                </ol>
              );
            })()}
          </div>
          {/* İndir butonları */}
          <div style={{ display: 'flex', gap: '1rem', flexWrap: 'wrap' }}>
            <button
              type="button"
              className="btn btn-primary"
              onClick={() => downloadBooklet('A')}
              style={{ background: BUTTON_COLORS.success, color: 'white' }}
            >
              A Kitapçığı İndir
            </button>
            <button
              type="button"
              className="btn btn-primary"
              onClick={() => downloadBooklet('B')}
              style={{ background: BUTTON_COLORS.success, color: 'white' }}
            >
              B Kitapçığı İndir
            </button>
          </div>
        </div>
      </div>
    );
  };

  const renderPreviewPage = () => {
    return (
      <div className="dashboard-section">
        <div className="page-header">
          <button className="back-button" onClick={() => {
            setCurrentPage(null);
            setPageData(null);
            setPreviewExam(null);
            setPreviewSettings(null);
            setPreviewQuestions([]);
            setPreviewPointInputs({});
            setPointsSaved(false);
            setTotalPreviewPoints(0);
          }}>
            ← Geri Dön
          </button>
          <h2>{previewExam?.title} - Önizleme</h2>
        </div>
        <div className="page-content" style={{ padding: '2rem', maxWidth: '100%', width: '100%' }}>
          {loadingPreview ? (
            <div style={{ textAlign: 'center', padding: '3rem' }}>
              <p>Yükleniyor...</p>
            </div>
          ) : (
            <>
              {/* Sınav Bilgileri */}
              <div className="preview-section">
                <h4 style={{ marginTop: 0, marginBottom: '1rem', color: '#1A202C', fontSize: '1.2rem', fontWeight: '600', borderBottom: '2px solid #1A202C', paddingBottom: '0.5rem' }}>
                  Sınav Bilgileri
                </h4>
                <div className="preview-grid" style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))', gap: '1rem', marginBottom: '1.5rem' }}>
                  <div className="preview-item">
                    <span className="preview-label">Ders:</span>
                    <span className="preview-value">{previewExam?.course_name || '-'}</span>
                  </div>
                  <div className="preview-item">
                    <span className="preview-label">Durum:</span>
                    <span className="preview-value">{getStatusBadge(previewExam?.status)}</span>
                  </div>
                  <div className="preview-item">
                    <span className="preview-label">Başlangıç:</span>
                    <span className="preview-value">{formatDate(previewExam?.start_at)}</span>
                  </div>
                  <div className="preview-item">
                    <span className="preview-label">Bitiş:</span>
                    <span className="preview-value">{formatDate(previewExam?.end_at)}</span>
                  </div>
                  {previewExam?.duration_minutes && (
                    <div className="preview-item">
                      <span className="preview-label">Süre:</span>
                      <span className="preview-value">{previewExam.duration_minutes} dakika</span>
                    </div>
                  )}
                  <div className="preview-item">
                    <span className="preview-label">Oluşturulma:</span>
                    <span className="preview-value">{formatDate(previewExam?.created_at)}</span>
                  </div>
                </div>
              </div>
              
              {/* Sınav Ayarları */}
              {previewSettings && (
                <div className="preview-section" style={{ marginTop: '2rem', paddingTop: '2rem', borderTop: '2px solid #e9ecef' }}>
                  <h4 style={{ marginTop: 0, marginBottom: '1rem', color: '#1A202C', fontSize: '1.2rem', fontWeight: '600', borderBottom: '2px solid #1A202C', paddingBottom: '0.5rem' }}>
                    Sınav Ayarları
                  </h4>
                  <div className="preview-grid" style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))', gap: '1rem' }}>
                    <div className="preview-item">
                      <span className="preview-label">Giriş Hakkı:</span>
                      <span className="preview-value">{previewSettings.max_attempts || 1} kez</span>
                    </div>
                    <div className="preview-item">
                      <span className="preview-label">Karıştırma:</span>
                      <span className="preview-value">
                        {previewSettings.shuffle_type === 'none' ? 'Karıştırma yok' :
                         previewSettings.shuffle_type === 'questions' ? 'Sadece soruları karıştır' :
                         previewSettings.shuffle_type === 'choices' ? 'Sadece şıkları karıştır' :
                         previewSettings.shuffle_type === 'both' ? 'Hem soruları hem şıkları karıştır' : 'Bilinmiyor'}
                      </span>
                    </div>
                    <div className="preview-item">
                      <span className="preview-label">Otomatik Kaydet:</span>
                      <span className="preview-value">Aktif</span>
                    </div>
                    {previewSettings.question_count && (
                      <div className="preview-item">
                        <span className="preview-label">Soru Sayısı:</span>
                        <span className="preview-value">{previewSettings.question_count} soru</span>
                      </div>
                    )}
                  </div>
                </div>
              )}
              
              {/* Onay Mesajları */}
              {(previewExam?.entrance_confirmation || previewExam?.finish_confirmation) && (
                <div className="preview-section" style={{ marginTop: '2rem', paddingTop: '2rem', borderTop: '2px solid #e9ecef' }}>
                  <h4 style={{ marginTop: 0, marginBottom: '1rem', color: '#1A202C', fontSize: '1.2rem', fontWeight: '600', borderBottom: '2px solid #1A202C', paddingBottom: '0.5rem' }}>
                    Onay Mesajları
                  </h4>
                  {previewExam.entrance_confirmation && (
                    <div style={{ marginBottom: '1rem', padding: '1rem', background: '#e8f5e9', borderRadius: '8px', borderLeft: '4px solid #4CAF50' }}>
                      <strong style={{ color: '#2e7d32', display: 'block', marginBottom: '0.5rem' }}>Giriş Onayı:</strong>
                      <p style={{ margin: 0, color: '#333', lineHeight: '1.6' }}>{previewExam.entrance_confirmation}</p>
                    </div>
                  )}
                  {previewExam.finish_confirmation && (
                    <div style={{ padding: '1rem', background: '#fff3e0', borderRadius: '8px', borderLeft: '4px solid #ff9800' }}>
                      <strong style={{ color: '#e65100', display: 'block', marginBottom: '0.5rem' }}>Çıkış Onayı:</strong>
                      <p style={{ margin: 0, color: '#333', lineHeight: '1.6' }}>{previewExam.finish_confirmation}</p>
                    </div>
                  )}
                </div>
              )}
              
              {/* Sorular — 3 Bölüm */}
              {(() => {
                const isPublished = previewExam?.status !== 'Draft';
                const mandatoryQs = previewQuestions.filter(q => q.is_mandatory);
                const mcPool = previewQuestions.filter(q => !q.is_mandatory && q.question_type === 'MultipleChoice');
                const classicPool = previewQuestions.filter(q => !q.is_mandatory && q.question_type === 'Classic');

                const allowedCount = previewSettings?.question_count ?? null;
                const totalSelected = mandatoryQs.length + (parseInt(mcQuestionCount) || 0) + (parseInt(classicQuestionCount) || 0);
                const countValid = allowedCount !== null && totalSelected === allowedCount;

                // Displayed value (same fallback logic as the input field)
                const getMandatoryVal = (q) => {
                  if (previewPointInputs[q.id] !== undefined) return previewPointInputs[q.id];
                  if (q.score !== null && q.score !== undefined) return String(q.score);
                  return '';
                };
                const mandatoryPointsFilled = mandatoryQs.every(q => {
                  const v = getMandatoryVal(q);
                  return v !== '' && !isNaN(parseFloat(v)) && parseFloat(v) >= 0;
                });
                const mandatoryFilledCount = mandatoryQs.filter(q => {
                  const v = getMandatoryVal(q);
                  return v !== '' && !isNaN(parseFloat(v));
                }).length;
                // mcReady: havuz bossa veya count 0/bos ise hazir; count > 0 ise points da gerekli
                const mcCountNum = parseInt(mcQuestionCount) || 0;
                const mcReady = mcPool.length === 0 || mcCountNum === 0 || mcQuestionPoints !== '';
                const classicCountNum = parseInt(classicQuestionCount) || 0;
                const classicReady = classicPool.length === 0 || classicCountNum === 0 || classicQuestionPoints !== '';
                const allReady = mandatoryPointsFilled && mcReady && classicReady && countValid;

                const mandatoryTotal = mandatoryQs.reduce((sum, q) => {
                  const v = parseFloat(getMandatoryVal(q));
                  return sum + (isNaN(v) ? 0 : v);
                }, 0);
                const mcTotal = (parseFloat(mcQuestionCount) || 0) * (parseFloat(mcQuestionPoints) || 0);
                const classicTotal = (parseFloat(classicQuestionCount) || 0) * (parseFloat(classicQuestionPoints) || 0);
                const grandTotal = mandatoryTotal + mcTotal + classicTotal;
                const optionKeys = ['option_a', 'option_b', 'option_c', 'option_d', 'option_e'];
                const optionLabels = { option_a: 'A', option_b: 'B', option_c: 'C', option_d: 'D', option_e: 'E' };
                const getCorrectOptionKey = (q) => {
                  const correct = String(q.correct_answer || '').trim();
                  if (!correct) return null;
                  const upper = correct.toUpperCase();
                  if (['A', 'B', 'C', 'D', 'E'].includes(upper)) return `option_${upper.toLowerCase()}`;
                  return optionKeys.find(key => String(q[key] || '').trim().toLowerCase() === correct.toLowerCase()) || null;
                };

                return (
                  <div className="preview-section" style={{ marginTop: '2rem', paddingTop: '2rem', borderTop: '1px solid #e9ecef' }}>
                    {previewQuestions.length === 0 ? (
                      <div style={{ textAlign: 'center', padding: '2rem', color: '#999' }}>
                        <p>Henüz soru eklenmemiş</p>
                      </div>
                    ) : (
                      <div ref={pointBoardRef} className={`pp-board ${pointBarFixed ? 'pp-board--fixed-bar' : ''}`}>
                        {/* Üstte: başlık + büyük toplam puan + segmentli ilerleme çubuğu */}
                        {(() => {
                          const total = grandTotal;
                          const totalClass = total === 100 ? 'ok' : total > 100 ? 'over' : '';
                          const mandPct = Math.min(100, (mandatoryTotal / 100) * 100);
                          const mcPct = Math.min(100 - mandPct, (mcTotal / 100) * 100);
                          const clsPct = Math.min(100 - mandPct - mcPct, (classicTotal / 100) * 100);
                          return (
                            <div
                              ref={pointBarAnchorRef}
                              className="pp-board-sticky-anchor"
                              style={{ height: pointBarFixed ? `${pointBarMetrics.height}px` : 'auto' }}
                            >
                              <div
                                ref={pointBarRef}
                                className={`pp-board-sticky ${pointBarFixed ? 'is-fixed' : ''}`}
                                style={pointBarFixed ? {
                                  top: `${pointBarMetrics.top}px`,
                                  left: `${pointBarMetrics.left}px`,
                                  width: `${pointBarMetrics.width}px`
                                } : undefined}
                              >
                                <div className="pp-board-head">
                                  <h4 className="pp-board-title">Sınav Puanlaması</h4>
                                  <div className={`pp-board-total ${totalClass}`}>
                                    {total.toFixed(total % 1 === 0 ? 0 : 2)}<span className="pp-suffix"> / 100 puan</span>
                                  </div>
                                </div>
                                <div className="pp-bar" title={`Toplam ${total} puan`}>
                                  <div className="pp-bar-seg mand" style={{ width: `${mandPct}%` }} />
                                  <div className="pp-bar-seg mc" style={{ width: `${mcPct}%` }} />
                                  <div className="pp-bar-seg cls" style={{ width: `${clsPct}%` }} />
                                </div>
                                <div className="pp-legend">
                                  <span className="pp-legend-item"><span className="pp-legend-dot mand" /> Zorunlu · {mandatoryTotal.toFixed(mandatoryTotal % 1 === 0 ? 0 : 2)} puan</span>
                                  <span className="pp-legend-item"><span className="pp-legend-dot mc" /> Çoktan Seçmeli · {mcTotal.toFixed(mcTotal % 1 === 0 ? 0 : 2)} puan</span>
                                  <span className="pp-legend-item"><span className="pp-legend-dot cls" /> Klasik · {classicTotal.toFixed(classicTotal % 1 === 0 ? 0 : 2)} puan</span>
                                </div>
                              </div>
                            </div>
                          );
                        })()}

                        {/* 3 ayrı bölüm bloğu */}
                        <div className="pp-rows">

                          {/* Zorunlu bloğu */}
                          <div className="pp-block">
                            <div className="pp-block-head">
                              <h5 className="pp-block-title">
                                <span className="swatch mand" />
                                Zorunlu
                                <span className="pp-block-meta">· {mandatoryQs.length} soru{mandatoryQs.length > 0 ? ` · ${mandatoryFilledCount}/${mandatoryQs.length} puan dolduruldu` : ''}</span>
                              </h5>
                              <div className="pp-mand-header-actions">
                                {!isPublished && (
                                  <button
                                    type="button"
                                    className="pp-mand-manage-btn"
                                    onClick={() => openQuestionModal(previewExam, 'manage')}
                                    title="Soru havuzundan zorunlu soru ekleyin veya mevcut seçimleri yönetin"
                                  >
                                    + Zorunlu Soru Ekle
                                  </button>
                                )}
                                {mandatoryQs.length > 0 && (
                                  <div className={`pp-block-subtotal ${mandatoryTotal > 0 ? '' : 'muted'}`}>
                                    = {mandatoryTotal.toFixed(mandatoryTotal % 1 === 0 ? 0 : 2)}<span className="unit">puan</span>
                                  </div>
                                )}
                              </div>
                            </div>

                            {mandatoryQs.length === 0 ? (
                              <div className="pp-block-empty">
                                <span>Zorunlu soru seçilmemiş</span>
                                {!isPublished && (
                                  <button
                                    className="pp-mini-link"
                                    onClick={() => openQuestionModal(previewExam, 'manage')}
                                  >
                                    Zorunlu Soru Ekle
                                  </button>
                                )}
                              </div>
                            ) : (
                              <>
                                {/* Toplu puan kısayolu — uzun listede çok pratik */}
                                {!isPublished && (
                                  <div className="pp-mand-bulk">
                                    <span className="pp-mand-bulk-label">Tüm zorunlu sorulara aynı puanı ver:</span>
                                    <input
                                      type="number" min="0" step="0.5"
                                      value={bulkMandatoryPoint}
                                      onChange={e => setBulkMandatoryPoint(e.target.value)}
                                      placeholder="Puan"
                                    />
                                    <button
                                      type="button"
                                      disabled={bulkMandatoryPoint === '' || isNaN(parseFloat(bulkMandatoryPoint))}
                                      onClick={() => {
                                        const v = bulkMandatoryPoint;
                                        if (v === '' || isNaN(parseFloat(v))) return;
                                        const next = {};
                                        mandatoryQs.forEach(q => { next[q.id] = v; });
                                        setPreviewPointInputs(prev => ({ ...prev, ...next }));
                                        setPointsSaved(false);
                                      }}
                                    >
                                      Uygula
                                    </button>
                                  </div>
                                )}
                                <div className="pp-mand-list">
                                  {mandatoryQs.map((q, index) => {
                                  const val = previewPointInputs[q.id] !== undefined ? previewPointInputs[q.id] : (q.score !== null && q.score !== undefined ? String(q.score) : '');
                                  const hasPts = val !== '' && !isNaN(parseFloat(val));
                                  const correctOptionKey = getCorrectOptionKey(q);
                                  const visibleOptions = optionKeys.filter(key => q[key]);
                                  return (
                                    <div key={q.id} className="pp-mand-item">
                                      <span className="pp-mand-item-no">{index + 1}</span>
                                      <div className="pp-mand-text">
                                        {q.question_text
                                          ? <MathText text={q.question_text} />
                                          : <span className="placeholder">Soru metni girilmemiş</span>}
                                        {visibleOptions.length > 0 && (
                                          <div className="pp-mand-options">
                                            {visibleOptions.map(key => {
                                              const letter = optionLabels[key];
                                              const isCorrect = correctOptionKey === key;
                                              const isPendingCorrect = !correctOptionKey && correctAnswerEdits[q.id] === letter;
                                              return (
                                                <div
                                                  key={key}
                                                  className={`pp-mand-option ${isCorrect || isPendingCorrect ? 'correct' : ''}`}
                                                  style={!correctOptionKey ? { cursor: 'pointer' } : undefined}
                                                  onClick={!correctOptionKey ? () => setCorrectAnswerEdits(prev => ({ ...prev, [q.id]: letter })) : undefined}
                                                >
                                                  <span className="pp-mand-option-label">{optionLabels[key]}</span>
                                                  <span className="pp-mand-option-text"><MathText text={q[key]} /></span>
                                                </div>
                                              );
                                            })}
                                            {!correctOptionKey && (
                                              <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', marginTop: '0.5rem' }}>
                                                <span style={{ fontSize: '0.75rem', color: '#e65100' }}>Doğru cevap belirtilmemiş — şıka tıklayın</span>
                                                <button
                                                  type="button"
                                                  disabled={!correctAnswerEdits[q.id] || savingCorrectAnswer[q.id]}
                                                  onClick={() => saveCorrectAnswerInExams(q.id, previewExam.exam_id)}
                                                  style={{
                                                    padding: '0.25rem 0.75rem', fontSize: '0.75rem',
                                                    background: '#4CAF50', color: '#fff',
                                                    border: 'none', borderRadius: '4px', cursor: 'pointer',
                                                    opacity: (!correctAnswerEdits[q.id] || savingCorrectAnswer[q.id]) ? 0.5 : 1
                                                  }}
                                                >
                                                  {savingCorrectAnswer[q.id] ? 'Kaydediliyor...' : 'Doğru Cevabı Kaydet'}
                                                </button>
                                              </div>
                                            )}
                                          </div>
                                        )}
                                      </div>
                                      <div className="pp-mand-actions">
                                        <div className="pp-mand-input-wrap">
                                          <label>Puan</label>
                                          <input
                                            type="number" min="0" step="0.5"
                                            className={hasPts ? '' : 'empty'}
                                            value={val}
                                            onChange={e => { if (!isPublished) { setPreviewPointInputs(prev => ({ ...prev, [q.id]: e.target.value })); setPointsSaved(false); } }}
                                            disabled={isPublished}
                                            placeholder="0"
                                          />
                                        </div>
                                        {!isPublished && (
                                          <button
                                            type="button"
                                            className="pp-mand-remove-btn"
                                            onClick={() => removeMandatoryQuestionFromPreview(q)}
                                            title="Soruyu zorunlu listesinden çıkarır; soru havuzda kalır"
                                          >
                                            Çıkar
                                          </button>
                                        )}
                                      </div>
                                    </div>
                                  );
                                })}
                                </div>
                                {mandatoryQs.length > 4 && (
                                  <div className="pp-mand-list-hint">
                                    {mandatoryQs.length} soru — listenin içinde kaydırarak tümünü görebilirsiniz
                                  </div>
                                )}
                              </>
                            )}
                          </div>

                          {/* Çoktan Seçmeli bloğu */}
                          <div className="pp-block">
                            <div className="pp-block-head">
                              <h5 className="pp-block-title">
                                <span className="swatch mc" />
                                Çoktan Seçmeli
                                <span className="pp-block-meta">· havuzda {mcPool.length} soru</span>
                              </h5>
                              {mcPool.length > 0 && (
                                <div className={`pp-block-subtotal ${mcTotal > 0 ? '' : 'muted'}`}>
                                  = {mcTotal.toFixed(mcTotal % 1 === 0 ? 0 : 2)}<span className="unit">puan</span>
                                </div>
                              )}
                            </div>

                            {mcPool.length === 0 ? (
                              <div className="pp-block-empty">
                                <span>Bu sınavda çoktan seçmeli soru yok</span>
                              </div>
                            ) : (
                              <div className="pp-input-row">
                                <div className="pp-input-group">
                                  <label>Sorulacak soru sayısı</label>
                                  <input
                                    className={`pp-big-input ${mcQuestionCount === '' ? 'empty' : ''}`}
                                    type="number" min="0" step="1"
                                    max={allowedCount !== null ? Math.min(mcPool.length, allowedCount - (parseInt(classicQuestionCount) || 0)) : mcPool.length}
                                    value={mcQuestionCount}
                                    onChange={e => {
                                      if (isPublished) return;
                                      setPointsSaved(false);
                                      const raw = parseInt(e.target.value);
                                      if (isNaN(raw) || e.target.value === '') { setMcQuestionCount(''); return; }
                                      const mcMax = allowedCount !== null ? Math.min(mcPool.length, allowedCount - (parseInt(classicQuestionCount) || 0)) : mcPool.length;
                                      setMcQuestionCount(String(Math.min(Math.max(0, raw), mcMax)));
                                    }}
                                    disabled={isPublished}
                                    placeholder="0"
                                  />
                                </div>
                                <div className="pp-input-times">×</div>
                                <div className="pp-input-group">
                                  <label>Her soru kaç puan</label>
                                  <input
                                    className={`pp-big-input ${mcQuestionPoints === '' ? 'empty' : ''}`}
                                    type="number" min="0" step="0.5"
                                    value={mcQuestionPoints}
                                    onChange={e => { if (!isPublished) { setMcQuestionPoints(e.target.value); setPointsSaved(false); } }}
                                    disabled={isPublished}
                                    placeholder="0"
                                  />
                                </div>
                              </div>
                            )}
                          </div>

                          {/* Klasik bloğu */}
                          <div className="pp-block">
                            <div className="pp-block-head">
                              <h5 className="pp-block-title">
                                <span className="swatch cls" />
                                Klasik
                                <span className="pp-block-meta">· havuzda {classicPool.length} soru</span>
                              </h5>
                              {classicPool.length > 0 && (
                                <div className={`pp-block-subtotal ${classicTotal > 0 ? '' : 'muted'}`}>
                                  = {classicTotal.toFixed(classicTotal % 1 === 0 ? 0 : 2)}<span className="unit">puan</span>
                                </div>
                              )}
                            </div>

                            {classicPool.length === 0 ? (
                              <div className="pp-block-empty">
                                <span>Bu sınavda klasik soru yok</span>
                              </div>
                            ) : (
                              <div className="pp-input-row">
                                <div className="pp-input-group">
                                  <label>Sorulacak soru sayısı</label>
                                  <input
                                    className={`pp-big-input ${classicQuestionCount === '' ? 'empty' : ''}`}
                                    type="number" min="0" step="1"
                                    max={allowedCount !== null ? Math.min(classicPool.length, allowedCount - (parseInt(mcQuestionCount) || 0)) : classicPool.length}
                                    value={classicQuestionCount}
                                    onChange={e => {
                                      if (isPublished) return;
                                      setPointsSaved(false);
                                      const raw = parseInt(e.target.value);
                                      if (isNaN(raw) || e.target.value === '') { setClassicQuestionCount(''); return; }
                                      const classicMax = allowedCount !== null ? Math.min(classicPool.length, allowedCount - (parseInt(mcQuestionCount) || 0)) : classicPool.length;
                                      setClassicQuestionCount(String(Math.min(Math.max(0, raw), classicMax)));
                                    }}
                                    disabled={isPublished}
                                    placeholder="0"
                                  />
                                </div>
                                <div className="pp-input-times">×</div>
                                <div className="pp-input-group">
                                  <label>Her soru kaç puan</label>
                                  <input
                                    className={`pp-big-input ${classicQuestionPoints === '' ? 'empty' : ''}`}
                                    type="number" min="0" step="0.5"
                                    value={classicQuestionPoints}
                                    onChange={e => { if (!isPublished) { setClassicQuestionPoints(e.target.value); setPointsSaved(false); } }}
                                    disabled={isPublished}
                                    placeholder="0"
                                  />
                                </div>
                              </div>
                            )}
                          </div>

                        </div>

                        {/* Alt bar: durum + Kaydet */}
                        {(() => {
                          const statusClass = isPublished ? 'locked' : pointsSaved ? 'saved' : (grandTotal > 0 && grandTotal !== 100) ? 'error' : '';
                          const statusText = isPublished
                            ? 'Puanlar kilitlendi'
                            : pointsSaved
                              ? 'Puanlar kaydedildi'
                              : !allReady
                                ? 'Bölümleri doldurun'
                                : grandTotal !== 100
                                  ? `Toplam ${grandTotal} puan — 100 olmalı`
                                  : !countValid
                                    ? `Soru sayısı: ${totalSelected} / ${allowedCount}`
                                    : 'Hazır — kaydedebilirsiniz';
                          return (
                            <div className="pp-savebar">
                              <span className={`pp-savebar-status ${statusClass}`}>
                                <span className="dot" />
                                {statusText}
                              </span>
                              <button
                                className={`pp-savebar-btn ${pointsSaved ? 'saved' : ''}`}
                                onClick={handleSavePoints}
                                disabled={savingPoints || !allReady || grandTotal !== 100 || isPublished || pointsSaved}
                              >
                                {savingPoints ? 'Kaydediliyor…' : isPublished ? 'Kilitli' : pointsSaved ? 'Kaydedildi ✓' : 'Puanları Kaydet'}
                              </button>
                            </div>
                          );
                        })()}
                      </div>
                    )}

                    {/* Eski içerik (kapalı) */}
                    {false && (
                      <div className="pp-sections">

                        {/* BÖLÜM 1: Zorunlu Sorular */}
                        <div className="pp-section is-mandatory">
                          <div className="pp-section-head">
                            <div className="pp-section-head-left">
                              <h5 className="pp-section-title">Zorunlu Sorular</h5>
                              <span className="pp-pill">{mandatoryQs.length} soru</span>
                              {mandatoryQs.length > 0 && (
                                <span className={`pp-pill ${mandatoryFilledCount === mandatoryQs.length ? 'is-success' : 'is-warn'}`}>
                                  {mandatoryFilledCount}/{mandatoryQs.length} puan belirlendi
                                </span>
                              )}
                            </div>
                          </div>
                          <div className="pp-section-body">
                            {mandatoryQs.length === 0 ? (
                              <div className="pp-empty">
                                <span>Zorunlu soru seçilmemiş. Soruları Yönet sayfasından işaretleyebilirsiniz.</span>
                                <button
                                  className="pp-link-btn"
                                  onClick={() => openQuestionModal(previewExam)}
                                  title="Soru yönetimi sayfasına git"
                                >
                                  Soruları Yönete Git
                                </button>
                              </div>
                            ) : (
                              <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
                                {mandatoryQs.map((q, index) => (
                                  <div key={q.id} style={{
                                    padding: '1.25rem', background: '#f8f9fa', borderRadius: '10px',
                                    border: '1px solid #e9ecef', boxShadow: '0 1px 3px rgba(0,0,0,0.05)'
                                  }}>
                                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '0.75rem' }}>
                                      <strong style={{ fontSize: '1rem', color: '#333' }}>Soru {index + 1}</strong>
                                      <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem' }}>
                                        {(() => {
                                          const val = previewPointInputs[q.id] !== undefined ? previewPointInputs[q.id] : (q.score !== null && q.score !== undefined ? String(q.score) : '');
                                          const hasPts = val !== '' && !isNaN(parseFloat(val));
                                          return (
                                            <div style={{ display: 'flex', alignItems: 'center', gap: '0.4rem' }}>
                                              <label style={{ fontSize: '0.9rem', color: isPublished ? '#999' : '#555', whiteSpace: 'nowrap' }}>Puan:</label>
                                              <input
                                                type="number" min="0" step="0.5"
                                                value={val}
                                                onChange={e => { if (!isPublished) { setPreviewPointInputs(prev => ({ ...prev, [q.id]: e.target.value })); setPointsSaved(false); } }}
                                                disabled={isPublished}
                                                style={{
                                                  width: '80px', padding: '0.4rem 0.5rem', borderRadius: '6px',
                                                  textAlign: 'center', fontSize: '1rem',
                                                  border: `2px solid ${isPublished ? '#bdbdbd' : (hasPts ? '#4CAF50' : '#FFC107')}`,
                                                  background: isPublished ? '#f5f5f5' : 'white',
                                                  color: isPublished ? '#757575' : '#333',
                                                  cursor: isPublished ? 'not-allowed' : 'text'
                                                }}
                                                placeholder="0"
                                              />
                                            </div>
                                          );
                                        })()}
                                        {q.correct_answer && (
                                          <span style={{ padding: '0.4rem 0.8rem', borderRadius: '8px', background: '#4CAF50', color: 'white', fontWeight: '600', fontSize: '0.85rem' }}>
                                            Doğru: {q.correct_answer}
                                          </span>
                                        )}
                                      </div>
                                    </div>
                                    <p style={{ margin: '0 0 0.75rem 0', fontSize: '0.95rem', lineHeight: '1.6', color: '#333' }}>
                                      {q.question_text ? <MathText text={q.question_text} /> : <span style={{ color: '#6c757d', fontStyle: 'italic' }}>Soru metni girilmemiş</span>}
                                    </p>
                                    {q.question_type === 'MultipleChoice' && (
                                      <div style={{ display: 'flex', flexDirection: 'column', gap: '0.4rem' }}>
                                        {['A','B','C','D','E'].map(opt => {
                                          const optionValue = q[`option_${opt.toLowerCase()}`];
                                          const ca = String(q.correct_answer || '').trim().toUpperCase();
                                          const isCorrect = ca.length === 1 && ['A','B','C','D','E'].includes(ca)
                                            ? ca === opt
                                            : (optionValue || '').trim().toLowerCase() === String(q.correct_answer || '').trim().toLowerCase();
                                          return optionValue ? (
                                            <div key={opt} style={{
                                              padding: '0.6rem 0.8rem', borderRadius: '6px',
                                              background: isCorrect ? '#e8f5e9' : 'white',
                                              border: `2px solid ${isCorrect ? '#4CAF50' : '#e0e0e0'}`,
                                              display: 'flex', alignItems: 'center', gap: '0.5rem'
                                            }}>
                                              <strong style={{ color: isCorrect ? '#4CAF50' : '#666', minWidth: '22px' }}>{opt}:</strong>
                                              <span style={{ color: '#333', flex: 1 }}>{optionValue}</span>
                                              {isCorrect && <span style={{ color: '#4CAF50', fontWeight: '600' }}>✓</span>}
                                            </div>
                                          ) : null;
                                        })}
                                      </div>
                                    )}
                                  </div>
                                ))}
                              </div>
                            )}
                          </div>
                        </div>

                        {/* BÖLÜM 2: Çoktan Seçmeli Sorular */}
                        <div className="pp-section is-mc">
                          <div className="pp-section-head">
                            <div className="pp-section-head-left">
                              <h5 className="pp-section-title">Çoktan Seçmeli Sorular</h5>
                              <span className="pp-pill">Havuzda {mcPool.length} soru</span>
                              {mcPool.length > 0 && mcQuestionCount !== '' && mcQuestionPoints !== '' && (
                                <span className="pp-pill is-success">Puanı belirlendi</span>
                              )}
                            </div>
                          </div>
                          <div className="pp-section-body">
                            {mcPool.length === 0 ? (
                              <p className="pp-section-help" style={{ margin: 0, fontStyle: 'italic' }}>Bu sınava ait çoktan seçmeli soru bulunmamaktadır.</p>
                            ) : (
                              <>
                                <p className="pp-section-help">
                                  Havuzdaki {mcPool.length} sorudan rastgele kaç soru sorulacağını ve her sorunun puanını belirleyin.
                                </p>
                                <div className="pp-fields">
                                  <div className="pp-field">
                                    <label>Kaç soru sorulsun?</label>
                                    <input
                                      className={`pp-input ${mcQuestionCount !== '' ? 'is-filled' : 'is-empty'}`}
                                      type="number" min="0" max={allowedCount !== null ? Math.min(mcPool.length, allowedCount - (parseInt(classicQuestionCount) || 0)) : mcPool.length} step="1"
                                      value={mcQuestionCount}
                                      onChange={e => {
                                        if (isPublished) return;
                                        setPointsSaved(false);
                                        const raw = parseInt(e.target.value);
                                        if (isNaN(raw) || e.target.value === '') { setMcQuestionCount(''); return; }
                                        const mcMax = allowedCount !== null ? Math.min(mcPool.length, allowedCount - (parseInt(classicQuestionCount) || 0)) : mcPool.length;
                                        setMcQuestionCount(String(Math.min(Math.max(0, raw), mcMax)));
                                      }}
                                      disabled={isPublished}
                                      placeholder={`0 – ${allowedCount !== null ? Math.min(mcPool.length, allowedCount - (parseInt(classicQuestionCount) || 0)) : mcPool.length}`}
                                    />
                                  </div>
                                  <div className="pp-field">
                                    <label>Her soru kaç puan?</label>
                                    <input
                                      className={`pp-input ${mcQuestionPoints !== '' ? 'is-filled' : 'is-empty'}`}
                                      type="number" min="0" step="0.5"
                                      value={mcQuestionPoints}
                                      onChange={e => { if (!isPublished) { setMcQuestionPoints(e.target.value); setPointsSaved(false); } }}
                                      disabled={isPublished}
                                      placeholder="0"
                                    />
                                  </div>
                                  {mcQuestionCount !== '' && mcQuestionPoints !== '' && (
                                    <div className="pp-subtotal">
                                      Toplam: {(parseFloat(mcQuestionCount) || 0) * (parseFloat(mcQuestionPoints) || 0)} puan
                                    </div>
                                  )}
                                </div>
                              </>
                            )}
                          </div>
                        </div>

                        {/* BÖLÜM 3: Klasik Sorular */}
                        <div className="pp-section is-classic">
                          <div className="pp-section-head">
                            <div className="pp-section-head-left">
                              <h5 className="pp-section-title">Klasik Sorular</h5>
                              <span className="pp-pill">Havuzda {classicPool.length} soru</span>
                              {classicPool.length > 0 && classicQuestionCount !== '' && classicQuestionPoints !== '' && (
                                <span className="pp-pill is-success">Puanı belirlendi</span>
                              )}
                            </div>
                          </div>
                          <div className="pp-section-body">
                            {classicPool.length === 0 ? (
                              <p className="pp-section-help" style={{ margin: 0, fontStyle: 'italic' }}>Bu sınava ait klasik soru bulunmamaktadır.</p>
                            ) : (
                              <>
                                <p className="pp-section-help">
                                  Havuzdaki {classicPool.length} sorudan rastgele kaç soru sorulacağını ve her sorunun puanını belirleyin.
                                </p>
                                <div className="pp-fields">
                                  <div className="pp-field">
                                    <label>Kaç soru sorulsun?</label>
                                    <input
                                      className={`pp-input ${classicQuestionCount !== '' ? 'is-filled' : 'is-empty'}`}
                                      type="number" min="0" max={allowedCount !== null ? Math.min(classicPool.length, allowedCount - (parseInt(mcQuestionCount) || 0)) : classicPool.length} step="1"
                                      value={classicQuestionCount}
                                      onChange={e => {
                                        if (isPublished) return;
                                        setPointsSaved(false);
                                        const raw = parseInt(e.target.value);
                                        if (isNaN(raw) || e.target.value === '') { setClassicQuestionCount(''); return; }
                                        const classicMax = allowedCount !== null ? Math.min(classicPool.length, allowedCount - (parseInt(mcQuestionCount) || 0)) : classicPool.length;
                                        setClassicQuestionCount(String(Math.min(Math.max(0, raw), classicMax)));
                                      }}
                                      disabled={isPublished}
                                      placeholder={`0 – ${allowedCount !== null ? Math.min(classicPool.length, allowedCount - (parseInt(mcQuestionCount) || 0)) : classicPool.length}`}
                                    />
                                  </div>
                                  <div className="pp-field">
                                    <label>Her soru kaç puan?</label>
                                    <input
                                      className={`pp-input ${classicQuestionPoints !== '' ? 'is-filled' : 'is-empty'}`}
                                      type="number" min="0" step="0.5"
                                      value={classicQuestionPoints}
                                      onChange={e => { if (!isPublished) { setClassicQuestionPoints(e.target.value); setPointsSaved(false); } }}
                                      disabled={isPublished}
                                      placeholder="0"
                                    />
                                  </div>
                                  {classicQuestionCount !== '' && classicQuestionPoints !== '' && (
                                    <div className="pp-subtotal">
                                      Toplam: {(parseFloat(classicQuestionCount) || 0) * (parseFloat(classicQuestionPoints) || 0)} puan
                                    </div>
                                  )}
                                </div>
                              </>
                            )}
                          </div>
                        </div>

                      </div>
                    )}
                  </div>
                );
              })()}

              {/* Yayınla kısayolu — puanlar kaydedildikten sonra göster */}
              {pointsSaved && previewExam?.status === 'Draft' && previewExam?.mode !== 'Physical' && (
                <div style={{ textAlign: 'right', marginTop: '2rem', paddingTop: '1.5rem', borderTop: '2px solid #e9ecef' }}>
                  <button
                    className="btn btn-primary"
                    onClick={() => {
                      setCurrentPage(null);
                      setPageData(null);
                      setPreviewExam(null);
                      setPreviewSettings(null);
                      setPreviewQuestions([]);
                      setPreviewPointInputs({});
                      setPointsSaved(false);
                      setTotalPreviewPoints(0);
                      handlePublishClick(previewExam);
                    }}
                    style={{ background: '#4CAF50', color: 'white', padding: '0.75rem 2rem', fontSize: '1rem' }}
                  >
                    Sınavı Yayınla
                  </button>
                </div>
              )}
            </>
          )}
        </div>
      </div>
    );
  };


  const renderExtendTimePage = () => {
    const formatFirstEntryTime = (startedAt) => {
      if (!startedAt) return '-';
      try {
        const date = new Date(startedAt);
        return date.toLocaleString('tr-TR', {
          day: '2-digit',
          month: '2-digit',
          year: 'numeric',
          hour: '2-digit',
          minute: '2-digit'
        });
      } catch (e) {
        return '-';
      }
    };
    
    const grantAttemptToStudent = async (student) => {
      if (!student.attempt_id) {
        setToastMessage('Öğrencinin henüz sınava girişi yok.');
        setToastType('error');
        setTimeout(() => setToastMessage(''), 3000);
        return;
      }
      
      try {
        const response = await apiFetch(
          `/instructor/exams/${selectedExamForExtend.exam_id}/attempts/${student.attempt_id}/grant-attempt`,
          {
            method: 'PATCH'
          }
        );
        
        const data = await response.json();
        
        if (data.success) {
          setToastMessage('Öğrenciye 1 hak verildi');
          setToastType('success');
          setTimeout(() => setToastMessage(''), 3000);
          await fetchExamStudents(selectedExamForExtend.exam_id);
        } else {
          setToastMessage(`Hata: ${data.message || 'Hak verilemedi'}`);
          setToastType('error');
          setTimeout(() => setToastMessage(''), 3000);
        }
      } catch (error) {
        console.error('Hak verme hatası:', error);
        setToastMessage('Hak verilirken bir hata oluştu');
        setToastType('error');
        setTimeout(() => setToastMessage(''), 3000);
      }
    };
    
    return (
      <div className="dashboard-section">
        <div className="page-header">
          <button className="back-button" onClick={() => {
            setCurrentPage(null);
            setPageData(null);
            setSelectedExamForExtend(null);
            setExamStudents([]);
          }}>
            ← Geri Dön
          </button>
          <h2>Ek Süre Ver - {selectedExamForExtend?.title}</h2>
        </div>
        <div className="page-content" style={{ padding: '2rem', maxWidth: '100%', width: '100%' }}>
          {loadingStudents ? (
            <div style={{ textAlign: 'center', padding: '2rem' }}>
              <p>Öğrenciler yükleniyor...</p>
            </div>
          ) : examStudents.length === 0 ? (
            <div style={{ textAlign: 'center', padding: '2rem' }}>
              <p>Bu sınavı alan öğrenci bulunamadı.</p>
            </div>
          ) : (
            <>
              {/* Toplu işlem toolbar */}
              <div style={{
                display: 'flex',
                alignItems: 'center',
                gap: '1rem',
                marginBottom: '1rem',
                padding: '0.75rem 1rem',
                background: '#f8f9fa',
                borderRadius: '8px',
                border: '1px solid #e9ecef',
                flexWrap: 'wrap'
              }}>
                <button
                  onClick={async () => {
                    try {
                      const response = await apiFetch(
                        `/instructor/exams/${selectedExamForExtend.exam_id}/grant-attempt-all`,
                        { method: 'PATCH' }
                      );
                      const data = await response.json();
                      if (data.success) {
                        setToastMessage(data.message || 'Tüm öğrencilere 1 hak verildi');
                        setToastType('success');
                        setTimeout(() => setToastMessage(''), 3000);
                        await fetchExamStudents(selectedExamForExtend.exam_id);
                      } else {
                        setToastMessage(`Hata: ${data.message || 'Hak verilemedi'}`);
                        setToastType('error');
                        setTimeout(() => setToastMessage(''), 3000);
                      }
                    } catch (error) {
                      setToastMessage('Hak verilirken bir hata oluştu');
                      setToastType('error');
                      setTimeout(() => setToastMessage(''), 3000);
                    }
                  }}
                  style={{
                    padding: '0.5rem 1.25rem',
                    background: BUTTON_COLORS.primaryDark,
                    color: 'white',
                    border: 'none',
                    borderRadius: '8px',
                    cursor: 'pointer',
                    fontSize: '0.9rem',
                    fontWeight: '500',
                    whiteSpace: 'nowrap'
                  }}
                >
                  Herkese +1 hak ver
                </button>

                <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', marginLeft: 'auto' }}>
                  <span style={{ fontSize: '0.9rem', color: '#555', whiteSpace: 'nowrap' }}>Herkese süre ekle:</span>
                  <input
                    type="number"
                    min="1"
                    placeholder="Dk"
                    value={bulkExtendMinutes}
                    onChange={e => setBulkExtendMinutes(e.target.value)}
                    style={{
                      width: '72px',
                      padding: '0.5rem 0.6rem',
                      borderRadius: '8px',
                      border: '1px solid #ccc',
                      fontSize: '0.9rem'
                    }}
                  />
                  <button
                    onClick={async () => {
                      const mins = parseInt(bulkExtendMinutes);
                      if (!mins || mins <= 0) {
                        setToastMessage('Lütfen geçerli bir dakika değeri giriniz');
                        setToastType('error');
                        setTimeout(() => setToastMessage(''), 3000);
                        return;
                      }
                      try {
                        const response = await apiFetch(
                          `/instructor/exams/${selectedExamForExtend.exam_id}/extend-time-all`,
                          { method: 'PATCH', body: JSON.stringify({ minutes: mins }) }
                        );
                        const data = await response.json();
                        if (data.success) {
                          setToastMessage(data.message || `Tüm öğrencilere ${mins} dakika eklendi`);
                          setToastType('success');
                          setTimeout(() => setToastMessage(''), 3000);
                          setBulkExtendMinutes('');
                          await fetchExamStudents(selectedExamForExtend.exam_id);
                        } else {
                          setToastMessage(`Hata: ${data.message || 'Süre verilemedi'}`);
                          setToastType('error');
                          setTimeout(() => setToastMessage(''), 3000);
                        }
                      } catch (error) {
                        setToastMessage('Süre verilirken bir hata oluştu');
                        setToastType('error');
                        setTimeout(() => setToastMessage(''), 3000);
                      }
                    }}
                    style={{
                      padding: '0.5rem 1.25rem',
                    background: BUTTON_COLORS.success,
                      color: 'white',
                      border: 'none',
                      borderRadius: '8px',
                      cursor: 'pointer',
                      fontSize: '0.9rem',
                      fontWeight: '500',
                      whiteSpace: 'nowrap'
                    }}
                  >
                    Ekle
                  </button>
                </div>
              </div>

              <div style={{ overflowX: 'auto' }}>
                <table style={{
                  width: '100%',
                  borderCollapse: 'collapse',
                  fontSize: '0.95rem',
                  background: 'white',
                  borderRadius: '8px',
                  overflow: 'hidden'
                }}>
                  <thead>
                    <tr style={{
                      background: '#f8f9fa',
                      borderBottom: '2px solid #dee2e6'
                    }}>
                      <th style={{ padding: '0.75rem', textAlign: 'left', fontWeight: '600', color: '#333' }}>Öğrenci No</th>
                      <th style={{ padding: '0.75rem', textAlign: 'left', fontWeight: '600', color: '#333' }}>Ad Soyad</th>
                      <th style={{ padding: '0.75rem', textAlign: 'left', fontWeight: '600', color: '#333' }}>Giriş Hakları</th>
                      <th style={{ padding: '0.75rem', textAlign: 'left', fontWeight: '600', color: '#333' }}>İlk Giriş Zamanı</th>
                      <th style={{ padding: '0.75rem', textAlign: 'right', fontWeight: '600', color: '#333' }}>Toplam Süre</th>
                    </tr>
                  </thead>
                  <tbody>
                    {examStudents.map((student) => {
                      const attemptCount = student.attempt_count || 0;
                      const maxAttempts = student.max_attempts || (selectedExamForExtend?.max_attempts || 1);
                      
                      return (
                        <tr 
                          key={student.student_id}
                          style={{
                            borderBottom: '1px solid #e9ecef'
                          }}
                        >
                          <td style={{ padding: '0.75rem' }}>
                            {student.student_number}
                          </td>
                          <td style={{ padding: '0.75rem' }}>
                            {`${student.first_name || ''} ${student.last_name || ''}`.trim() || '-'}
                          </td>
                          <td style={{ padding: '0.75rem' }}>
                            <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                              <span style={{ fontSize: '0.9rem' }}>
                                {attemptCount}/{maxAttempts}
                              </span>
                              <button
                                type="button"
                                onClick={() => grantAttemptToStudent(student)}
                                style={{
                                  padding: '0.5rem 1rem',
                                  fontSize: '0.85rem',
                                  background: BUTTON_COLORS.primaryDark,
                                  color: 'white',
                                  border: 'none',
                                  borderRadius: '6px',
                                  cursor: 'pointer',
                                  fontWeight: '600',
                                  whiteSpace: 'nowrap',
                                  minWidth: '88px',
                                  textAlign: 'center'
                                }}
                              >
                                +1 hak ver
                              </button>
                            </div>
                          </td>
                          <td style={{ padding: '0.75rem' }}>
                            {formatFirstEntryTime(student.started_at)}
                          </td>
                          <td style={{ padding: '0.75rem' }}>
                            {student.attempt_id ? (
                              <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end', gap: '0.3rem' }}>
                                {student.extra_minutes > 0 && (
                                  <span style={{ color: '#4CAF50', fontWeight: '600', fontSize: '0.88rem' }}>
                                    {student.extra_minutes} dk
                                  </span>
                                )}
                                <div style={{ display: 'flex', gap: '0.4rem', alignItems: 'center' }}>
                                  <input
                                    type="number"
                                    min="1"
                                    placeholder="Dk"
                                    value={studentExtendMinutes[student.attempt_id] || ''}
                                    onChange={e => setStudentExtendMinutes(prev => ({ ...prev, [student.attempt_id]: e.target.value }))}
                                    style={{
                                      width: '65px',
                                      padding: '0.35rem 0.5rem',
                                      fontSize: '0.82rem',
                                      borderRadius: '6px',
                                      border: '1px solid #ccc'
                                    }}
                                  />
                                  <button
                                    onClick={() => {
                                      const mins = parseInt(studentExtendMinutes[student.attempt_id]);
                                      if (!mins || mins <= 0) {
                                        setToastMessage('Lütfen geçerli bir dakika değeri giriniz');
                                        setToastType('error');
                                        setTimeout(() => setToastMessage(''), 3000);
                                        return;
                                      }
                                      extendTime(student.attempt_id, mins);
                                      setStudentExtendMinutes(prev => ({ ...prev, [student.attempt_id]: '' }));
                                    }}
                                    style={{
                                      padding: '0.35rem 0.65rem',
                                      fontSize: '0.82rem',
                                      background: BUTTON_COLORS.success,
                                      color: 'white',
                                      border: 'none',
                                      borderRadius: '6px',
                                      cursor: 'pointer',
                                      fontWeight: '600',
                                      whiteSpace: 'nowrap'
                                    }}
                                  >
                                    +Ekle
                                  </button>
                                </div>
                              </div>
                            ) : (
                              <span style={{ color: '#999' }}>-</span>
                            )}
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            </>
          )}
        </div>
      </div>
    );
  };

  const renderViolationsPage = () => {
    const getAttemptStatusText = (status) => {
      if (!status) return 'Başlamadı';
      const statusMap = {
        InProgress: 'Devam Ediyor',
        Submitted: 'Teslim Edildi',
        Draft: 'Taslak',
        Expired: 'Süresi Doldu'
      };
      return statusMap[status] || status;
    };

    return (
      <div className="dashboard-section">
        <div className="page-header">
          <button className="back-button" onClick={() => {
            setCurrentPage(null);
            setPageData(null);
            setSelectedExamForViolations(null);
            setExamStudents([]);
          }}>
            ← Geri Dön
          </button>
          <h2>İhlal İzleme - {selectedExamForViolations?.title}</h2>
        </div>
        <div className="page-content" style={{ padding: '2rem', maxWidth: '100%', width: '100%' }}>
          {loadingStudents ? (
            <div style={{ textAlign: 'center', padding: '2rem' }}>
              <p>Öğrenciler yükleniyor...</p>
            </div>
          ) : examStudents.length === 0 ? (
            <div style={{ textAlign: 'center', padding: '2rem' }}>
              <p>Bu sınavı alan öğrenci bulunamadı.</p>
            </div>
          ) : (
            <>
              <div style={{
                marginBottom: '1rem',
                padding: '0.75rem 1rem',
                background: '#f8f9fa',
                border: '1px solid #e9ecef',
                borderRadius: '8px',
                color: '#495057',
                fontSize: '0.9rem',
                display: 'flex',
                justifyContent: 'space-between',
                gap: '1rem',
                flexWrap: 'wrap'
              }}>
                <span>İhlal ekranı 10 saniyede bir otomatik yenilenir.</span>
                <span>
                  İhlal yapan öğrenci: <strong>
                    {examStudents
                      .filter(s => violationSessionFilter === null || s.session_number === violationSessionFilter)
                      .filter(s => !examAllowedStudentNos || examAllowedStudentNos.includes(s.student_number))
                      .filter(s => {
                        if (!violationSearch.trim()) return true;
                        const q = violationSearch.trim().toLocaleLowerCase('tr');
                        const name = `${s.first_name || ''} ${s.last_name || ''}`.toLocaleLowerCase('tr');
                        return name.includes(q) || String(s.student_number || '').toLocaleLowerCase('tr').includes(q);
                      })
                      .filter(s => (s.violation_count || 0) > 0 || s.re_entry_granted).length}
                  </strong> / {examStudents
                    .filter(s => violationSessionFilter === null || s.session_number === violationSessionFilter)
                    .filter(s => !examAllowedStudentNos || examAllowedStudentNos.includes(s.student_number))
                    .filter(s => {
                      if (!violationSearch.trim()) return true;
                      const q = violationSearch.trim().toLocaleLowerCase('tr');
                      const name = `${s.first_name || ''} ${s.last_name || ''}`.toLocaleLowerCase('tr');
                      return name.includes(q) || String(s.student_number || '').toLocaleLowerCase('tr').includes(q);
                    }).length}
                  {violationSessionFilter !== null && ` (${violationSessionFilter}. Oturum)`}
                </span>
              </div>

              <div style={{ marginBottom: '1rem', position: 'relative', maxWidth: '420px' }}>
                <svg
                  width="16" height="16" viewBox="0 0 24 24" fill="none"
                  stroke="#94a3b8" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"
                  style={{ position: 'absolute', left: '0.85rem', top: '50%', transform: 'translateY(-50%)', pointerEvents: 'none' }}
                >
                  <circle cx="11" cy="11" r="8" />
                  <line x1="21" y1="21" x2="16.65" y2="16.65" />
                </svg>
                <input
                  type="text"
                  value={violationSearch}
                  onChange={(e) => setViolationSearch(e.target.value)}
                  placeholder="Öğrenci adı veya numarasına göre ara..."
                  style={{
                    width: '100%',
                    padding: '0.55rem 2.2rem 0.55rem 2.4rem',
                    border: '1px solid #e2e8f0',
                    borderRadius: '8px',
                    fontSize: '0.9rem',
                    outline: 'none',
                    background: '#fff',
                    color: '#0f172a',
                  }}
                />
                {violationSearch && (
                  <button
                    type="button"
                    onClick={() => setViolationSearch('')}
                    style={{
                      position: 'absolute', right: '0.5rem', top: '50%', transform: 'translateY(-50%)',
                      background: 'transparent', border: 'none', color: '#94a3b8',
                      cursor: 'pointer', fontSize: '1.1rem', lineHeight: 1, padding: '0.25rem 0.5rem'
                    }}
                    aria-label="Aramayı temizle"
                  >×</button>
                )}
              </div>

              {(examSessionCount > 1 || selectedExamForViolations?.session_count > 1) && (
                <div style={{
                  display: 'flex',
                  gap: '0.5rem',
                  marginBottom: '1rem',
                  flexWrap: 'wrap'
                }}>
                  <button
                    className="btn"
                    onClick={() => setViolationSessionFilter(null)}
                    style={{
                      background: violationSessionFilter === null ? '#007bff' : '#e9ecef',
                      color: violationSessionFilter === null ? '#fff' : '#495057',
                      border: 'none',
                      padding: '0.5rem 1rem',
                      borderRadius: '4px',
                      cursor: 'pointer',
                      fontWeight: violationSessionFilter === null ? '600' : '400'
                    }}
                  >
                    Tümü
                  </button>
                  {[...Array(examSessionCount > 1 ? examSessionCount : (selectedExamForViolations?.session_count || 1))].map((_, i) => (
                    <button
                      key={i + 1}
                      className="btn"
                      onClick={() => setViolationSessionFilter(i + 1)}
                      style={{
                        background: violationSessionFilter === i + 1 ? '#007bff' : '#e9ecef',
                        color: violationSessionFilter === i + 1 ? '#fff' : '#495057',
                        border: 'none',
                        padding: '0.5rem 1rem',
                        borderRadius: '4px',
                        cursor: 'pointer',
                        fontWeight: violationSessionFilter === i + 1 ? '600' : '400'
                      }}
                    >
                      {i + 1}. Oturum
                    </button>
                  ))}
                </div>
              )}

              <div style={{ overflowX: 'auto' }}>
                <table style={{
                  width: '100%',
                  borderCollapse: 'collapse',
                  fontSize: '0.95rem',
                  background: 'white',
                  borderRadius: '8px',
                  overflow: 'hidden'
                }}>
                  <thead>
                    <tr style={{ background: '#f8f9fa', borderBottom: '2px solid #dee2e6' }}>
                      <th style={{ padding: '0.75rem', textAlign: 'left', fontWeight: '600', color: '#333' }}>Öğrenci No</th>
                      <th style={{ padding: '0.75rem', textAlign: 'left', fontWeight: '600', color: '#333' }}>Ad Soyad</th>
                      {(examSessionCount > 1 || selectedExamForViolations?.session_count > 1) && (
                        <th style={{ padding: '0.75rem', textAlign: 'center', fontWeight: '600', color: '#333' }}>Oturum</th>
                      )}
                      <th style={{ padding: '0.75rem', textAlign: 'left', fontWeight: '600', color: '#333' }}>Durum</th>
                      <th style={{ padding: '0.75rem', textAlign: 'center', fontWeight: '600', color: '#333' }}>Not</th>
                      <th style={{ padding: '0.75rem', textAlign: 'center', fontWeight: '600', color: '#333' }}>İhlal Sayısı</th>
                      <th style={{ padding: '0.75rem', textAlign: 'left', fontWeight: '600', color: '#333' }}>İhlal Durumu</th>
                      <th style={{ padding: '0.75rem', textAlign: 'center', fontWeight: '600', color: '#333' }}>İşlem</th>
                    </tr>
                  </thead>
                  <tbody>
                    {examStudents
                      .filter(s => violationSessionFilter === null || s.session_number === violationSessionFilter)
                      .filter(s => {
                        if (!violationSearch.trim()) return true;
                        const q = violationSearch.trim().toLocaleLowerCase('tr');
                        const name = `${s.first_name || ''} ${s.last_name || ''}`.toLocaleLowerCase('tr');
                        return name.includes(q) || String(s.student_number || '').toLocaleLowerCase('tr').includes(q);
                      })
                      .map((student) => {
                      const violationCount = student.violation_count || 0;
                      const reEntryGranted = !!student.re_entry_granted;
                      // re_entry_granted olan öğrenci için ihlal geçmişi olduğunu göster
                      const isCritical = violationCount >= 2 || (reEntryGranted && violationCount === 0);
                      const hasViolation = violationCount > 0 || reEntryGranted;
                      const isSubmitted = student.attempt_status === 'Submitted';
                      const isInProgress = student.attempt_status === 'InProgress';
                      const hasTotalPoints = student.total_points !== null && student.total_points !== undefined;
                      const isAllowed = !examAllowedStudentNos || examAllowedStudentNos.includes(student.student_number);
                      const noteText = isAllowed && isSubmitted
                        ? (hasTotalPoints ? `${Number(student.total_points).toFixed(2)}` : '-')
                        : isAllowed ? '-' : '—';
                      const rowBg = !isAllowed ? 'transparent' : (isCritical && !reEntryGranted) ? '#fff5f5' : (hasViolation ? '#fff8f0' : 'transparent');
                      const dimStyle = !isAllowed ? { opacity: 0.35, color: '#adb5bd' } : {};
                      return (
                        <tr
                          key={student.student_id}
                          style={{
                            borderBottom: '1px solid #e9ecef',
                            background: rowBg,
                            ...dimStyle
                          }}
                        >
                          <td style={{ padding: '0.75rem' }}>{student.student_number}</td>
                          <td style={{ padding: '0.75rem' }}>
                            {`${student.first_name || ''} ${student.last_name || ''}`.trim() || '-'}
                          </td>
                          {(examSessionCount > 1 || selectedExamForViolations?.session_count > 1) && (
                            <td style={{ padding: '0.75rem', textAlign: 'center' }}>
                              {student.session_number ? `${student.session_number}. Oturum` : '-'}
                            </td>
                          )}
                          <td style={{ padding: '0.75rem' }}>{isAllowed ? getAttemptStatusText(student.attempt_status) : '—'}</td>
                          <td style={{ padding: '0.75rem', textAlign: 'center', fontWeight: isAllowed && isSubmitted ? '600' : '400' }}>
                            {noteText}
                          </td>
                          <td style={{ padding: '0.75rem', textAlign: 'center', fontWeight: '700' }}>
                            {isAllowed
                              ? (reEntryGranted && violationCount === 0 ? '2*' : violationCount)
                              : '—'}
                          </td>
                          <td style={{ padding: '0.75rem' }}>
                            {isAllowed ? (
                              reEntryGranted ? (
                                <span className="status-badge" style={{ background: '#6f42c1', color: '#fff' }}>Ek Hak</span>
                              ) : isCritical ? (
                                <span className="status-badge" style={{ background: '#dc3545', color: '#fff' }}>Kritik</span>
                              ) : hasViolation ? (
                                <span className="status-badge" style={{ background: '#fd7e14', color: '#fff' }}>Uyarı</span>
                              ) : (
                                <span className="status-badge" style={{ background: '#28a745', color: '#fff' }}>Normal</span>
                              )
                            ) : (
                              <span style={{ fontSize: '0.8rem', color: '#adb5bd' }}>Bu sınava dahil değil</span>
                            )}
                          </td>
                          <td style={{ padding: '0.75rem', textAlign: 'center' }}>
                            {isAllowed && isCritical && isSubmitted && !reEntryGranted && (
                              <button
                                onClick={() => handleGrantReEntry(student.attempt_id)}
                                style={{
                                  padding: '0.35rem 0.75rem',
                                  background: '#6f42c1',
                                  color: '#fff',
                                  border: 'none',
                                  borderRadius: '6px',
                                  cursor: 'pointer',
                                  fontSize: '0.82rem',
                                  fontWeight: '600',
                                  whiteSpace: 'nowrap'
                                }}
                                title="Bu öğrencinin ihlal sayacını sıfırla ve sınava devam etmesine izin ver"
                              >
                                Ek Giriş Hakkı Ver
                              </button>
                            )}
                            {isAllowed && reEntryGranted && isInProgress && (
                              <span style={{ fontSize: '0.82rem', color: '#6f42c1', fontWeight: '600' }}>
                                ↩ Hak Verildi
                              </span>
                            )}
                            {isAllowed && reEntryGranted && isSubmitted && (
                              <span style={{ fontSize: '0.82rem', color: '#6c757d' }}>
                                ↩ Ek Hak ile Teslim Edildi
                              </span>
                            )}
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            </>
          )}
        </div>
      </div>
    );
  };

  const renderExamStatisticsPage = () => {
    if (!selectedExamForScores) {
      return (
        <div className="dashboard-section">
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1rem', gap: '0.75rem', flexWrap: 'wrap' }}>
            <h2 style={{ margin: 0 }}>
              {(selectedCourseForStats?.course_name || 'Secilen Ders')} - Istatistikler
            </h2>
            <button
              className="btn btn-secondary"
              onClick={() => {
                setCurrentPage(null);
                setSelectedCourseForStats(null);
              }}
            >
              Sinav Listesine Don
            </button>
          </div>
          <div className="empty-state">
            <p>Bu derse ait sinav bulunmamaktadir.</p>
          </div>
        </div>
      );
    }

    return (
      <div className="dashboard-section">
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1rem', gap: '0.75rem', flexWrap: 'wrap' }}>
          <h2 style={{ margin: 0 }}>
            {(selectedCourseForStats?.course_name || selectedExamForScores.title)} - Istatistikler
          </h2>
          <div style={{ display: 'flex', gap: '0.5rem', flexWrap: 'wrap' }}>
            <button
              className="btn btn-secondary"
              onClick={() => {
                setCurrentPage(null);
                setSelectedCourseForStats(null);
                setSelectedExamForScores(null);
                setExamScoreStudents([]);
                setExamStatistics(null);
                setTopRankings([]);
                setBottomRankings([]);
              }}
            >
              Sinav Listesine Don
            </button>
            <button
              className="btn"
              style={{ background: BUTTON_COLORS.warning, color: 'white' }}
              onClick={() => setGradingExamId(selectedExamForScores.exam_id)}
            >
              Detay Degerlendirme
            </button>
          </div>
        </div>

        {selectedCourseForStats && (
          <div className="create-exam-form" style={{ marginBottom: '1rem' }}>
            <h3 style={{ marginTop: 0, marginBottom: '0.75rem' }}>Sinav Sec</h3>
            <div className="stats-exam-selector-list">
              {[...exams, ...archivedExams]
                .filter((exam) => String(exam.course_id) === String(selectedCourseForStats.course_id))
                .map((exam) => (
                  <button
                    key={exam.exam_id}
                    className="stats-exam-selector-item"
                    onClick={() => openExamScoreSummary(exam)}
                    data-selected={selectedExamForScores?.exam_id === exam.exam_id ? 'true' : 'false'}
                  >
                    <div className="stats-exam-selector-title">{exam.title}</div>
                    <div className="stats-exam-selector-meta">
                      {exam.status || '-'} | {formatDate(exam.start_at)}
                    </div>
                  </button>
                ))}
            </div>
          </div>
        )}

        {loadingExamScores ? (
          <div className="empty-state"><p>Veriler yukleniyor...</p></div>
        ) : (
          <>
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(180px, 1fr))', gap: '0.75rem', marginBottom: '1rem' }}>
              <div className="exam-info-card"><span className="info-label">Ortalama</span><span className="info-value">{examStatistics?.average_score ?? '-'}</span></div>
              <div className="exam-info-card"><span className="info-label">En Yuksek</span><span className="info-value">{examStatistics?.highest_score ?? '-'}</span></div>
              <div className="exam-info-card"><span className="info-label">En Dusuk</span><span className="info-value">{examStatistics?.lowest_score ?? '-'}</span></div>
              <div className="exam-info-card"><span className="info-label">Teslim Sayisi</span><span className="info-value">{examStatistics?.submitted_count ?? 0}</span></div>
            </div>

            <div className="create-exam-form" style={{ marginBottom: '1rem' }}>
              <h3 style={{ marginTop: 0 }}>Ogrenci Not Listesi</h3>
              {examScoreStudents.length === 0 ? (
                <div className="empty-state"><p>Bu sinav icin ogrenci/not verisi bulunamadi.</p></div>
              ) : (
                <div style={{ overflowX: 'auto' }}>
                  <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                    <thead>
                      <tr style={{ background: '#f8f9fa', borderBottom: '1px solid #dee2e6' }}>
                        <th style={{ padding: '0.75rem', textAlign: 'left' }}>Ogrenci No</th>
                        <th style={{ padding: '0.75rem', textAlign: 'left' }}>Ad Soyad</th>
                        <th style={{ padding: '0.75rem', textAlign: 'left' }}>Durum</th>
                        <th style={{ padding: '0.75rem', textAlign: 'left' }}>Toplam Not</th>
                      </tr>
                    </thead>
                    <tbody>
                      {examScoreStudents.map((student) => (
                        <tr key={`${student.student_id}-${student.attempt_id || 'na'}`} style={{ borderBottom: '1px solid #eef0f2' }}>
                          <td style={{ padding: '0.75rem' }}>{student.student_number || '-'}</td>
                          <td style={{ padding: '0.75rem' }}>{`${student.first_name || ''} ${student.last_name || ''}`.trim() || '-'}</td>
                          <td style={{ padding: '0.75rem' }}>{student.attempt_status || '-'}</td>
                          <td style={{ padding: '0.75rem', fontWeight: 600 }}>{student.total_points ?? '-'}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              )}
            </div>

            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))', gap: '0.75rem' }}>
              <div className="create-exam-form">
                <h3 style={{ marginTop: 0 }}>En Yuksek 5</h3>
                {topRankings.length === 0 ? <p style={{ margin: 0, color: '#6c757d' }}>Veri bulunamadi.</p> : (
                  <ol style={{ margin: 0, paddingLeft: '1.2rem' }}>
                    {topRankings.map((item) => (
                      <li key={`top-${item.rank}-${item.student_number}`} style={{ marginBottom: '0.35rem' }}>
                        {item.student_number || '-'} - {item.student_name || '-'} ({item.total_points ?? '-'})
                      </li>
                    ))}
                  </ol>
                )}
              </div>
              <div className="create-exam-form">
                <h3 style={{ marginTop: 0 }}>En Dusuk 5</h3>
                {bottomRankings.length === 0 ? <p style={{ margin: 0, color: '#6c757d' }}>Veri bulunamadi.</p> : (
                  <ol style={{ margin: 0, paddingLeft: '1.2rem' }}>
                    {bottomRankings.map((item) => (
                      <li key={`bottom-${item.rank}-${item.student_number}`} style={{ marginBottom: '0.35rem' }}>
                        {item.student_number || '-'} - {item.student_name || '-'} ({item.total_points ?? '-'})
                      </li>
                    ))}
                  </ol>
                )}
              </div>
            </div>
          </>
        )}
      </div>
    );
  };

  if (loading) {
    return (
      <div className="dashboard-section">
        <h2>{isAdmin ? 'Tüm Sınavlar' : 'Sınavlarım'}</h2>
        <div className="loading-state">
          <p>Yükleniyor...</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="dashboard-section">
        <h2>{isAdmin ? 'Tüm Sınavlar' : 'Sınavlarım'}</h2>
        <div className="error-state">
          <p>{error}</p>
        </div>
      </div>
    );
  }

  // Sayfa render kontrolü - modallar yerine sayfalar göster
  if (currentPage === 'question-management' && selectedExam) {
    // Soru yönetimi sayfası - modal içeriğini sayfa olarak göster
    return renderQuestionManagementPage();
  }
  
  if (currentPage === 'preview' && previewExam) {
    // Önizleme sayfası
    return renderPreviewPage();
  }
  
  if (currentPage === 'extend-time' && selectedExamForExtend) {
    // Ek süre sayfası
    return renderExtendTimePage();
  }

  if (currentPage === 'violations' && selectedExamForViolations) {
    // İhlal izleme sayfası
    return renderViolationsPage();
  }
  
  if (currentPage === 'upload-result' && uploadStatistics) {
    // Soru yükleme sonuç sayfası
    return (
      <QuestionUploadResultPage
        statistics={uploadStatistics}
        errors={uploadErrors}
        onClose={() => {
          setCurrentPage(null);
          setPageData(null);
          setUploadStatistics(null);
          setUploadErrors([]);
          fetchExams(showArchived);
        }}
      />
    );
  }

  if (currentPage === 'booklets' && selectedExam) {
    return renderBookletsPage();
  }

  if (currentPage === 'exam-statistics') {
    return renderExamStatisticsPage();
  }

  const normalizedSelectedCourseId = selectedCourseId ? String(selectedCourseId) : '';
  const normalizedCourseSearch = (courseSearchQuery || '').trim().toLowerCase();
  const visibleCourses = isAdmin
    ? courses.filter((course) => {
        if (!normalizedCourseSearch) return true;
        const searchable = [
          course.course_code || '',
          course.course_name || '',
          course.faculty_name || '',
          course.program_name || ''
        ].join(' ').toLowerCase();
        return searchable.includes(normalizedCourseSearch);
      })
    : courses;
  const filteredExams = normalizedSelectedCourseId
    ? exams.filter((exam) => String(exam.course_id) === normalizedSelectedCourseId)
    : exams;
  const filteredArchivedExams = normalizedSelectedCourseId
    ? archivedExams.filter((exam) => String(exam.course_id) === normalizedSelectedCourseId)
    : archivedExams;

  const ARCHIVED_CATEGORY_ORDER = [
    { key: 'vize', label: 'Ara Sınavlar' },
    { key: 'odev', label: 'Ödevler' },
    { key: 'final', label: 'Finaller' },
    { key: 'butunleme', label: 'Bütünlemeler' },
    { key: 'ontest', label: 'Ön Testler' },
    { key: 'diger', label: 'Diğer' },
  ];
  const getArchivedCategoryKey = (exam) => {
    const raw = String(exam.exam_weight_type || exam.exam_category || '').toLowerCase();
    if (['vize', 'ara sınav', 'ara sinav'].includes(raw)) return 'vize';
    if (['odev', 'ödev'].includes(raw)) return 'odev';
    if (raw === 'final') return 'final';
    if (['butunleme', 'bütünleme'].includes(raw)) return 'butunleme';
    if (raw === 'ontest' || raw === 'ön test' || raw === 'on test') return 'ontest';
    return 'diger';
  };
  const getExamSortTime = (exam) => {
    const d = exam.start_at || exam.end_at || exam.created_at;
    const t = d ? new Date(d).getTime() : 0;
    return Number.isNaN(t) ? 0 : t;
  };
  const groupedArchivedExams = ARCHIVED_CATEGORY_ORDER
    .map((cat) => ({
      ...cat,
      items: filteredArchivedExams.filter((exam) => getArchivedCategoryKey(exam) === cat.key),
    }))
    .filter((cat) => cat.items.length > 0)
    .map((cat) => ({
      ...cat,
      latestTime: cat.items.reduce((max, exam) => Math.max(max, getExamSortTime(exam)), 0),
    }))
    .sort((a, b) => b.latestTime - a.latestTime);

  return (
    <div className="dashboard-section">
      <div className="exams-header">
        <h2>{isAdmin ? 'Tüm Sınavlar' : 'Sınavlarım'}</h2>
        <div className="exams-header-actions">
          <button
            className="btn-create-exam"
            onClick={() => {
              if (!showCreateForm) {
                // Yeni form açılırken state'leri sıfırla ve başlangıç tarihini bugüne ayarla
                setAutoEndDateEnabled(true);
                setSelectedDuration(null);
                setFormData(prev => ({
                  ...prev,
                  course_id: activeCourseContext?.activeCourseId || '',
                  start_at: getCurrentDateTimeLocal()
                }));
              }
              setShowCreateForm(!showCreateForm);
            }}
          >
            {showCreateForm ? '✕ İptal' : '+ Yeni Sınav Oluştur'}
          </button>
        </div>
      </div>
      
      {showCreateForm && (
        <div className="create-exam-form">
          <h3>
            {editingExam ? 'Sınavı Düzenle' : 'Yeni Sınav Oluştur'}
          </h3>

          {createError && (
            <div className="alert alert-error">
              {createError}
            </div>
          )}

          <form onSubmit={handleCreateExam}>
            <div className="exam-form-section">
              <h4 className="exam-form-section-title">Genel Bilgiler</h4>
              <div className="form-row-2">
                {editingExam && (
                  <div className="form-group">
                    <label>Ders *</label>
                    <select
                      name="course_id"
                      value={formData.course_id}
                      onChange={handleInputChange}
                      required
                    >
                      <option value="">Ders Seçin</option>
                      {courses.map((course) => {
                        const code = (course.course_code || '').trim().toUpperCase() || null;
                        const name = course.course_name || `Ders ${course.course_id}`;
                        const parts = [];
                        if (course.program_name) parts.push(course.program_name);
                        if (course.faculty_name) {
                          const fn = course.faculty_name.trim();
                          parts.push(/^myo\s*:/i.test(fn) ? fn : `MYO: ${fn}`);
                        }
                        const detail = parts.length ? ` (${parts.join(' - ')})` : '';
                        const label = code ? `${code} — ${name}${detail}` : `${name}${detail}`;
                        return (
                          <option key={course.course_id} value={course.course_id}>
                            {label}
                          </option>
                        );
                      })}
                    </select>
                  </div>
                )}

                <div className="form-group" style={!editingExam ? { gridColumn: '1 / -1' } : undefined}>
                  <label>Sınav Başlığı *</label>
                  <input
                    type="text"
                    name="title"
                    value={formData.title}
                    onChange={handleInputChange}
                    required
                    placeholder="Ör: Ara Sınav"
                  />
                </div>
              </div>

              <div className="form-row-2" style={{ marginTop: '1rem' }}>
                <div className="form-group">
                  <label>Mod</label>
                  <select
                    name="mode"
                    value={formData.mode}
                    onChange={handleInputChange}
                  >
                    <option value="Online">Online</option>
                    <option value="Physical">Yüz Yüze</option>
                  </select>
                </div>

                <div className="form-group">
                  <label>Sınav Kategorisi *</label>
                  {loadingWeights ? (
                    <select disabled>
                      <option>Yükleniyor...</option>
                    </select>
                  ) : examWeights.length > 0 ? (
                    <select
                      name="exam_category"
                      value={formData.exam_weight_id || ''}
                      onChange={handleExamCategoryChange}
                      required
                    >
                      <option value="">Sınav Kategorisi Seçin</option>
                      {examWeights.map((weight) => (
                        <option key={weight.id} value={weight.id}>
                          {getExamWeightLabel(weight)}
                        </option>
                      ))}
                    </select>
                  ) : formData.course_id ? (
                    <select disabled>
                      <option>Bu ders için sınav türü bulunamadı</option>
                    </select>
                  ) : (
                    <select disabled>
                      <option>Önce ders seçiniz</option>
                    </select>
                  )}
                  {(formData.exam_effect !== null && formData.exam_effect !== undefined) && (
                    ['ontest', 'öntest'].includes(String(formData.exam_category || '').trim().toLocaleLowerCase('tr-TR'))
                      ? <p className="exam-form-helper">Öntest sonuçları not hesaplamasına dahil edilmez.</p>
                      : <p className="exam-form-helper">Katkısı: %{Number(formData.exam_effect)}</p>
                  )}
                </div>
              </div>
            </div>

            <div className="exam-form-section">
              <h4 className="exam-form-section-title">Tarih ve Süre</h4>

              <div className="form-row-2">
                <div className="form-group">
                  <label>Oturum Sayısı</label>
                  <select
                    name="session_count"
                    value={formData.session_count}
                    onChange={handleInputChange}
                  >
                    <option value={1}>Tek Oturum</option>
                    <option value={2}>2 Oturum</option>
                  </select>
                </div>

                {parseInt(formData.session_count) > 1 && (
                  <div className="form-group">
                    <label>1. Oturumdaki Öğrenci Sayısı</label>
                    <input
                      type="number"
                      name="students_per_session"
                      min="1"
                      value={formData.students_per_session}
                      onChange={handleInputChange}
                      placeholder="Örn: 60"
                    />
                    <p className="exam-form-helper">
                      İlk {formData.students_per_session || '?'} öğrenci 1. Oturum, kalanlar 2. Oturum olarak atanır.
                    </p>
                  </div>
                )}
              </div>

            {/* TEK OTURUM - Mevcut tarih/saat alanları */}
            {parseInt(formData.session_count) === 1 && (
            <>
            <div className="form-row-3" style={{ marginTop: '1rem' }}>
              <div className="form-group">
                <label>Başlangıç *</label>
                <div className="exam-datetime-row">
                  <input
                    type="date"
                    value={formData.start_at ? formData.start_at.split('T')[0] : ''}
                    onChange={(e) => handleDateTimePartChange('start_date', e.target.value)}
                    required
                    style={{ borderColor: validationErrors.start_at ? '#dc3545' : undefined }}
                  />
                  <input
                    type="time"
                    value={formData.start_at && formData.start_at.includes('T') ? formData.start_at.split('T')[1].substring(0, 5) : ''}
                    onChange={(e) => handleDateTimePartChange('start_time', e.target.value)}
                    required
                    style={{ borderColor: validationErrors.start_at ? '#dc3545' : undefined }}
                  />
                </div>
                <button
                  type="button"
                  onClick={setStartTime5MinutesLater}
                  className="exam-form-link"
                  title="Şu anki tarih ve saatten 5 dakika sonrasını seç"
                >
                  → 5 dakika sonraya ayarla
                </button>
                {validationErrors.start_at && (
                  <p className="exam-form-error">{validationErrors.start_at}</p>
                )}
              </div>

              <div className="form-group">
                <label>Bitiş *</label>
                <div className="exam-datetime-row">
                  <input
                    type="date"
                    value={formData.end_at ? formData.end_at.split('T')[0] : ''}
                    onChange={(e) => handleDateTimePartChange('end_date', e.target.value)}
                    required
                    style={{ borderColor: validationErrors.end_at ? '#dc3545' : undefined }}
                  />
                  <input
                    type="time"
                    value={formData.end_at && formData.end_at.includes('T') ? formData.end_at.split('T')[1].substring(0, 5) : ''}
                    onChange={(e) => handleDateTimePartChange('end_time', e.target.value)}
                    required
                    style={{ borderColor: validationErrors.end_at ? '#dc3545' : undefined }}
                  />
                </div>
                {validationErrors.end_at && (
                  <p className="exam-form-error">{validationErrors.end_at}</p>
                )}
              </div>

              <div className="form-group">
                <label>Süre (dakika) *</label>
                <input
                  type="number"
                  name="duration_minutes"
                  value={formData.duration_minutes}
                  onChange={handleInputChange}
                  min="1"
                  placeholder="Örn: 90"
                  required
                  style={{ borderColor: validationErrors.duration_minutes ? '#dc3545' : undefined }}
                />
                {validationErrors.duration_minutes && (
                  <p className="exam-form-error">{validationErrors.duration_minutes}</p>
                )}
              </div>
            </div>

            {/* Hızlı Süre Seçenekleri */}
            {formData.start_at && (
              <div className="exam-form-chip-row" style={{ marginTop: '0.75rem' }}>
                <span className="exam-form-chip-label">Hızlı Süre:</span>
                {[
                  { minutes: 30, label: '30 dk' },
                  { minutes: 45, label: '45 dk' },
                  { minutes: 60, label: '1 saat' },
                  { minutes: 90, label: '1.5 saat' },
                  { minutes: 120, label: '2 saat' },
                ].map((option) => (
                  <button
                    key={option.minutes}
                    type="button"
                    onClick={() => handleQuickDurationSelect(option.minutes)}
                    className={`exam-form-chip${selectedDuration === option.minutes && autoEndDateEnabled ? ' active' : ''}`}
                  >
                    {option.label}
                  </button>
                ))}
                <span className="exam-form-helper" style={{ marginLeft: 'auto' }}>
                  {autoEndDateEnabled ? 'Bitiş tarihi otomatik ayarlanıyor' : 'Bitiş tarihi manuel'}
                </span>
              </div>
            )}
            </>
            )}

            {/* 2 OTURUM - Her oturum için ayrı tarih/saat alanları */}
            {parseInt(formData.session_count) > 1 && (
              <>
                {/* 1. Oturum */}
                <div className="exam-session-card session-1">
                  <h4 className="exam-session-card-title">1. Oturum</h4>
                  <div className="form-row-3">
                    <div className="form-group">
                      <label>Başlangıç Tarihi *</label>
                      <input
                        type="date"
                        value={formData.session_1_start_at ? formData.session_1_start_at.split('T')[0] : ''}
                        onChange={(e) => {
                          const date = e.target.value;
                          const time = formData.session_1_start_at && formData.session_1_start_at.includes('T') 
                            ? formData.session_1_start_at.split('T')[1].substring(0, 5) 
                            : '09:00';
                          setFormData(prev => ({...prev, session_1_start_at: date ? `${date}T${time}` : ''}));
                        }}
                        required
                      />
                      <label style={{ marginTop: '0.5rem', display: 'block' }}>Başlangıç Saati *</label>
                      <input
                        type="time"
                        value={formData.session_1_start_at && formData.session_1_start_at.includes('T') ? formData.session_1_start_at.split('T')[1].substring(0, 5) : ''}
                        onChange={(e) => {
                          const time = e.target.value;
                          let date = formData.session_1_start_at ? formData.session_1_start_at.split('T')[0] : '';
                          if (!date) {
                            date = new Date().toISOString().split('T')[0];
                          }
                          setFormData(prev => ({...prev, session_1_start_at: `${date}T${time}`}));
                        }}
                        required
                      />
                    </div>
                    <div className="form-group">
                      <label>Bitiş Tarihi *</label>
                      <input
                        type="date"
                        value={formData.session_1_end_at ? formData.session_1_end_at.split('T')[0] : ''}
                        onChange={(e) => {
                          const date = e.target.value;
                          const time = formData.session_1_end_at && formData.session_1_end_at.includes('T') 
                            ? formData.session_1_end_at.split('T')[1].substring(0, 5) 
                            : '10:00';
                          setFormData(prev => ({...prev, session_1_end_at: date ? `${date}T${time}` : ''}));
                        }}
                        required
                      />
                      <label style={{ marginTop: '0.5rem', display: 'block' }}>Bitiş Saati *</label>
                      <input
                        type="time"
                        value={formData.session_1_end_at && formData.session_1_end_at.includes('T') ? formData.session_1_end_at.split('T')[1].substring(0, 5) : ''}
                        onChange={(e) => {
                          const time = e.target.value;
                          let date = formData.session_1_end_at ? formData.session_1_end_at.split('T')[0] : '';
                          if (!date) {
                            date = new Date().toISOString().split('T')[0];
                          }
                          setFormData(prev => ({...prev, session_1_end_at: `${date}T${time}`}));
                        }}
                        required
                      />
                    </div>
                    <div className="form-group">
                      <label>Süre (dakika) *</label>
                      <input
                        type="number"
                        name="duration_minutes"
                        value={formData.duration_minutes}
                        onChange={handleInputChange}
                        min="1"
                        placeholder="Örn: 90"
                        required
                        style={{
                          borderColor: validationErrors.duration_minutes ? '#dc3545' : undefined
                        }}
                      />
                      {validationErrors.duration_minutes && (
                        <small style={{ color: '#dc3545', display: 'block', marginTop: '0.25rem' }}>
                          {validationErrors.duration_minutes}
                        </small>
                      )}
                    </div>
                  </div>
                  {validationErrors.session_1 && (
                    <small style={{ color: '#dc3545', display: 'block', marginTop: '0.5rem' }}>
                      {validationErrors.session_1}
                    </small>
                  )}
                </div>

                {/* 2. Oturum */}
                <div className="exam-session-card session-2">
                  <h4 className="exam-session-card-title">2. Oturum</h4>
                  <div className="form-row-3">
                    <div className="form-group">
                      <label>Başlangıç Tarihi *</label>
                      <input
                        type="date"
                        value={formData.session_2_start_at ? formData.session_2_start_at.split('T')[0] : ''}
                        onChange={(e) => {
                          const date = e.target.value;
                          const time = formData.session_2_start_at && formData.session_2_start_at.includes('T') 
                            ? formData.session_2_start_at.split('T')[1].substring(0, 5) 
                            : '14:00';
                          setFormData(prev => ({...prev, session_2_start_at: date ? `${date}T${time}` : ''}));
                        }}
                        required
                      />
                      <label style={{ marginTop: '0.5rem', display: 'block' }}>Başlangıç Saati *</label>
                      <input
                        type="time"
                        value={formData.session_2_start_at && formData.session_2_start_at.includes('T') ? formData.session_2_start_at.split('T')[1].substring(0, 5) : ''}
                        onChange={(e) => {
                          const time = e.target.value;
                          let date = formData.session_2_start_at ? formData.session_2_start_at.split('T')[0] : '';
                          if (!date) {
                            date = new Date().toISOString().split('T')[0];
                          }
                          setFormData(prev => ({...prev, session_2_start_at: `${date}T${time}`}));
                        }}
                        required
                      />
                    </div>
                    <div className="form-group">
                      <label>Bitiş Tarihi *</label>
                      <input
                        type="date"
                        value={formData.session_2_end_at ? formData.session_2_end_at.split('T')[0] : ''}
                        onChange={(e) => {
                          const date = e.target.value;
                          const time = formData.session_2_end_at && formData.session_2_end_at.includes('T') 
                            ? formData.session_2_end_at.split('T')[1].substring(0, 5) 
                            : '15:00';
                          setFormData(prev => ({...prev, session_2_end_at: date ? `${date}T${time}` : ''}));
                        }}
                        required
                      />
                      <label style={{ marginTop: '0.5rem', display: 'block' }}>Bitiş Saati *</label>
                      <input
                        type="time"
                        value={formData.session_2_end_at && formData.session_2_end_at.includes('T') ? formData.session_2_end_at.split('T')[1].substring(0, 5) : ''}
                        onChange={(e) => {
                          const time = e.target.value;
                          let date = formData.session_2_end_at ? formData.session_2_end_at.split('T')[0] : '';
                          if (!date) {
                            date = new Date().toISOString().split('T')[0];
                          }
                          setFormData(prev => ({...prev, session_2_end_at: `${date}T${time}`}));
                        }}
                        required
                      />
                    </div>
                    <div className="form-group">
                      <label>Süre</label>
                      <div className="exam-session-note">
                        Her iki oturum için aynı: {formData.duration_minutes || '-'} dk
                      </div>
                    </div>
                  </div>
                  {validationErrors.session_2 && (
                    <p className="exam-form-error">{validationErrors.session_2}</p>
                  )}
                </div>
              </>
            )}
            </div>

            {/* Öğrenci Seçimi */}
            <div className="exam-form-section">
              <h4 className="exam-form-section-title">Öğrenci Seçimi</h4>
              <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem' }}>
                <button
                  type="button"
                  className={selectedStudents === 'all' ? 'btn btn-secondary' : 'btn btn-primary'}
                  style={selectedStudents !== 'all' ? { background: '#2e7d32', color: 'white' } : undefined}
                  onClick={handleOpenStudentModal}
                  disabled={!formData.course_id || loadingStudentList}
                >
                  {loadingStudentList
                    ? 'Öğrenciler yükleniyor...'
                    : selectedStudents === 'all'
                      ? 'Öğrenci Seç (Tüm öğrenciler)'
                      : `${selectedStudents.length} öğrenci seçildi`}
                </button>
                {selectedStudents !== 'all' && (
                  <button
                    type="button"
                    className="btn btn-secondary"
                    style={{ padding: '0.35rem 0.65rem', fontWeight: 700 }}
                    onClick={() => setSelectedStudents('all')}
                    title="Seçimi temizle"
                  >
                    ×
                  </button>
                )}
              </div>
              <p className="exam-form-helper" style={{ marginTop: '0.5rem' }}>
                Seçim yapılmazsa sınav dersteki tüm öğrencilere tanımlanır.
              </p>
            </div>

            {/* Sınav Ayarları */}
            <div className="exam-form-section">
              <h4 className="exam-form-section-title">Sınav Ayarları</h4>
              {formData.mode === 'Physical' && (
                <p className="exam-form-helper" style={{ marginBottom: '1rem' }}>
                  Yüz yüze sınavda giriş hakkı kullanılmaz (devre dışıdır). Karıştırma türü kitapçık oluşturulurken uygulanır.
                </p>
              )}
              <div className="form-row-3">
                <div className="form-group">
                  <label>Giriş Hakkı Sayısı *</label>
                  <input
                    type="number"
                    name="max_attempts"
                    min="1"
                    value={formData.max_attempts}
                    onChange={handleInputChange}
                    required={formData.mode !== 'Physical'}
                    disabled={formData.mode === 'Physical'}
                    style={formData.mode === 'Physical' ? { opacity: 0.7, cursor: 'not-allowed', backgroundColor: '#f8f9fa' } : undefined}
                  />
                </div>

                <div className="form-group">
                  <label>Karıştırma Türü *</label>
                  <select
                    name="shuffle_type"
                    value={formData.shuffle_type}
                    onChange={handleInputChange}
                    required
                  >
                    <option value="none">Karıştırma yok</option>
                    <option value="questions">Sadece soruları karıştır</option>
                    <option value="choices">Sadece şıkları karıştır</option>
                    <option value="both">Hem soruları hem şıkları karıştır</option>
                  </select>
                </div>

                <div className="form-group">
                  <label>Soru Sayısı *</label>
                  <input
                    type="number"
                    name="random_question_count"
                    min="1"
                    value={formData.random_question_count}
                    onChange={handleInputChange}
                    placeholder="Kaç soru sorulsun?"
                    required
                  />
                  {validationErrors.question_count && (
                    <span className="validation-error">{validationErrors.question_count}</span>
                  )}
                </div>
              </div>
            </div>

            {/* Onay Mesajları */}
            <div className="exam-form-section">
              <h4 className="exam-form-section-title">Onay Mesajları</h4>
              <div className="form-group">
                <label>Giriş Onay Mesajı *</label>
                <textarea
                  name="entrance_confirmation"
                  value={formData.entrance_confirmation}
                  onChange={handleInputChange}
                  rows="3"
                  placeholder="Sınav başlangıcında öğrencilere gösterilecek onay mesajı"
                  required
                />
                <p className="exam-form-helper">
                  Bu mesaj sınav başlangıcında öğrencilere gösterilecek ve onaylamaları gerekecek.
                </p>
              </div>

              <div className="form-group" style={{ marginTop: '1.25rem' }}>
                <label>Çıkış Onay Mesajı *</label>
                <textarea
                  name="finish_confirmation"
                  value={formData.finish_confirmation}
                  onChange={handleInputChange}
                  rows="3"
                  placeholder="Sınav bitişinde öğrencilere gösterilecek onay mesajı"
                  required
                />
                <p className="exam-form-helper">
                  Bu mesaj sınav bitişinde öğrencilere gösterilecek ve onaylamaları gerekecek.
                </p>
              </div>
            </div>
            
            <div className="form-actions">
              <button
                type="button"
                onClick={() => {
                  setAutoEndDateEnabled(true);
                  setSelectedDuration(null);
                  setShowCreateForm(false);
                  setSelectedStudents('all');
                  setStudentList([]);
                  setModalStudents([]);
                }}
                className="btn btn-secondary"
              >
                İptal
              </button>
              <button
                type="submit"
                disabled={creating}
                className="btn btn-primary"
                style={{
                  background: BUTTON_COLORS.success,
                  color: 'white'
                }}
              >
                {creating ? (editingExam ? 'Kaydediliyor...' : 'Oluşturuluyor...') : (editingExam ? 'Kaydet' : 'Sınav Oluştur')}
              </button>
            </div>
          </form>
        </div>
      )}
      
      {/* Öğrenci Seçim Modalı */}
      {showStudentModal && (() => {
        const getStudentKey = (s) => s.student_number;
        const getStudentName = (s) => s.name ?? s.student_name ?? '';
        const getStudentProgram = (s) => s.program ?? s.program_name ?? '';
        const filteredStudents = studentList.filter(s => {
          const matchSearch = !studentSearch ||
            getStudentName(s).toLowerCase().includes(studentSearch.toLowerCase()) ||
            (s.student_number || '').includes(studentSearch);
          const matchClass = !studentClassFilter || getStudentProgram(s) === studentClassFilter;
          return matchSearch && matchClass;
        });
        const classOptions = [...new Set(studentList.map(s => getStudentProgram(s)).filter(Boolean))];
        return (
          <div className="modal-overlay" onClick={() => setShowStudentModal(false)}>
            <div className="modal-content" style={{ maxWidth: '650px' }} onClick={e => e.stopPropagation()}>
              <div className="modal-header">
                <h3>Öğrenci Seç</h3>
                <button className="modal-close" onClick={() => setShowStudentModal(false)}>×</button>
              </div>
              <div style={{ padding: '1rem 1.5rem', borderBottom: '1px solid #e9ecef', display: 'flex', gap: '0.75rem', flexWrap: 'wrap' }}>
                <input
                  type="text"
                  placeholder="Ad veya numara ile ara..."
                  value={studentSearch}
                  onChange={e => setStudentSearch(e.target.value)}
                  style={{ flex: 1, minWidth: '160px', padding: '0.5rem 0.75rem', borderRadius: '8px', border: '1px solid #ced4da', fontSize: '0.9rem' }}
                />
                <select
                  value={studentClassFilter}
                  onChange={e => setStudentClassFilter(e.target.value)}
                  style={{ padding: '0.5rem 0.75rem', borderRadius: '8px', border: '1px solid #ced4da', fontSize: '0.9rem' }}
                >
                  <option value="">Tüm Şubeler</option>
                  {classOptions.map(cls => (
                    <option key={cls} value={cls}>{cls}</option>
                  ))}
                </select>
              </div>
              <div style={{ overflowY: 'auto', maxHeight: '380px' }}>
                <div style={{ padding: '0.6rem 1.5rem', background: '#f8f9fa', borderBottom: '1px solid #e9ecef', display: 'flex', alignItems: 'center', gap: '0.75rem' }}>
                  <input
                    type="checkbox"
                    id="selectAllStudents"
                    checked={filteredStudents.length > 0 && filteredStudents.every(s => modalStudents.includes(getStudentKey(s)))}
                    onChange={() => handleMasterCheck(filteredStudents, getStudentKey)}
                  />
                  <label htmlFor="selectAllStudents" style={{ fontWeight: 600, cursor: 'pointer', margin: 0, userSelect: 'none' }}>
                    Tümünü seç ({filteredStudents.length} öğrenci)
                  </label>
                </div>
                {filteredStudents.map(student => {
                  const sno = student.student_number;
                  return (
                    <div
                      key={sno}
                      style={{ display: 'flex', alignItems: 'center', gap: '0.75rem', padding: '0.55rem 1.5rem', borderBottom: '1px solid #f0f0f0', cursor: 'pointer' }}
                      onClick={() => toggleModalStudent(sno)}
                    >
                      <input type="checkbox" checked={modalStudents.includes(sno)} onChange={() => {}} />
                      <span style={{ minWidth: '90px', color: '#64748b', fontSize: '0.85rem' }}>{student.student_number}</span>
                      <span style={{ flex: 1, fontSize: '0.9rem' }}>{student.name ?? student.student_name}</span>
                      <span style={{ color: '#64748b', fontSize: '0.8rem' }}>{(student.program ?? student.program_name) || '—'}</span>
                    </div>
                  );
                })}
                {filteredStudents.length === 0 && (
                  <p style={{ textAlign: 'center', color: '#64748b', padding: '2rem', margin: 0 }}>Öğrenci bulunamadı</p>
                )}
              </div>
              <div style={{ padding: '1rem 1.5rem', borderTop: '2px solid #e9ecef', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <span style={{ color: '#64748b', fontWeight: 600 }}>
                  {modalStudents.length} öğrenci seçildi
                </span>
                <div style={{ display: 'flex', gap: '0.75rem' }}>
                  <button
                    type="button"
                    className="btn btn-secondary"
                    onClick={() => {
                      setModalStudents(selectedStudents === 'all' ? [] : [...selectedStudents]);
                      setShowStudentModal(false);
                    }}
                  >
                    Vazgeç
                  </button>
                  <button
                    type="button"
                    className="btn btn-primary"
                    style={{ background: '#2e7d32', color: 'white' }}
                    onClick={() => {
                      setSelectedStudents(modalStudents.length > 0 ? [...modalStudents] : 'all');
                      setShowStudentModal(false);
                    }}
                  >
                    Onayla
                  </button>
                </div>
              </div>
            </div>
          </div>
        );
      })()}

      {/* Değerlendirme Paneli */}
      {gradingExamId ? (
        <InstructorExamGrading
          examId={gradingExamId}
          instructorId={instructorId}
          onBack={() => {
            setGradingExamId(null);
            setShowArchived(false); // Arşivden dönüşte aktif sınavlar paneline dön
            fetchExams(false);
          }}
        />
      ) : (
        <>
          {isAdmin && (
            <div className="create-exam-form" style={{ marginBottom: '1rem' }}>
              <h3 style={{ marginBottom: '0.75rem', color: '#1A202C' }}>Derslerim</h3>
              {courses.length === 0 ? (
                <p style={{ margin: 0, color: '#6c757d' }}>Ders listesi bulunamadi.</p>
              ) : (
                <div>
                  <input
                    type="text"
                    value={courseSearchQuery}
                    onChange={(e) => setCourseSearchQuery(e.target.value)}
                    placeholder="Ders kodu, ders adi, fakulte veya bolum ara..."
                    style={{
                      width: '100%',
                      marginBottom: '0.75rem',
                      padding: '0.65rem 0.8rem',
                      border: '1px solid #dee2e6',
                      borderRadius: '6px',
                      fontSize: '0.92rem'
                    }}
                  />
                  <div className="courses-table-wrap">
                    <table className="courses-table">
                      <thead>
                        <tr>
                          <th>Ders Kodu</th>
                          <th>Ders Adi</th>
                          <th>Fakulte</th>
                          <th>Bolum</th>
                        </tr>
                      </thead>
                      <tbody>
                        {visibleCourses.length === 0 ? (
                          <tr>
                            <td colSpan={4} style={{ padding: '1rem', color: '#6c757d' }}>
                              Aramaya uygun ders bulunamadi.
                            </td>
                          </tr>
                        ) : (
                          visibleCourses.map((course) => {
                            const isSelected = String(course.course_id) === normalizedSelectedCourseId;
                            return (
                              <tr
                                key={course.course_id}
                                className="courses-table-row"
                                onClick={() => openCourseStatisticsPage(course)}
                                style={isSelected ? { background: '#f1f3f5', borderLeftColor: '#4CAF50' } : undefined}
                              >
                                <td>{course.course_code || '-'}</td>
                                <td className="course-name-cell">{course.course_name || '-'}</td>
                                <td>{course.faculty_name || '-'}</td>
                                <td>{course.program_name || '-'}</td>
                              </tr>
                            );
                          })
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              )}
            </div>
          )}
          {exams.length === 0 ? (
            <div className="empty-state">
              <p>{isAdmin ? 'Henüz sınav bulunmamaktadır.' : 'Henüz sınavınız bulunmamaktadır.'}</p>
            </div>
          ) : isAdmin && normalizedSelectedCourseId && filteredExams.length === 0 && filteredArchivedExams.length === 0 ? (
            <div className="empty-state">
              <p>Secilen derse ait sinav bulunmamaktadir.</p>
            </div>
          ) : (
            <div className="exams-list">
          {filteredExams.map((exam) => (
            <div
              key={exam.exam_id}
              className="exam-card"
            >
              <div className="exam-header">
                <h3>{exam.title}</h3>
                <div className="exam-header-badges">
                  {getStatusBadge(exam.status)}
                </div>
              </div>
              <div className="exam-details">
                <div className="exam-info-card exam-info-full">
                  <span className="info-label">Ders:</span>
                  <span className="info-value">{exam.course_name}</span>
                </div>
                {isProgramBaskan && exam.creator_name && (
                  <div className="exam-info-card">
                    <span className="info-label">Oluşturan:</span>
                    <span className="info-value">{exam.creator_name}</span>
                  </div>
                )}
                {(exam.exam_weight_type || exam.exam_category) && (
                  <div className="exam-info-card">
                    <span className="info-label">Sınav Türü:</span>
                    <span className="info-value">
                      {(() => {
                        const typeLabels = {
                          'final': 'Dönem Sonu Sınavı', 'Final': 'Dönem Sonu Sınavı',
                          'vize': 'Ara Sınav', 'Vize': 'Ara Sınav', 'Ara Sınav': 'Ara Sınav',
                          'butunleme': 'Bütünleme', 'bütünleme': 'Bütünleme', 'Butunleme': 'Bütünleme', 'Bütünleme': 'Bütünleme',
                          'odev': 'Ödev', 'Odev': 'Ödev', 'Ödev': 'Ödev',
                          'Ontest': 'Öntest', 'ontest': 'Öntest', 'Öntest': 'Öntest',
                        };
                        const raw = exam.exam_weight_type || exam.exam_category || '';
                        const label = typeLabels[raw] || raw;
                        const isOntest = ['ontest', 'öntest'].includes(String(raw).trim().toLocaleLowerCase('tr-TR'));
                        const effect = !isOntest && exam.exam_effect != null ? ` (%${Number(exam.exam_effect)})` : '';
                        return label + effect;
                      })()}
                    </span>
                  </div>
                )}
                <div className="exam-info-card">
                  <span className="info-label">Başlangıç:</span>
                  <span className="info-value">{formatDate(exam.start_at)}</span>
                </div>
                <div className="exam-info-card">
                  <span className="info-label">Bitiş:</span>
                  <span className="info-value">{formatDate(exam.end_at)}</span>
                </div>
                {exam.duration_minutes && (
                  <div className="exam-info-card">
                    <span className="info-label">Süre:</span>
                    <span className="info-value">{exam.duration_minutes} dakika</span>
                  </div>
                )}
                <div className="exam-info-card">
                  <span className="info-label">Soru Sayısı:</span>
                  <span className="info-value exam-info-question">
                    <span className={`exam-info-question-assigned ${(exam.question_count || 0) > 0 ? '' : 'empty'}`}>
                      {(exam.question_count || 0) > 0
                        ? `${exam.question_count} soru atanmış`
                        : 'Soru sayısı belirtilmemiş'}
                    </span>
                  </span>
                </div>
              </div>
              <div className="exam-actions" onClick={(e) => e.stopPropagation()}>
                {(() => {
                  const now = new Date();
                  const startDate = exam.start_at ? new Date(exam.start_at) : null;
                  const endDate = exam.end_at ? new Date(exam.end_at) : null;
                  const isStarted = startDate && startDate <= now;
                  const isEnded = endDate && endDate < now;
                  const isDraft = exam.status === 'Draft';
                  const isPublished = exam.status === 'Published';
                  const isArchived = exam.status === 'Archived';
                  const canManage = isDraft && !isStarted && !isEnded;
                  const canGrade = (isPublished || isArchived) && isEnded;
                  const questionCount = exam.question_count || 0;
                  const totalQuestionCount = exam.total_question_count || 0;
                  const hasQuestions = totalQuestionCount > 0;
                  const canPublish = questionCount > 0 && hasQuestions && examsWithPoints.has(exam.exam_id);
                  
                  return (
                    <>
                      {/* Sol taraftaki butonlar */}
                      <div className="exam-actions-left">
                        {/* Arşivlenmiş sınavlarda Soruları Yönet ve Düzenle butonları gösterilmez */}
                        {!isArchived && (
                          <>
                            <button
                              className="btn btn-primary"
                              onClick={() => openQuestionModal(exam)}
                              disabled={!canManage}
                              style={{ background: BUTTON_COLORS.primaryDark, color: 'white' }}
                              title={!canManage ? (isPublished ? 'Yayınlanmış sınavlarda sorular yönetilemez' : isEnded ? 'Sınav bittikten sonra sorular yönetilemez' : 'Sınav başladıktan sonra sorular yönetilemez') : 'Soruları Yönet'}
                            >
                              Soruları Yönet
                            </button>
                            <button
                              className="btn btn-secondary"
                              onClick={() => openEditExamModal(exam)}
                              disabled={!canManage}
                              title={!canManage ? (isPublished ? 'Yayınlanmış sınavlar düzenlenemez' : isEnded ? 'Sınav bittikten sonra düzenlenemez' : 'Sınav başladıktan sonra düzenlenemez') : 'Sınavı Düzenle'}
                            >
                              Düzenle
                            </button>
                          </>
                        )}
                        {isPublished && (
                          <button
                            className="btn"
                            onClick={() => handleDraftClick(exam)}
                            style={{ background: BUTTON_COLORS.primaryDark, color: 'white' }}
                            title="Sınavı Taslağa Al"
                          >
                            Taslağa Al
                          </button>
                        )}
                        {/* Değerlendirme butonu - sınav bitmişse ve yayınlanmış/arşivlenmişse göster */}
                        {canGrade && (
                          <button
                            className="btn"
                            onClick={() => setGradingExamId(exam.exam_id)}
                            style={{ background: BUTTON_COLORS.warning, color: 'white' }}
                            title="Sınav Kağıtlarını Değerlendir"
                          >
                            Değerlendir
                          </button>
                        )}
                        {/* Ek Süre butonu - her zaman göster */}
                        <button
                          className="btn"
                          onClick={() => openExtendTimeModal(exam)}
                          style={{ background: BUTTON_COLORS.success, color: 'white' }}
                          title="Öğrencilere Ek Süre Ver"
                        >
                          Ek Süre
                        </button>
                        <button
                          className="btn"
                          onClick={() => openViolationsPage(exam)}
                          style={{ background: BUTTON_COLORS.warning, color: 'white' }}
                          title="Sınav ihlallerini görüntüle"
                        >
                          İhlal
                        </button>
                        {/* Sonuçları Yayınla butonu - sadece arşivlenmiş ve sonuçlar yayınlanmamış sınavlarda göster */}
                        {isArchived && (exam.results_published === false || exam.results_published === null) && (
                          <button
                            className="btn"
                            onClick={() => handlePublishResultsClick(exam)}
                            disabled={publishing && publishingExamId === exam.exam_id}
                            style={{ 
                              background: publishing && publishingExamId === exam.exam_id ? '#6c757d' : '#28a745',
                              color: 'white'
                            }}
                            title="Sınav Sonuçlarını Yayınla"
                          >
                            {publishing && publishingExamId === exam.exam_id ? 'Yayınlanıyor...' : 'Sonuçları Yayınla'}
                          </button>
                        )}
                        {isArchived && (
                          <button
                            className="btn"
                            onClick={() => downloadGradesExcel(exam)}
                            disabled={!exam.results_published}
                            style={{
                              background: exam.results_published ? '#17a2b8' : '#adb5bd',
                              color: 'white',
                              cursor: exam.results_published ? 'pointer' : 'not-allowed'
                            }}
                            title={exam.results_published ? 'Not Listesini İndir' : 'Sonuçlar yayınlanmadan not listesi indirilemez'}
                          >
                            Not Listesi İndir
                          </button>
                        )}
                      </div>

                      {/* Sağ taraftaki butonlar (Önizle ve Yayınla) */}
                      <div className="exam-actions-right" style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end', gap: '0.45rem' }}>
                        {isDraft && exam.mode !== 'Physical' && !canPublish && (
                          <div
                            style={{
                              fontSize: '0.82rem',
                              fontWeight: '600',
                              color: '#9a3412',
                              background: '#fff7ed',
                              border: '1px solid #fdba74',
                              borderRadius: '6px',
                              padding: '0.3rem 0.55rem',
                              maxWidth: '280px',
                              textAlign: 'center'
                            }}
                          >
                            {!hasQuestions
                              ? 'Yayınlamak için önce soru ekleyin.'
                              : 'Yayınlamak için Önizle sayfasında puanları kaydedin.'}
                          </div>
                        )}
                        <div style={{ display: 'flex', alignItems: 'center', gap: '0.45rem' }}>
                          {(!isProgramBaskan || String(exam.created_by) === String(instructorId)) && (
                            <button
                              className="btn"
                              onClick={() => handleDeleteClick(exam)}
                              style={{ background: BUTTON_COLORS.danger, color: 'white' }}
                              title="Sınavı Sil"
                            >
                              Sil
                            </button>
                          )}
                          <button
                            className="btn"
                            onClick={() => openPreviewModal(exam)}
                            style={{ background: BUTTON_COLORS.primaryDark, color: 'white' }}
                            title="Sınav Önizlemesi"
                          >
                            Önizle
                          </button>
                          {isDraft && exam.mode === 'Physical' && (
                            <button
                              className="btn btn-primary"
                              onClick={() => openBookletsPage(exam)}
                              disabled={!canPublish}
                              style={{ background: BUTTON_COLORS.success, color: 'white' }}
                              title={!canPublish ? 'Sınava en az bir soru eklenmelidir' : 'Kitapçıklar'}
                            >
                              Kitapçıklar
                            </button>
                          )}
                          {isDraft && exam.mode !== 'Physical' && (
                            <button
                              className="btn btn-primary"
                              onClick={() => handlePublishClick(exam)}
                              disabled={!canPublish}
                              style={{ background: BUTTON_COLORS.success, color: 'white' }}
                              title={!canPublish ? (!hasQuestions ? 'Sınava en az bir soru eklenmelidir' : 'Yayınlamak için önizleme yapılmalı ve tüm sorulara puan girilmelidir') : 'Sınavı Yayınla'}
                            >
                              Yayınla
                            </button>
                          )}
                        </div>
                      </div>
                    </>
                  );
                })()}
              </div>
            </div>
          ))}
        </div>
      )}

      {/* Geçmiş Sınavlar - Kategori Bölümleri */}
      <div className="archived-section">
        {loadingArchived ? (
          <div className="empty-state"><p>Yükleniyor...</p></div>
        ) : filteredArchivedExams.length === 0 ? (
          <div className="empty-state"><p>Geçmiş sınav bulunmamaktadır.</p></div>
        ) : (
          <div className="archived-categories">
            {groupedArchivedExams.map((category) => {
              const isOpen = openArchivedCategories[category.key] === true;
              return (
                <div key={category.key} className="archived-category">
                  <div
                    className="archived-section-header"
                    onClick={() => setOpenArchivedCategories(prev => ({ ...prev, [category.key]: !prev[category.key] }))}
                  >
                    <h2>
                      {category.label}
                      <span className="archived-category-count">({category.items.length})</span>
                    </h2>
                    <span className="archived-toggle-icon">{isOpen ? '▲' : '▼'}</span>
                  </div>
                  {isOpen && (
                    <div className="exams-list">
                      {category.items.map((exam) => (
                <div
                  key={exam.exam_id}
                  className="exam-card"
                >
                  <div className="exam-header">
                    <h3>{exam.title}</h3>
                    <div className="exam-header-badges">
                    </div>
                  </div>
                  <div className="exam-details">
                    <div className="exam-info-card exam-info-full">
                      <span className="info-label">Ders:</span>
                      <span className="info-value">{exam.course_name}</span>
                    </div>
                    {isProgramBaskan && exam.creator_name && (
                      <div className="exam-info-card">
                        <span className="info-label">Oluşturan:</span>
                        <span className="info-value">{exam.creator_name}</span>
                      </div>
                    )}
                    {(exam.exam_weight_type || exam.exam_category) && (
                      <div className="exam-info-card">
                        <span className="info-label">Sınav Türü:</span>
                        <span className="info-value">
                          {(() => {
                            const typeLabels = {
                              'final': 'Dönem Sonu Sınavı', 'Final': 'Dönem Sonu Sınavı',
                              'vize': 'Ara Sınav', 'Vize': 'Ara Sınav', 'Ara Sınav': 'Ara Sınav',
                              'butunleme': 'Bütünleme', 'bütünleme': 'Bütünleme', 'Butunleme': 'Bütünleme', 'Bütünleme': 'Bütünleme',
                              'odev': 'Ödev', 'Odev': 'Ödev', 'Ödev': 'Ödev',
                              'Ontest': 'Öntest', 'ontest': 'Öntest', 'Öntest': 'Öntest',
                            };
                            const raw = exam.exam_weight_type || exam.exam_category || '';
                            const label = typeLabels[raw] || raw;
                            const isOntest = ['ontest', 'öntest'].includes(String(raw).trim().toLocaleLowerCase('tr-TR'));
                            const effect = !isOntest && exam.exam_effect != null ? ` (%${Number(exam.exam_effect)})` : '';
                            return label + effect;
                          })()}
                        </span>
                      </div>
                    )}
                    <div className="exam-info-card">
                      <span className="info-label">Başlangıç:</span>
                      <span className="info-value">{formatDate(exam.start_at)}</span>
                    </div>
                    <div className="exam-info-card">
                      <span className="info-label">Bitiş:</span>
                      <span className="info-value">{formatDate(exam.end_at)}</span>
                    </div>
                    {exam.duration_minutes && (
                      <div className="exam-info-card">
                        <span className="info-label">Süre:</span>
                        <span className="info-value">{exam.duration_minutes} dakika</span>
                      </div>
                    )}
                    <div className="exam-info-card">
                      <span className="info-label">Soru Sayısı:</span>
                      <span className="info-value exam-info-question">
                        <span className={`exam-info-question-assigned ${(exam.question_count || 0) > 0 ? '' : 'empty'}`}>
                          {(exam.question_count || 0) > 0
                            ? `${exam.question_count} soru atanmış`
                            : 'Soru sayısı belirtilmemiş'}
                        </span>
                      </span>
                    </div>
                  </div>
                  <div className="exam-actions" onClick={(e) => e.stopPropagation()}>
                    {(() => {
                      const now = new Date();
                      const startDate = exam.start_at ? new Date(exam.start_at) : null;
                      const endDate = exam.end_at ? new Date(exam.end_at) : null;
                      const isStarted = startDate && startDate <= now;
                      const isEnded = endDate && endDate < now;
                      const isDraft = exam.status === 'Draft';
                      const isPublished = exam.status === 'Published';
                      const isArchived = exam.status === 'Archived';
                      const canGrade = (isPublished || isArchived) && isEnded;
                      const questionCount = exam.question_count || 0;
                      const totalQuestionCount = exam.total_question_count || 0;
                      const hasQuestions = totalQuestionCount > 0;
                      const canPublish = questionCount > 0 && hasQuestions && examsWithPoints.has(exam.exam_id);
                      return (
                        <>
                          <div className="exam-actions-left">
                            {canGrade && (
                              <button
                                className="btn"
                                onClick={() => setGradingExamId(exam.exam_id)}
                                style={{ background: BUTTON_COLORS.warning, color: 'white' }}
                                title="Sınav Kağıtlarını Değerlendir"
                              >
                                Değerlendir
                              </button>
                            )}
                            <button
                              className="btn"
                              onClick={() => openExtendTimeModal(exam)}
                              style={{ background: BUTTON_COLORS.success, color: 'white' }}
                              title="Öğrencilere Ek Süre Ver"
                            >
                              Ek Süre
                            </button>
                            <button
                              className="btn"
                              onClick={() => openViolationsPage(exam)}
                              style={{ background: BUTTON_COLORS.warning, color: 'white' }}
                              title="Sınav ihlallerini görüntüle"
                            >
                              İhlal
                            </button>
                            {isArchived && (exam.results_published === false || exam.results_published === null) && (
                              <button
                                className="btn"
                                onClick={() => handlePublishResultsClick(exam)}
                                disabled={publishing && publishingExamId === exam.exam_id}
                                style={{
                                  background: publishing && publishingExamId === exam.exam_id ? '#6c757d' : '#28a745',
                                  color: 'white'
                                }}
                                title="Sınav Sonuçlarını Yayınla"
                              >
                                {publishing && publishingExamId === exam.exam_id ? 'Yayınlanıyor...' : 'Sonuçları Yayınla'}
                              </button>
                            )}
                            {isArchived && (
                              <button
                                className="btn"
                                onClick={() => downloadGradesExcel(exam)}
                                disabled={!exam.results_published}
                                style={{
                                  background: exam.results_published ? '#17a2b8' : '#adb5bd',
                                  color: 'white',
                                  cursor: exam.results_published ? 'pointer' : 'not-allowed'
                                }}
                                title={exam.results_published ? 'Not Listesini İndir' : 'Sonuçlar yayınlanmadan not listesi indirilemez'}
                              >
                                Not Listesi İndir
                              </button>
                            )}
                          </div>
                          <div className="exam-actions-right">
                            {(!isProgramBaskan || String(exam.created_by) === String(instructorId)) && (
                              <button
                                className="btn"
                                onClick={() => handleDeleteClick(exam)}
                                style={{ background: BUTTON_COLORS.danger, color: 'white' }}
                                title="Sınavı Sil"
                              >
                                Sil
                              </button>
                            )}
                            <button
                              className="btn"
                              onClick={() => openPreviewModal(exam)}
                              style={{ background: BUTTON_COLORS.primaryDark, color: 'white' }}
                              title="Sınav Önizlemesi"
                            >
                              Önizle
                            </button>
                          </div>
                        </>
                      );
                    })()}
                  </div>
                </div>
                      ))}
                    </div>
                  )}
                </div>
                );
              })}
            </div>
          )}
      </div>

      </>
      )}
      
      {/* Soru Ekleme Modal - Kaldırıldı, sayfa olarak gösteriliyor */}
      {false && !gradingExamId && false && selectedExam && (
        <div className="modal-overlay" onClick={() => {
          setCurrentPage(null);
          setPageData(null);
          setQuestionError('');
          setUploadErrors([]);
          setUploadStatistics(null);
          setUploadSuccessMessage('');
          setExcelFile(null);
          fetchExams(showArchived); // Modal kapandığında listeyi yenile
        }}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()} style={{
            maxHeight: '85vh',
            height: '85vh',
            minHeight: '85vh',
            display: 'flex',
            flexDirection: 'column'
          }}>
            <div className="modal-header" style={{ flexShrink: 0 }}>
              <h3>{selectedExam.title} - Sorular</h3>
              <button className="modal-close" onClick={() => {
                setCurrentPage(null);
                setPageData(null);
                setQuestionError('');
                setUploadErrors([]);
                setUploadStatistics(null);
                setUploadSuccessMessage('');
                setExcelFile(null);
                fetchExams(showArchived); // Modal kapandığında listeyi yenile
              }}>×</button>
            </div>
            
            <div className="modal-body" style={{
              flex: 1,
              overflowY: 'hidden',
              minHeight: 0,
              display: 'flex',
              flexDirection: 'column'
            }}>
              {/* Soru Havuzu İçeriği */}
              <div style={{ 
                flex: 1,
                display: 'flex',
                flexDirection: 'column',
                minHeight: 0,
                overflowY: 'auto',
                paddingBottom: '1rem'
              }}>
              
              {/* Hata Mesajları */}
              {questionError && (
                <div className="alert alert-error" style={{ 
                  marginBottom: '1rem', 
                  padding: '1rem', 
                  backgroundColor: '#f8d7da', 
                  color: '#721c24', 
                  borderRadius: '8px',
                  border: '1px solid #f5c6cb',
                  fontSize: '0.95rem',
                  fontWeight: '500'
                }}>
                  <strong>⚠️ Hata:</strong> {questionError}
                </div>
              )}
              
              {/* Soru Sayısı Ayarları */}
              <div className="form-group" style={{ 
                marginBottom: '1.5rem', 
                padding: '1.5rem', 
                backgroundColor: '#ffffff', 
                borderRadius: '12px', 
                border: '1px solid #e8ecef',
                boxShadow: '0 2px 8px rgba(0, 0, 0, 0.08)'
              }}>
                {/* Soru Havuzu ve Atanan Soru Bilgisi */}
                <div style={{ 
                  display: 'flex', 
                  justifyContent: 'space-between', 
                  alignItems: 'center', 
                  marginBottom: '1.5rem',
                  padding: '1rem 1.25rem',
                  backgroundColor: '#f8f9fa',
                  borderRadius: '10px',
                  border: '1px solid #e9ecef',
                  boxShadow: '0 1px 3px rgba(0, 0, 0, 0.05)'
                }}>
                  <div style={{ display: 'flex', flexDirection: 'column', gap: '0.35rem' }}>
                    <span style={{ fontSize: '0.875rem', color: '#6c757d', fontWeight: '500', letterSpacing: '0.3px' }}>Soru Havuzu</span>
                    <span style={{ fontSize: '1.25rem', color: '#212529', fontWeight: '700' }}>
                      {questions.length} soru
                    </span>
                  </div>
                  <div style={{ 
                    width: '1px', 
                    height: '50px', 
                    backgroundColor: '#dee2e6',
                    margin: '0 1rem'
                  }}></div>
                  <div style={{ display: 'flex', flexDirection: 'column', gap: '0.35rem' }}>
                    <span style={{ fontSize: '0.875rem', color: '#6c757d', fontWeight: '500', letterSpacing: '0.3px' }}>Sınavda Sorulacak</span>
                    <span style={{ 
                      fontSize: '1.25rem', 
                      color: questionCount ? '#28a745' : '#6c757d', 
                      fontWeight: '700' 
                    }}>
                      {questionCount ? `${questionCount} soru` : 'Tüm sorular'}
                    </span>
                  </div>
                </div>
                
                <label style={{ 
                  fontWeight: '600', 
                  marginBottom: '0.75rem', 
                  display: 'block',
                  fontSize: '1rem',
                  color: '#495057',
                  letterSpacing: '0.2px'
                }}>
                  Soru Sayısı (Sınavda Sorulacak)
                </label>
                <div style={{ display: 'flex', gap: '0.875rem', alignItems: 'flex-start' }}>
                  <input
                    type="text"
                    inputMode="numeric"
                    value={questionCountInput}
                    disabled={questions.length === 0}
                    onChange={(e) => {
                      const value = e.target.value;
                      // Sadece sayısal karakterlere izin ver
                      if (value === '' || /^\d+$/.test(value)) {
                        setQuestionCountInput(value);
                      }
                    }}
                    onBlur={(e) => {
                      const value = e.target.value;
                      if (value === '') {
                        setQuestionCount(null);
                        setQuestionCountInput('');
                      } else {
                        const num = parseInt(value, 10);
                        if (!isNaN(num) && num > 0 && num <= questions.length) {
                          setQuestionCount(num);
                          setQuestionCountInput(value);
                        } else {
                          // Geçersiz değer - eski değere geri dön
                          setQuestionCountInput(questionCount ? questionCount.toString() : '');
                        }
                      }
                      e.target.style.borderColor = '#dee2e6';
                      e.target.style.boxShadow = 'none';
                    }}
                    placeholder={questions.length === 0 ? "Önce soru yükleyiniz" : "Boş bırakılırsa tüm sorular gönderilir"}
                    style={{
                      flex: 1,
                      padding: '0.875rem 1rem',
                      border: '2px solid #dee2e6',
                      borderRadius: '8px',
                      fontSize: '1rem',
                      fontFamily: 'inherit',
                      fontWeight: '500',
                      color: questions.length === 0 ? '#6c757d' : '#495057',
                      backgroundColor: questions.length === 0 ? '#f8f9fa' : '#ffffff',
                      transition: 'all 0.2s ease',
                      outline: 'none',
                      cursor: questions.length === 0 ? 'not-allowed' : 'text'
                    }}
                    onFocus={(e) => {
                      if (questions.length > 0) {
                        e.target.style.borderColor = '#28a745';
                        e.target.style.boxShadow = '0 0 0 0.2rem rgba(40, 167, 69, 0.15)';
                      }
                    }}
                  />
                  <button
                    type="button"
                    disabled={questions.length === 0}
                    onClick={async () => {
                      if (selectedExam && questions.length > 0) {
                        // onBlur'dan önce değeri doğrula
                        const value = questionCountInput;
                        let finalCount = questionCount;
                        if (value === '') {
                          finalCount = null;
                        } else {
                          const num = parseInt(value, 10);
                          if (!isNaN(num) && num > 0 && num <= questions.length) {
                            finalCount = num;
                          }
                        }
                        const success = await saveQuestionCount(selectedExam.exam_id, finalCount);
                        if (success) {
                          setQuestionCount(finalCount);
                          setQuestionCountInput(finalCount ? finalCount.toString() : '');
                        }
                      }
                    }}
                    style={{
                      padding: '0.875rem 1.75rem',
                      backgroundColor: questions.length === 0 ? '#6c757d' : '#28a745',
                      color: 'white',
                      border: 'none',
                      borderRadius: '8px',
                      fontSize: '1rem',
                      fontWeight: '600',
                      cursor: questions.length === 0 ? 'not-allowed' : 'pointer',
                      transition: 'all 0.2s ease',
                      whiteSpace: 'nowrap',
                      boxShadow: questions.length === 0 ? 'none' : '0 2px 4px rgba(40, 167, 69, 0.2)',
                      opacity: questions.length === 0 ? 0.6 : 1
                    }}
                    onMouseOver={(e) => {
                      if (questions.length > 0) {
                        e.target.style.backgroundColor = '#218838';
                        e.target.style.boxShadow = '0 3px 6px rgba(40, 167, 69, 0.3)';
                        e.target.style.transform = 'translateY(-1px)';
                      }
                    }}
                    onMouseOut={(e) => {
                      if (questions.length > 0) {
                        e.target.style.backgroundColor = '#28a745';
                        e.target.style.boxShadow = '0 2px 4px rgba(40, 167, 69, 0.2)';
                        e.target.style.transform = 'translateY(0)';
                      }
                    }}
                  >
                    Kaydet
                  </button>
                </div>
                <small style={{ 
                  display: 'block', 
                  marginTop: '0.75rem', 
                  color: '#6c757d', 
                  fontSize: '0.875rem',
                  lineHeight: '1.5'
                }}>
                  Soru havuzundan rastgele seçilecek soru sayısını belirleyiniz. Bu alan boş bırakıldığında sınavda tüm sorular sorulacaktır. (Maksimum: {questions.length} soru)
                </small>
              </div>
              
              {/* Mevcut Sorular Listesi */}
              {(() => {
                const baseQuestions = questions || [];
                const filteredQuestions = getFilteredQuestions(baseQuestions, questionPoolFilter);
                const mandatoryCount = (questions || []).filter(q => q.is_mandatory).length;
                return (
              <div className="questions-section" style={{ 
                marginTop: '0', 
                paddingTop: '0',
                paddingBottom: '2rem',
                flex: 1,
                overflowY: 'visible',
                minHeight: 0,
                display: 'flex',
                flexDirection: 'column'
              }}>
                {/* Zorunlu Soru Sayacı */}
                <div style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  padding: '0.75rem 1rem',
                  background: mandatoryCount > 0 ? '#e8f5e9' : '#fff3e0',
                  border: `1px solid ${mandatoryCount > 0 ? '#4CAF50' : '#ff9800'}`,
                  borderRadius: '8px',
                  marginBottom: '1rem'
                }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem' }}>
                    <span style={{ fontSize: '1rem', fontWeight: '600' }}>●</span>
                    <span style={{ fontWeight: '600', color: '#333' }}>
                      Zorunlu Soru Sayısı: <strong style={{ color: mandatoryCount > 0 ? '#2e7d32' : '#e65100', fontSize: '1.1rem' }}>{mandatoryCount}</strong>
                    </span>
                  </div>
                  {mandatoryCount === 0 && (
                    <span style={{ fontSize: '0.85rem', color: '#e65100', fontStyle: 'italic' }}>
                      Henüz zorunlu soru seçilmedi
                    </span>
                  )}
                </div>

                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: '1rem', marginBottom: '1rem' }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '1rem', flexWrap: 'wrap' }}>
                    <h4 style={{ 
                      marginBottom: 0,
                      fontSize: '1.25rem',
                      fontWeight: '600',
                      color: '#212529',
                      flexShrink: 0
                    }}>Mevcut Sorular ({filteredQuestions.length}{questionPoolFilter !== 'all' ? ` / ${(questions || []).length}` : ''})</h4>
                  </div>
                  <div style={{ display: 'flex', gap: '0.5rem', alignItems: 'center' }}>
                    <span style={{ fontSize: '0.875rem', color: '#6c757d', marginRight: '0.25rem' }}>Filtre:</span>
                    <select
                      value={questionPoolFilter}
                      onChange={(e) => setQuestionPoolFilter(e.target.value)}
                      style={{
                        padding: '0.5rem 1rem',
                        borderRadius: '8px',
                        border: '1px solid #dee2e6',
                        background: '#fff',
                        color: '#212529',
                        cursor: 'pointer',
                        fontSize: '0.875rem',
                        fontWeight: '500',
                        minWidth: '180px'
                      }}
                      >
                      <option value="all">Tümü</option>
                      {getAvailableWeeks(questions).weeks.map(w => (
                        <option key={w} value={String(w)}>{w}. Hafta</option>
                      ))}
                      {getAvailableWeeks(questions).hasUnassigned && <option value="none">Hafta atanmamış</option>}
                    </select>
                  </div>
                </div>
                {filteredQuestions.length === 0 ? (
                  <p className="no-questions">
                    {questionPoolFilter === 'all' ? 'Henüz soru eklenmemiş' : questionPoolFilter === 'none' ? 'Hafta atanmamış soru yok' : `${questionPoolFilter}. haftaya ait soru yok`}
                  </p>
                ) : (
                  <div className="questions-list" style={{
                    width: '100%',
                    maxWidth: '100%',
                    boxSizing: 'border-box',
                    flex: 1,
                    display: 'flex',
                    flexDirection: 'column',
                    minHeight: 0
                  }}>
                    {filteredQuestions.map((q, index) => {
                      const isMandatory = Boolean(q.is_mandatory);
                      return (
                      <div key={q.id} className="question-item" style={{
                        wordWrap: 'break-word',
                        overflowWrap: 'break-word',
                        maxWidth: '100%'
                      }}>
                        <div className="question-header">
                          <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem', flexWrap: 'wrap' }}>
                            <strong>Soru {index + 1}</strong>
                            {q.created_at && (
                              <span style={{ fontSize: '0.8rem', color: '#6c757d', fontWeight: '400' }}>
                                {formatQuestionDate(q.created_at)}
                              </span>
                            )}
                          </div>
                          <div style={{ display: 'flex', gap: '0.5rem', alignItems: 'center' }}>
                            <button
                              className="star-button"
                              onClick={() => toggleMandatoryQuestion(q.id)}
                              title={isMandatory ? "Zorunlu soru - Tıklayarak kaldır" : "Zorunlu soru yap"}
                              style={{
                                padding: '0.5rem 1rem',
                                background: isMandatory ? '#4CAF50' : '#e9ecef',
                                color: isMandatory ? 'white' : '#333',
                                border: 'none',
                                borderRadius: '6px',
                                cursor: 'pointer',
                                fontSize: '0.85rem',
                                fontWeight: '500',
                                transition: 'none',
                                outline: 'none',
                                userSelect: 'none',
                                WebkitUserSelect: 'none',
                                MozUserSelect: 'none',
                                msUserSelect: 'none'
                              }}
                              onMouseDown={(e) => e.preventDefault()}
                              onMouseUp={(e) => e.preventDefault()}
                            >
                              {isMandatory ? 'Zorunlu Soruyu Kaldır' : 'Zorunlu Yap'}
                            </button>
                            <button
                              className="btn-delete"
                              onClick={() => deleteQuestion(q.id)}
                              title="Sil"
                              style={{
                                padding: '0.5rem 1rem',
                                background: '#dc3545',
                                color: 'white',
                                border: 'none',
                                borderRadius: '6px',
                                cursor: 'pointer',
                                fontSize: '0.85rem',
                                fontWeight: '500'
                              }}
                            >
                              Sil
                            </button>
                          </div>
                        </div>
                        <p className="question-text" style={{
                          wordWrap: 'break-word',
                          overflowWrap: 'break-word',
                          wordBreak: 'break-word',
                          whiteSpace: 'normal',
                          maxWidth: '100%'
                        }}>{q.question_text ? <MathText text={q.question_text} /> : <span style={{ color: '#6c757d', fontStyle: 'italic' }}>Soru metni girilmemiş</span>}</p>
                        {q.image_url && (() => {
                          const src = resolveMediaUrl(q.image_url);
                          return (
                            <div style={{ margin: '8px 0 12px', textAlign: 'center' }}>
                              <img
                                src={src}
                                alt="Soru görseli"
                                style={{ maxWidth: '100%', maxHeight: 320, borderRadius: 8, border: '1px solid #e2e8f0', cursor: 'zoom-in' }}
                                onClick={() => window.open(src, '_blank')}
                              />
                            </div>
                          );
                        })()}
                        {/* Test soruları için doğru cevap gösterimi (klasik sorulardaki gibi) */}
                        {q.question_type === 'MultipleChoice' && q.correct_answer && (
                          <div style={{
                            padding: '0.75rem',
                            marginBottom: '1rem',
                            backgroundColor: '#d4edda',
                            border: '2px solid #28a745',
                            borderRadius: '8px',
                            color: '#155724',
                            fontWeight: '500'
                          }}>
                            <strong>Doğru Cevap: </strong>{String(q.correct_answer).trim().toUpperCase()}
                          </div>
                        )}
                        {/* Klasik soru için doğru cevap gösterimi */}
                        {q.question_type === 'Classic' && q.correct_answer && (
                          <div style={{
                            padding: '0.75rem',
                            marginBottom: '1rem',
                            backgroundColor: '#d4edda',
                            border: '2px solid #28a745',
                            borderRadius: '8px',
                            color: '#155724',
                            fontWeight: '500'
                          }}>
                            <strong>Doğru Cevap: </strong><MathText text={String(q.correct_answer)} />
                          </div>
                        )}
                        {/* Şıkları sadece MultipleChoice sorular için göster (Classic sorularda şık olmaz) */}
                        {(q.question_type === 'MultipleChoice' || !q.question_type || q.question_type === '') && (
                        <div className="question-options">
                          {['A', 'B', 'C', 'D', 'E'].map(opt => {
                            const optionValue = q[`option_${opt.toLowerCase()}`];
                            if (!optionValue) return null;

                            // Doğru cevap kontrolü - harf veya tam metin formatını destekler
                            let isCorrect = false;
                            if (q.correct_answer) {
                              const correctAnswerStr = String(q.correct_answer).trim().toUpperCase();
                              if (correctAnswerStr.length === 1 && ['A','B','C','D','E'].includes(correctAnswerStr)) {
                                // Tek harf formatı: "A", "B", "C", "D", "E"
                                isCorrect = correctAnswerStr === opt;
                              } else if (correctAnswerStr.startsWith('OPTION_')) {
                                // "OPTION_A", "OPTION_B" formatı
                                const optionLetter = correctAnswerStr.replace('OPTION_', '').charAt(0);
                                isCorrect = optionLetter === opt;
                              } else {
                                // Tam metin formatı: şık metniyle karşılaştır
                                const optionValue = q[`option_${opt.toLowerCase()}`] || '';
                                isCorrect = optionValue.trim().toLowerCase() === String(q.correct_answer).trim().toLowerCase();
                              }
                            }
                            return (
                              <div key={opt} className={`option-item ${isCorrect ? 'correct' : ''}`} style={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: '0.5rem',
                                padding: '0.75rem',
                                borderRadius: '8px',
                                backgroundColor: isCorrect ? '#d4edda' : '#f8f9fa',
                                border: isCorrect ? '2px solid #28a745' : '1px solid #e9ecef',
                                transition: 'all 0.2s ease',
                                boxShadow: isCorrect ? '0 2px 4px rgba(40, 167, 69, 0.2)' : 'none',
                                wordWrap: 'break-word',
                                overflowWrap: 'break-word'
                              }}>
                                <strong style={{
                                  padding: '0.375rem 0.875rem',
                                  borderRadius: '6px',
                                  background: isCorrect ? '#28a745' : '#e9ecef',
                                  color: isCorrect ? 'white' : '#333',
                                  fontSize: '0.9rem',
                                  fontWeight: '600',
                                  minWidth: '2.5rem',
                                  textAlign: 'center',
                                  flexShrink: 0
                                }}>{opt}</strong>
                                <span style={{
                                  flex: 1,
                                  fontWeight: isCorrect ? '600' : '400',
                                  color: isCorrect ? '#155724' : '#495057',
                                  wordWrap: 'break-word',
                                  overflowWrap: 'break-word',
                                  wordBreak: 'break-word'
                                }}>
                                  <MathText text={optionValue} />
                                  {isCorrect && (
                                    <span style={{
                                      marginLeft: '0.5rem',
                                      color: '#28a745',
                                      fontSize: '0.85rem',
                                      fontWeight: '600',
                                      whiteSpace: 'nowrap'
                                    }}>✓ Doğru Cevap</span>
                                  )}
                                </span>
                              </div>
                            );
                          })}
                        </div>
                        )}
                      </div>
                    );
                    })}
                  </div>
                )}
              </div>
              ); })()}
              </div>
            </div>
          </div>
        </div>
      )}
      
      {/* Sınav Önizleme Modal - Kaldırıldı, sayfa olarak gösteriliyor */}
      {false && previewExam && (
        <div className="modal-overlay" onClick={() => {
          setCurrentPage(null);
          setPageData(null);
          setPreviewExam(null);
        }}>
          <div className="modal-content preview-modal" onClick={(e) => e.stopPropagation()} style={{ maxWidth: '900px', maxHeight: 'calc(100vh - 2rem)', overflowY: 'auto' }}>
            <div className="modal-header" style={{ background: BUTTON_COLORS.primaryDark, color: 'white', padding: '1.5rem', borderRadius: '12px 12px 0 0' }}>
              <h3 style={{ margin: 0, fontSize: '1.5rem', fontWeight: '700' }}>{previewExam.title} - Önizleme</h3>
              <button className="modal-close" onClick={() => {
                setCurrentPage(null);
                setPageData(null);
                setPreviewExam(null);
              }} style={{ color: 'white', fontSize: '1.5rem' }}>×</button>
            </div>
            
            <div className="modal-body" style={{ padding: '2rem' }}>
              {loadingPreview ? (
                <div style={{ textAlign: 'center', padding: '3rem' }}>
                  <p>Yükleniyor...</p>
                </div>
              ) : (
                <>
                  {/* Sınav Bilgileri */}
                  <div className="preview-section">
                    <h4 style={{ marginTop: 0, marginBottom: '1rem', color: '#1A202C', fontSize: '1.2rem', fontWeight: '600', borderBottom: '2px solid #1A202C', paddingBottom: '0.5rem' }}>
                      Sınav Bilgileri
                    </h4>
                    <div className="preview-grid" style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))', gap: '1rem', marginBottom: '1.5rem' }}>
                      <div className="preview-item">
                        <span className="preview-label">Ders:</span>
                        <span className="preview-value">{previewExam.course_name || '-'}</span>
                      </div>
                      <div className="preview-item">
                        <span className="preview-label">Durum:</span>
                        <span className="preview-value">{getStatusBadge(previewExam.status)}</span>
                      </div>
                      <div className="preview-item">
                        <span className="preview-label">Başlangıç:</span>
                        <span className="preview-value">{formatDate(previewExam.start_at)}</span>
                      </div>
                      <div className="preview-item">
                        <span className="preview-label">Bitiş:</span>
                        <span className="preview-value">{formatDate(previewExam.end_at)}</span>
                      </div>
                      {previewExam.duration_minutes && (
                        <div className="preview-item">
                          <span className="preview-label">Süre:</span>
                          <span className="preview-value">{previewExam.duration_minutes} dakika</span>
                        </div>
                      )}
                      <div className="preview-item">
                        <span className="preview-label">Oluşturulma:</span>
                        <span className="preview-value">{formatDate(previewExam.created_at)}</span>
                      </div>
                    </div>
                  </div>
                  
                  {/* Sınav Ayarları */}
                  {previewSettings && (
                    <div className="preview-section" style={{ marginTop: '2rem', paddingTop: '2rem', borderTop: '2px solid #e9ecef' }}>
                      <h4 style={{ marginTop: 0, marginBottom: '1rem', color: '#1A202C', fontSize: '1.2rem', fontWeight: '600', borderBottom: '2px solid #1A202C', paddingBottom: '0.5rem' }}>
                        Sınav Ayarları
                      </h4>
                      <div className="preview-grid" style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))', gap: '1rem' }}>
                        <div className="preview-item">
                          <span className="preview-label">Giriş Hakkı:</span>
                          <span className="preview-value">{previewSettings.max_attempts || 1} kez</span>
                        </div>
                        <div className="preview-item">
                          <span className="preview-label">Karıştırma:</span>
                          <span className="preview-value">
                            {previewSettings.shuffle_type === 'none' ? 'Karıştırma yok' :
                             previewSettings.shuffle_type === 'questions' ? 'Sadece soruları karıştır' :
                             previewSettings.shuffle_type === 'choices' ? 'Sadece şıkları karıştır' :
                             previewSettings.shuffle_type === 'both' ? 'Hem soruları hem şıkları karıştır' : 'Bilinmiyor'}
                          </span>
                        </div>
                        <div className="preview-item">
                          <span className="preview-label">Otomatik Kaydet:</span>
                          <span className="preview-value">Aktif</span>
                        </div>
                      </div>
                    </div>
                  )}
                  
                  {/* Onay Mesajları */}
                  {(previewExam.entrance_confirmation || previewExam.finish_confirmation) && (
                    <div className="preview-section" style={{ marginTop: '2rem', paddingTop: '2rem', borderTop: '2px solid #e9ecef' }}>
                      <h4 style={{ marginTop: 0, marginBottom: '1rem', color: '#1A202C', fontSize: '1.2rem', fontWeight: '600', borderBottom: '2px solid #1A202C', paddingBottom: '0.5rem' }}>
                        Onay Mesajları
                      </h4>
                      {previewExam.entrance_confirmation && (
                        <div style={{ marginBottom: '1rem', padding: '1rem', background: '#e8f5e9', borderRadius: '8px', borderLeft: '4px solid #4CAF50' }}>
                          <strong style={{ color: '#2e7d32', display: 'block', marginBottom: '0.5rem' }}>Giriş Onayı:</strong>
                          <p style={{ margin: 0, color: '#333', lineHeight: '1.6' }}>{previewExam.entrance_confirmation}</p>
                        </div>
                      )}
                      {previewExam.finish_confirmation && (
                        <div style={{ padding: '1rem', background: '#fff3e0', borderRadius: '8px', borderLeft: '4px solid #ff9800' }}>
                          <strong style={{ color: '#e65100', display: 'block', marginBottom: '0.5rem' }}>Çıkış Onayı:</strong>
                          <p style={{ margin: 0, color: '#333', lineHeight: '1.6' }}>{previewExam.finish_confirmation}</p>
                        </div>
                      )}
                    </div>
                  )}
                  
                  {/* Sorular */}
                  <div className="preview-section" style={{ marginTop: '2rem', paddingTop: '2rem', borderTop: '2px solid #e9ecef' }}>
                    <h4 style={{ marginTop: 0, marginBottom: '1rem', color: '#1A202C', fontSize: '1.2rem', fontWeight: '600', borderBottom: '2px solid #1A202C', paddingBottom: '0.5rem' }}>
                      Sorular ({previewQuestions.length})
                    </h4>
                    {previewQuestions.length === 0 ? (
                      <div style={{ textAlign: 'center', padding: '2rem', color: '#999' }}>
                        <p>Henüz soru eklenmemiş</p>
                      </div>
                    ) : (
                      <div className="preview-questions-list" style={{ display: 'flex', flexDirection: 'column', gap: '1.5rem' }}>
                        {previewQuestions.map((q, index) => (
                          <div key={q.id} className="preview-question-item" style={{ 
                            padding: '1.5rem', 
                            background: '#f8f9fa', 
                            borderRadius: '12px', 
                            border: '1px solid #e9ecef',
                            boxShadow: '0 2px 4px rgba(0,0,0,0.05)'
                          }}>
                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '1rem' }}>
                              <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem' }}>
                                <strong style={{ fontSize: '1.1rem', color: '#333' }}>Soru {index + 1}</strong>
                                {q.is_mandatory && (
                                  <span style={{ 
                                    padding: '0.25rem 0.75rem', 
                                    borderRadius: '12px', 
                                    fontSize: '0.85rem',
                                    background: '#ffebee',
                                    color: '#c62828',
                                    fontWeight: '600'
                                  }}>
                                    Zorunlu
                                  </span>
                                )}
                              </div>
                              {q.correct_answer && (
                                <span style={{ 
                                  padding: '0.5rem 1rem', 
                                  borderRadius: '8px', 
                                  background: '#4CAF50', 
                                  color: 'white', 
                                  fontWeight: '600',
                                  fontSize: '0.9rem'
                                }}>
                                  Doğru: {q.correct_answer}
                                </span>
                              )}
                            </div>
                            <p style={{ margin: '0 0 1rem 0', fontSize: '1rem', lineHeight: '1.6', color: '#333', fontWeight: '500' }}>
                              {q.question_text ? <MathText text={q.question_text} /> : <span style={{ color: '#6c757d', fontStyle: 'italic' }}>Soru metni girilmemiş</span>}
                            </p>
                            <div style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
                              {['A', 'B', 'C', 'D', 'E'].map(opt => {
                                const optionValue = q[`option_${opt.toLowerCase()}`];
                                const isCorrect = q.correct_answer === opt;
                                return optionValue ? (
                                  <div key={opt} style={{ 
                                    padding: '0.75rem 1rem', 
                                    borderRadius: '8px', 
                                    background: isCorrect ? '#e8f5e9' : 'white',
                                    border: `2px solid ${isCorrect ? '#4CAF50' : '#e0e0e0'}`,
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '0.5rem'
                                  }}>
                                    <strong style={{ 
                                      color: isCorrect ? '#4CAF50' : '#666',
                                      minWidth: '24px',
                                      fontSize: '1rem'
                                    }}>{opt}:</strong>
                                    <span style={{ color: '#333', flex: 1 }}>{optionValue}</span>
                                    {isCorrect && (
                                      <span style={{ color: '#4CAF50', fontWeight: '600' }}>✓</span>
                                    )}
                                  </div>
                                ) : null;
                              })}
                            </div>
                          </div>
                        ))}
                      </div>
                    )}
                  </div>
                </>
              )}
            </div>
            
            <div className="modal-footer" style={{ padding: '1.5rem', borderTop: '1px solid #e9ecef', display: 'flex', justifyContent: 'flex-end' }}>
              <button 
                className="btn btn-secondary" 
                onClick={() => {
                  setCurrentPage(null);
                  setPageData(null);
                  setPreviewExam(null);
                }}
                style={{ padding: '0.75rem 2rem', fontSize: '1rem' }}
              >
                Kapat
              </button>
            </div>
          </div>
        </div>
      )}
      
      {/* Status Güncelleme Onay Modalı - Kaldırıldı, sayfa olarak gösteriliyor */}
      {false && (
        <div className="modal-overlay" style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          background: 'rgba(0, 0, 0, 0.5)',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          zIndex: 1000
        }}>
          <div className="modal-content" style={{
            background: 'white',
            borderRadius: '12px',
            padding: '2rem',
            maxWidth: '500px',
            width: '90%',
            boxShadow: '0 4px 20px rgba(0,0,0,0.15)'
          }}>
            <h3 style={{ marginTop: 0, marginBottom: '1rem', color: '#333' }}>
              {pendingStatusAction === 'publish' ? 'Sınavı Yayınla' : 'Sınavı Taslağa Al'}
            </h3>
            <p style={{ marginBottom: '1.5rem', color: '#666', lineHeight: '1.6' }}>
              {pendingStatusAction === 'publish' 
                ? 'Bu sınavı yayınlamak istediğinizden emin misiniz? Yayınlandıktan sonra sınav düzenlenemez ve sorular yönetilemez.'
                : 'Bu sınavı taslağa almak istediğinizden emin misiniz? Taslağa alındıktan sonra sınav düzenlenebilir ve sorular yönetilebilir.'}
            </p>
            <div style={{ display: 'flex', gap: '1rem', justifyContent: 'flex-end' }}>
              <button
                onClick={cancelStatusChange}
                disabled={updatingStatus}
                style={{
                  padding: '0.75rem 1.5rem',
                  background: '#e9ecef',
                  color: '#333',
                  border: 'none',
                  borderRadius: '8px',
                  cursor: updatingStatus ? 'not-allowed' : 'pointer',
                  fontSize: '0.95rem'
                }}
              >
                İptal
              </button>
              <button
                onClick={confirmStatusChange}
                disabled={updatingStatus}
                style={{
                  padding: '0.75rem 1.5rem',
                  background: pendingStatusAction === 'publish' ? '#4CAF50' : '#1A202C',
                  color: 'white',
                  border: 'none',
                  borderRadius: '8px',
                  cursor: updatingStatus ? 'not-allowed' : 'pointer',
                  fontSize: '0.95rem',
                  opacity: updatingStatus ? 0.6 : 1
                }}
              >
                {updatingStatus ? 'Güncelleniyor...' : (pendingStatusAction === 'publish' ? 'Yayınla' : 'Taslağa Al')}
              </button>
            </div>
          </div>
        </div>
      )}
      
      {/* Silme Onay Modalı - Kaldırıldı, sayfa olarak gösteriliyor */}
      {false && (
        <div className="modal-overlay" style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          background: 'rgba(0, 0, 0, 0.5)',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          zIndex: 1000
        }} onClick={cancelDelete}>
          <div className="modal-content" style={{
            background: 'white',
            borderRadius: '12px',
            padding: '0',
            maxWidth: '500px',
            width: '90%',
            boxShadow: '0 4px 20px rgba(0,0,0,0.15)',
            overflow: 'hidden'
          }} onClick={(e) => e.stopPropagation()}>
            {/* Header */}
            <div style={{
              background: '#1A202C',
              color: 'white',
              padding: '1.5rem',
              borderBottom: '3px solid #dc3545'
            }}>
              <h3 style={{ 
                margin: 0, 
                fontSize: '1.5rem', 
                fontWeight: '600',
                color: 'white'
              }}>
                Sınavı Sil
              </h3>
            </div>
            
            {/* Body */}
            <div style={{ padding: '2rem' }}>
              <p style={{ 
                marginBottom: '1rem', 
                color: '#333', 
                lineHeight: '1.6',
                fontSize: '1rem'
              }}>
                <strong style={{ color: '#1A202C' }}>"{pendingDeleteExamTitle}"</strong> sınavını silmek istediğinizden emin misiniz?
              </p>
              <div style={{
                padding: '1rem',
                background: '#fff5f5',
                borderRadius: '8px',
                borderLeft: '4px solid #dc3545',
                marginBottom: '1.5rem'
              }}>
                <p style={{ 
                  margin: 0, 
                  color: '#721c24', 
                  lineHeight: '1.6',
                  fontSize: '0.9rem'
                }}>
                  Bu işlem geri alınamaz. Sınav silindikten sonra görünmeyecektir.
                </p>
              </div>
              
              {/* Butonlar */}
              <div style={{ 
                display: 'flex', 
                gap: '1rem', 
                justifyContent: 'flex-end',
                marginTop: '1.5rem'
              }}>
                <button
                  onClick={cancelDelete}
                  disabled={deleting}
                  style={{
                    padding: '0.75rem 1.5rem',
                    background: '#e9ecef',
                    color: '#333',
                    border: 'none',
                    borderRadius: '8px',
                    cursor: deleting ? 'not-allowed' : 'pointer',
                    fontSize: '0.95rem',
                    fontWeight: '500',
                    transition: 'all 0.2s'
                  }}
                  onMouseEnter={(e) => {
                    if (!deleting) e.target.style.background = '#dee2e6';
                  }}
                  onMouseLeave={(e) => {
                    if (!deleting) e.target.style.background = '#e9ecef';
                  }}
                >
                  İptal
                </button>
                <button
                  onClick={confirmDelete}
                  disabled={deleting}
                  style={{
                    padding: '0.75rem 1.5rem',
                    background: '#dc3545',
                    color: 'white',
                    border: 'none',
                    borderRadius: '8px',
                    cursor: deleting ? 'not-allowed' : 'pointer',
                    fontSize: '0.95rem',
                    fontWeight: '500',
                    opacity: deleting ? 0.6 : 1,
                    transition: 'all 0.2s'
                  }}
                  onMouseEnter={(e) => {
                    if (!deleting) e.target.style.background = '#c82333';
                  }}
                  onMouseLeave={(e) => {
                    if (!deleting) e.target.style.background = '#dc3545';
                  }}
                >
                  {deleting ? 'Siliniyor...' : 'Sil'}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
      
      {/* Ek Süre Modal - Kaldırıldı, sayfa olarak gösteriliyor */}
      {false && selectedExamForExtend && (
        <div 
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background: 'rgba(0, 0, 0, 0.5)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 1000
          }}
          onClick={() => {
            setCurrentPage(null);
            setPageData(null);
            setSelectedExamForExtend(null);
            setExamStudents([]);
          }}
        >
          <div 
            className="modal-content" 
            style={{
              background: 'white',
              borderRadius: '12px',
              padding: '0',
              maxWidth: '800px',
              width: '90%',
              maxHeight: '90vh',
              boxShadow: '0 4px 20px rgba(0,0,0,0.15)',
              overflow: 'hidden',
              display: 'flex',
              flexDirection: 'column'
            }} 
            onClick={(e) => e.stopPropagation()}
          >
            {/* Header */}
            <div style={{
              background: '#4CAF50',
              color: 'white',
              padding: '1.5rem',
              borderBottom: '3px solid #3d8b40'
            }}>
              <h3 style={{ 
                margin: 0, 
                fontSize: '1.5rem', 
                fontWeight: '600',
                color: 'white'
              }}>
                Ek Süre Ver - {selectedExamForExtend.title}
              </h3>
            </div>
            
            {/* Body */}
            <div style={{ 
              padding: '1.5rem',
              overflowY: 'auto',
              flex: 1
            }}>
              {loadingStudents ? (
                <div style={{ textAlign: 'center', padding: '2rem' }}>
                  <p>Öğrenciler yükleniyor...</p>
                </div>
              ) : examStudents.length === 0 ? (
                <div style={{ textAlign: 'center', padding: '2rem' }}>
                  <p>Bu sınavı alan öğrenci bulunamadı.</p>
                </div>
              ) : (
                <div style={{ overflowX: 'auto' }}>
                  <table style={{
                    width: '100%',
                    borderCollapse: 'collapse',
                    fontSize: '0.95rem'
                  }}>
                    <thead>
                      <tr style={{
                        background: '#f8f9fa',
                        borderBottom: '2px solid #dee2e6'
                      }}>
                        <th style={{
                          padding: '0.75rem',
                          textAlign: 'left',
                          fontWeight: '600',
                          color: '#333'
                        }}>Öğrenci No</th>
                        <th style={{
                          padding: '0.75rem',
                          textAlign: 'left',
                          fontWeight: '600',
                          color: '#333'
                        }}>Ad Soyad</th>
                        <th style={{
                          padding: '0.75rem',
                          textAlign: 'left',
                          fontWeight: '600',
                          color: '#333'
                        }}>Giriş Hakları</th>
                        <th style={{
                          padding: '0.75rem',
                          textAlign: 'left',
                          fontWeight: '600',
                          color: '#333'
                        }}>İlk Giriş Zamanı</th>
                        <th style={{
                          padding: '0.75rem',
                          textAlign: 'left',
                          fontWeight: '600',
                          color: '#333'
                        }}>Ek Süre</th>
                      </tr>
                    </thead>
                    <tbody>
                      {examStudents.map((student) => {
                        // Gerçek attempt_count ve max_attempts değerlerini kullan
                        const attemptCount = student.attempt_count || 0;
                        const maxAttempts = student.max_attempts || (selectedExamForExtend?.max_attempts || 1);
                        
                        // Format first entry time
                        const formatFirstEntryTime = (startedAt) => {
                          if (!startedAt) return '-';
                          try {
                            const date = new Date(startedAt);
                            return date.toLocaleString('tr-TR', {
                              day: '2-digit',
                              month: '2-digit',
                              year: 'numeric',
                              hour: '2-digit',
                              minute: '2-digit'
                            });
                          } catch (e) {
                            return '-';
                          }
                        };
                        
                        // Öğrenciye +1 hak ver fonksiyonu
                        const grantAttemptToStudent = async () => {
                          if (!student.attempt_id) {
                            setToastMessage('Öğrencinin henüz sınava girişi yok.');
                            setToastType('error');
                            setTimeout(() => setToastMessage(''), 3000);
                            return;
                          }
                          
                          try {
                            const response = await apiFetch(
                              `/instructor/exams/${selectedExamForExtend.exam_id}/attempts/${student.attempt_id}/grant-attempt`,
                              {
                                method: 'PATCH'
                              }
                            );
                            
                            const data = await response.json();
                            
                            if (data.success) {
                              setToastMessage('Öğrenciye 1 hak verildi');
                              setToastType('success');
                              setTimeout(() => setToastMessage(''), 3000);
                              // Listeyi yenile
                              await fetchExamStudents(selectedExamForExtend.exam_id);
                            } else {
                              setToastMessage(`Hata: ${data.message || 'Hak verilemedi'}`);
                              setToastType('error');
                              setTimeout(() => setToastMessage(''), 3000);
                            }
                          } catch (error) {
                            console.error('Hak verme hatası:', error);
                            setToastMessage('Hak verilirken bir hata oluştu');
                            setToastType('error');
                            setTimeout(() => setToastMessage(''), 3000);
                          }
                        };
                        
                        return (
                          <tr 
                            key={student.student_id}
                            style={{
                              borderBottom: '1px solid #e9ecef'
                            }}
                          >
                            <td style={{ padding: '0.75rem' }}>
                              {student.student_number}
                            </td>
                            <td style={{ padding: '0.75rem' }}>
                              {`${student.first_name || ''} ${student.last_name || ''}`.trim() || '-'}
                            </td>
                            <td style={{ padding: '0.75rem' }}>
                              <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                                <span style={{ fontSize: '0.9rem' }}>
                                  {attemptCount}/{maxAttempts}
                                </span>
                                <button
                                  type="button"
                                  onClick={grantAttemptToStudent}
                                  style={{
                                    padding: '0.5rem 1rem',
                                    fontSize: '0.85rem',
                                    background: '#1A202C',
                                    color: 'white',
                                    border: 'none',
                                    borderRadius: '6px',
                                    cursor: 'pointer',
                                    fontWeight: '600',
                                    whiteSpace: 'nowrap',
                                    minWidth: '88px',
                                    textAlign: 'center'
                                  }}
                                  onMouseEnter={(e) => {
                                    e.target.style.background = '#111827';
                                  }}
                                  onMouseLeave={(e) => {
                                    e.target.style.background = '#1A202C';
                                  }}
                                >
                                  +1 hak ver
                                </button>
                              </div>
                            </td>
                            <td style={{ padding: '0.75rem' }}>
                              {formatFirstEntryTime(student.started_at)}
                            </td>
                            <td style={{ padding: '0.75rem' }}>
                              {student.attempt_status === 'InProgress' ? (
                                <div style={{ display: 'flex', gap: '0.5rem' }}>
                                  <button
                                    onClick={() => extendTime(student.attempt_id, 5)}
                                    style={{
                                      padding: '0.5rem 1rem',
                                      fontSize: '0.85rem',
                                      background: '#4CAF50',
                                      color: 'white',
                                      border: 'none',
                                      borderRadius: '6px',
                                      cursor: 'pointer',
                                    fontWeight: '600',
                                    minWidth: '88px',
                                    textAlign: 'center',
                                    lineHeight: '1.1'
                                    }}
                                    onMouseEnter={(e) => {
                                      e.target.style.background = '#3d8b40';
                                    }}
                                    onMouseLeave={(e) => {
                                      e.target.style.background = '#4CAF50';
                                    }}
                                  >
                                    +5 dk
                                  </button>
                                  <button
                                    onClick={() => extendTime(student.attempt_id, 10)}
                                    style={{
                                      padding: '0.5rem 1rem',
                                      fontSize: '0.85rem',
                                      background: '#4CAF50',
                                      color: 'white',
                                      border: 'none',
                                      borderRadius: '6px',
                                      cursor: 'pointer',
                                    fontWeight: '600',
                                    minWidth: '88px',
                                    textAlign: 'center',
                                    lineHeight: '1.1'
                                    }}
                                    onMouseEnter={(e) => {
                                      e.target.style.background = '#3d8b40';
                                    }}
                                    onMouseLeave={(e) => {
                                      e.target.style.background = '#4CAF50';
                                    }}
                                  >
                                    +10 dk
                                  </button>
                                </div>
                              ) : (
                                <span style={{ color: '#999' }}>-</span>
                              )}
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
              )}
            </div>
            
            {/* Footer */}
            <div style={{
              padding: '1rem 1.5rem',
              borderTop: '1px solid #e9ecef',
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center'
            }}>
              <div style={{ display: 'flex', gap: '0.75rem' }}>
                <button
                  onClick={async () => {
                    try {
                      const response = await apiFetch(
                        `/instructor/exams/${selectedExamForExtend.exam_id}/grant-attempt-all`,
                        {
                          method: 'PATCH'
                        }
                      );
                      
                      const data = await response.json();
                      
                      if (data.success) {
                        setToastMessage(data.message || 'Tüm öğrencilere 1 hak verildi');
                        setToastType('success');
                        setTimeout(() => setToastMessage(''), 3000);
                        // Listeyi yenile
                        await fetchExamStudents(selectedExamForExtend.exam_id);
                      } else {
                        setToastMessage(`Hata: ${data.message || 'Hak verilemedi'}`);
                        setToastType('error');
                        setTimeout(() => setToastMessage(''), 3000);
                      }
                    } catch (error) {
                      console.error('Herkese hak verme hatası:', error);
                      setToastMessage('Hak verilirken bir hata oluştu');
                      setToastType('error');
                      setTimeout(() => setToastMessage(''), 3000);
                    }
                  }}
                  style={{
                    padding: '0.75rem 1.5rem',
                    background: '#1A202C',
                    color: 'white',
                    border: 'none',
                    borderRadius: '8px',
                    cursor: 'pointer',
                    fontSize: '0.95rem',
                    fontWeight: '500'
                  }}
                  onMouseEnter={(e) => {
                    e.target.style.background = '#111827';
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.background = '#1A202C';
                  }}
                >
                  Herkese 1 hak ver
                </button>
                <button
                  onClick={() => {
                    alert('Herkese 10 dakika ekstra süre verme özelliği yakında eklenecek (placeholder).');
                  }}
                  style={{
                    padding: '0.75rem 1.5rem',
                    background: '#4CAF50',
                    color: 'white',
                    border: 'none',
                    borderRadius: '8px',
                    cursor: 'pointer',
                    fontSize: '0.95rem',
                    fontWeight: '500'
                  }}
                  onMouseEnter={(e) => {
                    e.target.style.background = '#3d8b40';
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.background = '#4CAF50';
                  }}
                >
                  Herkese 10 dakika ekstra süre ver
                </button>
              </div>
              <button
                onClick={() => {
                  setCurrentPage(null);
                  setPageData(null);
                  setSelectedExamForExtend(null);
                  setExamStudents([]);
                }}
                style={{
                  padding: '0.75rem 1.5rem',
                  background: '#6c757d',
                  color: 'white',
                  border: 'none',
                  borderRadius: '8px',
                  cursor: 'pointer',
                  fontSize: '0.95rem',
                  fontWeight: '500'
                }}
                onMouseEnter={(e) => {
                  e.target.style.background = '#5a6268';
                }}
                onMouseLeave={(e) => {
                  e.target.style.background = '#6c757d';
                }}
              >
                Kapat
              </button>
            </div>
          </div>
        </div>
      )}
      
      {/* Status Onay Modal */}
      {showStatusConfirmModal && (
        <div className="modal-overlay" onClick={cancelStatusChange}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()} style={{ maxWidth: '500px' }}>
            <div className="modal-header">
              <h3>Sınav Durumu Güncelleme</h3>
              <button className="modal-close" onClick={cancelStatusChange}>×</button>
            </div>
            <div className="modal-body">
              <p style={{ fontSize: '1rem', lineHeight: '1.6', marginBottom: '1.5rem' }}>
                Bu sınavı <strong>{pendingStatusAction === 'publish' ? 'Yayınla' : 'Taslağa Çevir'}</strong> olarak işaretlemek istediğinize emin misiniz?
              </p>
              <div className="form-actions" style={{ justifyContent: 'flex-end', gap: '0.75rem' }}>
                <button className="btn btn-secondary" onClick={cancelStatusChange}>
                  İptal
                </button>
                <button 
                  className="btn btn-primary" 
                  onClick={confirmStatusChange}
                  disabled={updatingStatus}
                  style={{
                    background: pendingStatusAction === 'publish' ? BUTTON_COLORS.success : BUTTON_COLORS.primaryDark,
                    color: 'white',
                    border: 'none'
                  }}
                >
                  {updatingStatus ? 'Güncelleniyor...' : (pendingStatusAction === 'publish' ? 'Yayınla' : 'Taslağa Çevir')}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Silme Onay Modal */}
      {showDeleteConfirmModal && (
        <div className="modal-overlay" onClick={cancelDelete}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()} style={{ maxWidth: '500px' }}>
            <div className="modal-header">
              <h3>Sınavı Sil</h3>
              <button className="modal-close" onClick={cancelDelete}>×</button>
            </div>
            <div className="modal-body">
              <p style={{ fontSize: '1rem', lineHeight: '1.6', marginBottom: '1.5rem' }}>
                <strong>{pendingDeleteExamTitle}</strong> adlı sınavı silmek istediğinize emin misiniz?
                Bu işlem geri alınamaz.
              </p>
              <div className="form-actions" style={{ justifyContent: 'flex-end', gap: '0.75rem' }}>
                <button className="btn btn-secondary" onClick={cancelDelete}>
                  İptal
                </button>
                <button 
                  className="btn btn-danger" 
                  onClick={confirmDelete}
                  disabled={deleting}
                  style={{
                    background: BUTTON_COLORS.danger,
                    color: 'white',
                    border: 'none'
                  }}
                >
                  {deleting ? 'Siliniyor...' : 'Sil'}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Sonuçları Yayınlama Onay Modal */}
      {showPublishResultsModal && publishResultsExam && (
        <div className="modal-overlay" onClick={cancelPublishResults}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()} style={{ maxWidth: '500px' }}>
            <div className="modal-header">
              <h3>Sonuçları Yayınla</h3>
              <button className="modal-close" onClick={cancelPublishResults}>×</button>
            </div>
            <div className="modal-body">
              <p style={{ fontSize: '1rem', lineHeight: '1.6', marginBottom: '1.5rem' }}>
                <strong>{publishResultsExam.title}</strong> adlı sınavın sonuçlarını yayınlamak istediğinize emin misiniz?
                Bu işlem geri alınamaz.
              </p>
              <div className="form-actions" style={{ justifyContent: 'flex-end', gap: '0.75rem' }}>
                <button className="btn btn-secondary" onClick={cancelPublishResults}>
                  İptal
                </button>
                <button 
                  className="btn btn-primary" 
                  onClick={publishResults}
                  disabled={publishing}
                  style={{
                    background: BUTTON_COLORS.success,
                    color: 'white',
                    border: 'none'
                  }}
                >
                  {publishing ? 'Yayınlanıyor...' : 'Yayınla'}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Toast Notification */}
      {toastMessage && (
        <div
          style={{
            position: 'fixed',
            top: '20px',
            right: '20px',
            background: toastType === 'success' ? '#4CAF50' : '#dc3545',
            color: 'white',
            padding: '1rem 1.5rem',
            borderRadius: '8px',
            boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
            zIndex: 10000,
            display: 'flex',
            alignItems: 'center',
            gap: '0.75rem',
            fontSize: '0.95rem',
            fontWeight: '500',
            animation: 'slideIn 0.3s ease-out',
            maxWidth: '400px',
            wordWrap: 'break-word'
          }}
        >
          <span>{toastType === 'success' ? '✓' : '✗'}</span>
          <span>{toastMessage}</span>
        </div>
      )}
    </div>
  );
}

export default InstructorExams;
